import React, {useEffect, useMemo, useState, useRef} from 'react';
import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';
import {
   Avatar,
   Typography,
   Button,
   List,
   Modal,
   Menu,
   MenuItem,
   Grid,
   Box,
   FormControl,
   Select,
   IconButton,
} from '@mui/material';
import {IoSend} from 'react-icons/io5'
import {span} from 'react-icons/tb'
import Linkify from 'linkify-react';
import {TbPhoto, TbVideo, TbMicrophone, TbFile, TbLink, TbCalendar, TbPlus} from "react-icons/tb";
import {FaFileImage, FaFileVideo, FaFileAudio, FaFilePdf, FaFile, FaLink} from "react-icons/fa6";
import {FaRegCalendarAlt, FaCalendar} from 'react-icons/fa';
import {DateTimePicker} from 'react-rainbow-components';
import {ImEmbed2} from "react-icons/im";
import {BsFillPinAngleFill} from 'react-icons/bs';
import ConfettiExplosion from 'react-confetti-explosion';
import Fade from "react-reveal/Fade";
import '../../../css/Community.css';
import TextareaAutosize from 'react-textarea-autosize';

import {HiOutlineDotsHorizontal} from 'react-icons/hi';
import {IoClose} from "react-icons/io5";
import {FiChevronDown, FiChevronUp} from 'react-icons/fi';
import {styled} from "@mui/material/styles";
import Tooltip, {tooltipClasses} from "@mui/material/Tooltip";
import VideoJS from '../../common/VideoJS';
import PDFSwiper from "../../Content/ContentSubComponents/PDFs/PDFSwiper";
import TextField from "@mui/material/TextField";
import ReactAudioPlayer from "react-audio-player";
import SnackbarAlert from '../../common/SnackbarAlert';
import {RiFullscreenFill} from 'react-icons/ri';
import TruncateWithEllipsis from '../../common/common/TruncateWithEllipsis';
import { BiSolidBadgeCheck } from "react-icons/bi";
import ZoomImage from '../../../media/site_media/platform-icons/zoom.png';
import MicrosoftTeams from '../../../media/site_media/platform-icons/microsoft-teams.png';
import GoogleMeetImage from '../../../media/site_media/platform-icons/google-meet.png';
import GoogleSheetsImage from '../../../media/site_media/platform-icons/google-sheets.png';
import GoogleDocsImage from '../../../media/site_media/platform-icons/google-docs.png';
import SnackbarAlertClick from '../../common/SnackbarAlertClick';
import TextEditor from '../../common/TextEditorRebranded';
import MantineEditorWrapper from '../../common/MantineRichTextEditor/MantineEditorWrapper';
import MantineRichTextEditor from '../../common/MantineRichTextEditor/MantineRichTextEditor';
import { decode } from 'html-entities';
import { normalizeExternalHref } from '../../../utils/normalizeExternalHref';
const paths = require('../../../paths.json');

const DarkTooltip = styled(({ className, ...props }) => (
   <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
   [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#222222 !important',
      color: '#ffffff',
      boxShadow: theme.shadows[1],
      fontSize: 11,
      margin: '0px'
   },
}));

const modalStyle = {
   display: 'flex',
   height: 'auto',
   // bgcolor: 'rgba(0,0,0,1)',
   minHeight: '100vh',
   minWidth: '100vw',
   overflowY: 'hidden',
   outline: 'none',
   zIndex: '9999',
};

const confettiColors = [
   '#3c55f3',
   '#fa87da',
   '#2cd983',
   '#f6bd50'
];


function getTimeDelta(timeString, t) {
   const currentTime = new Date();
   const targetTime = new Date(timeString);

   const timeDiff = currentTime - targetTime;

   const seconds = Math.floor(timeDiff / 1000);
   const minutes = Math.floor(seconds / 60);
   const hours = Math.floor(minutes / 60);
   const days = Math.floor(hours / 24);

   if (!t) {
      // Fallback if t not provided
      if (seconds < 60) return 'Just now';
      if (minutes < 60) return `${minutes}m ago`;
      if (hours < 24) return `${hours}h ago`;
      return `${days}d ago`;
   }

   if (seconds < 60) {
      return t('community.post.timeDelta.justNow');
   } else if (minutes < 60) {
      return t('community.post.timeDelta.minutesAgo', { minutes });
   } else if (hours < 24) {
      return t('community.post.timeDelta.hoursAgo', { hours });
   } else {
      return t('community.post.timeDelta.daysAgo', { days });
   }
}

const formatCategoryName = (category) => {
   if (!category) {
      return '';
   }
   if (category.toLowerCase() === 'all') {
      return 'All';
   }
   return category
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
};

const VideoPost = React.memo(function VideoPost ({video_src, pre_upload}){
   useEffect(() => {
      try {
         playerRef.current.src({ type: 'video/mp4', src: pre_upload ? video_src : paths.CONTENT_CLOUDFRONT + video_src });
         if (window.innerWidth < 900){
            playerRef.current.play();
         }
      } catch (error){

      }
   }, [video_src])
   const playerRef = React.useRef(null);
   const handlePlayerReady = (player) => {
      playerRef.current = player
      if (player.options().autoplay) {
         player.pause();
      }
   };
   return (
      <div
         className="video-container"
         style={{
         borderRadius: '8px !important',
         overflow: 'hidden',
         height: '100%', width: '100%'}}>
      <div
         className="video-container"
           style={{
              width: '100%',
              height: '100%',
           }}>


         <VideoJS
            style={{
               height: '56.25vw',
               width: '100vw',
               // borderRadius: '8px !important',
               zIndex: '9999',
            }}
            onReady={handlePlayerReady}
            options={{
               autoplay: true,
               controls: true,
               muted: false,
               fluid: true,
               width: '100%',
               height: '100%',
               loop: true,
               preload: 'auto',
               playbackRates: [0.25, 0.5, 1, 1.5, 2],
               sources: [{
                  src: pre_upload ? video_src : paths.CONTENT_CLOUDFRONT + video_src,
                  type: `video/mp4`
               }],
               poster: '',
            }}
            page={'influencer_banner'}/>
      </div>
      </div>
   )
})

const YoutubePost = React.memo(function YoutubePost ({video_src}){
   const { t } = useTranslation();
   return (
      <div
         className="video-container"
         style={{
         borderRadius: '8px !important',
         overflow: 'hidden',
         height: '100%', width: '100%'}}>
      <div
         className="video-container"
         style={{
            width: '100%',
            height: '100%',
         }}>
            <div style={{width:'100%', height: '100%',
               aspectRatio: '16/9', borderRadius: '8px', overflow: 'hidden'}}>
               {/* TODO check works with all file formats */}
               <iframe 
                  position='absolute'
                  border='none'
                  width="100%" 
                  height="100%" 
                  src={"https://www.youtube-nocookie.com/embed/" + video_src + "?si=zjwU1BLkbSYRvl1j?rel=0&amp;modestbranding=1"}
                  title={t('dashboard.widgets.articles.youtubePlayer')}
                  frameborder="0"
                  allow="accelerometer; encrypted-media; gyroscope; fullscreen;"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
               ></iframe>
            </div>
      </div>
      </div>
   )
})

const LoomPost = React.memo(function LoomPost ({video_src}){
   return (
      <div
         className="video-container"
         style={{
         borderRadius: '8px !important',
         overflow: 'hidden',
         height: '100%', width: '100%'}}>
      <div
         className="video-container"
         style={{
            width: '100%',
            height: '100%',
         }}>
            <div style={{position: 'relative',
               paddingBottom: '56.25%',
               height: '0'}}>
               {/* TODO check works with all file formats */}
               <iframe 
                  src={"https://www.loom.com/embed/" + video_src + "?sid=879009a9-7ce5-4bc0-84cc-dc6633dc222c?autoplay=false"}
                  frameborder="0" 
                  webkitallowfullscreen 
                  mozallowfullscreen 
                  allowfullscreen 
                  style={
                     {
                        position: 'absolute',
                        top: '0', 
                        left: '0', 
                        width: '100%', 
                        height: '100%'
                     }
                  }
               ></iframe>
            </div>
      </div>
      </div>
   )
})


const VimeoPost = React.memo(function VimeoPost ({video_src}){
   return (
      <div className="video-container" style={{borderRadius: '8px !important', overflow: 'hidden', height: '100%', width: '100%'}}>
      <div className="video-container" style={{width: '100%', height: '100%'}}>
         <div style={{position: 'relative', paddingBottom: '56.25%', height: '0'}}>
            <iframe
               src={"https://player.vimeo.com/video/" + video_src}
               frameborder="0"
               allow="autoplay; fullscreen; picture-in-picture"
               allowfullscreen
               style={{position: 'absolute', top: '0', left: '0', width: '100%', height: '100%'}}
            ></iframe>
         </div>
      </div>
      </div>
   )
})

const TwitchPost = React.memo(function TwitchPost ({video_src}){
   const twitchSrc = video_src?.startsWith('ch')
      ? "https://player.twitch.tv/?channel=" + video_src.slice(2) + "&parent=" + window.location.hostname
      : video_src?.startsWith('c')
      ? "https://clips.twitch.tv/embed?clip=" + video_src.slice(1) + "&parent=" + window.location.hostname
      : video_src
      ? "https://player.twitch.tv/?video=" + video_src.slice(1) + "&parent=" + window.location.hostname
      : ''
   return (
      <div className="video-container" style={{borderRadius: '8px !important', overflow: 'hidden', height: '100%', width: '100%'}}>
      <div className="video-container" style={{width: '100%', height: '100%'}}>
         <div style={{position: 'relative', paddingBottom: '56.25%', height: '0'}}>
            <iframe
               src={twitchSrc}
               frameborder="0"
               allow="autoplay; fullscreen"
               allowfullscreen
               style={{position: 'absolute', top: '0', left: '0', width: '100%', height: '100%'}}
            ></iframe>
         </div>
      </div>
      </div>
   )
})

const WistiaPost = React.memo(function WistiaPost ({video_src}){
   return (
      <div className="video-container" style={{borderRadius: '8px !important', overflow: 'hidden', height: '100%', width: '100%'}}>
      <div className="video-container" style={{width: '100%', height: '100%'}}>
         <div style={{position: 'relative', paddingBottom: '56.25%', height: '0'}}>
            <iframe
               src={"https://fast.wistia.com/embed/iframe/" + video_src + "?autoPlay=false"}
               frameborder="0"
               allow="autoplay; fullscreen"
               allowfullscreen
               style={{position: 'absolute', top: '0', left: '0', width: '100%', height: '100%'}}
            ></iframe>
         </div>
      </div>
      </div>
   )
})

const GoogleSheetsPost = React.memo(function GoogleSheetsPost ({video_src, type, id, handleFullscreenOpen, fullscreen}){
   return (
      <div
         className="video-container"
         style={{
         borderRadius: '8px !important',
         overflow: 'hidden',
         height: 'calc(100vh - 40px)', margin: 'auto 0px 0px 0px', width: '100%'}}>
      <div
         className="video-container"
         style={{
            width: '100%',
            height: '100vh',
            overflow: 'hidden',
         }}>
            <div style={{width:'100%', height: '100vh',
               borderRadius: '8px', overflow: 'hidden'}}>
               {/* TODO check works with all file formats */}
               <iframe
                  id={'google_sheet_'+type+'_'+String(id)}
                  src={video_src}
                  style={
                     {
                        display: 'block',
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%', 
                        height: '100%',
                     }
                  }
               ></iframe>
               <a className={'hover_modal_icon'}
                  onClick={() => {
                     handleFullscreenOpen(video_src, 'gos')
                  }}
               >
                  {
                     fullscreen ?
                        null
                        :
                        <RiFullscreenFill className="fullscreen_icon" style={{ width: '20px', height: '20px', bottom: '10px', right: '10px'}}/>
                  }
               </a>
            </div>
      </div>
      </div>
   )
})


const GoogleDocsPost = React.memo(function GoogleDocsPost ({video_src, type, id, handleFullscreenOpen, fullscreen}){
   return (
      <div
         className="video-container"
         style={{
         borderRadius: '8px !important',
         overflow: 'hidden',
         height: 'calc(100vh - 40px)', margin: 'auto 0px 0px 0px', width: '100%'}}>
      <div
         className="video-container"
         style={{
            width: '100%',
            height: '100vh',
            overflow: 'hidden',
         }}>
            <div style={{width:'100%', height: '100vh',
               borderRadius: '8px', overflow: 'hidden'}}>
               {/* TODO check works with all file formats */}
               <iframe
                  id={'google_doc_'+type+'_'+String(id)}
                  src={video_src}
                  style={
                     {
                        display: 'block',
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%', 
                        height: '100%',
                     }
                  }
               ></iframe>
               <a className={'hover_modal_icon'}
                  onClick={() => {
                     handleFullscreenOpen(video_src, 'god')
                  }}
               >
                  {
                     fullscreen ?
                        null
                        :
                        <RiFullscreenFill className="fullscreen_icon" style={{ width: '20px', height: '20px', bottom: '10px', right: '10px'}}/>
                  }
               </a>
            </div>
      </div>
      </div>
   )
})


const ImagePost = React.memo(function ImagePost({image_src, pre_upload, fullscreen, post_type, handleFullscreenOpen}){
   const { t } = useTranslation();
   const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });

   useEffect(() => {
      const img = new Image();
      img.src = pre_upload || fullscreen ? image_src : paths.CONTENT_CLOUDFRONT + image_src;

      img.onload = () => {
         setImageDimensions({ width: img.naturalWidth, height: img.naturalHeight });
      };
   }, [image_src, pre_upload, fullscreen]);
   return (
   <div style={{ position: 'relative', maxHeight: '100vh' }}>
      <img
         src={pre_upload || fullscreen ? image_src : paths.CONTENT_CLOUDFRONT + image_src}
         alt={t('common.selectedImage')}
         style={{
            maxWidth: '100vw',
            maxHeight: '100vh',
            height: fullscreen ? (imageDimensions.height > window.innerHeight ? '100vh' : 'auto') : 'auto',
            width: fullscreen ?  (imageDimensions.height < window.innerWidth) ? '100vw' : 'auto' : '100%',
            objectFit: 'contain',
            borderRadius: fullscreen ? '0px' : '6px',
            overflow: 'hidden',
            margin: '0px 0px 0px 0px',
            // paddingBottom: pre_upload ? '0px' : '20px',
         }}
      />
      <a className={'hover_modal_icon'}
         onClick={() => {
            handleFullscreenOpen(pre_upload ? image_src : paths.CONTENT_CLOUDFRONT + image_src, 'img')
         }}
      >

         {
            fullscreen ?
               null
               :
               <RiFullscreenFill className="fullscreen_icon" style={{ width: '20px', height: '20px', bottom: '10px', right: '10px'}}/>
         }
      </a>
   </div>

)
})

const PDFPost = React.memo(function PDFPost({pdf_src, pre_upload, fullscreen, content_width_type, handleFullscreenPDFOpen}){
   //
   // if (window.innerWidth < 600) {
   //    return null
   // } else {
   //    return (
   //       <div style={{ position: 'relative' }}>
   //          <PDFSwiper pdfFile={pre_upload || fullscreen ? pdf_src : paths.CONTENT_CLOUDFRONT + pdf_src} content_width_type={content_width_type} />
   //
   //          <a className={'hover_modal_icon'}
   //             onClick={() => {
   //                handleFullscreenPDFOpen(pre_upload ? pdf_src : paths.CONTENT_CLOUDFRONT + pdf_src, 'pdf')
   //             }}
   //          >
   //
   //             {
   //                fullscreen ?
   //                   null
   //                   :
   //                   <RiFullscreenFill className="fullscreen_icon" style={{ width: '20px', height: '20px', bottom: content_width_type === 'post' ? '50px' : '40px', right: '10px', zIndex: '999'}}/>
   //             }
   //          </a>
   //
   //       </div>
   //    )
   // }

   return (
      <div style={{ position: 'relative' }}>
         <PDFSwiper pdfFile={pre_upload || fullscreen ? pdf_src : paths.CONTENT_CLOUDFRONT + pdf_src} content_width_type={content_width_type} />

         <a className={'hover_modal_icon'}
            onClick={() => {
               handleFullscreenPDFOpen(pre_upload ? pdf_src : paths.CONTENT_CLOUDFRONT + pdf_src, 'pdf')
            }}
         >

            {
               fullscreen ?
                  null
                  :
                  <RiFullscreenFill className="fullscreen_icon" style={{ width: '20px', height: '20px', bottom: content_width_type === 'post' ? '50px' : '40px', right: '10px', zIndex: '999'}}/>
            }
         </a>

      </div>
   )



})

const PDFPostFullscreen = React.memo(function PDFPostFullscreen({pdf_src, pre_upload, fullscreen, content_width_type, handleFullscreenPDFOpen}){

   return (
      <div style={{ position: 'relative' }}>
         <PDFSwiper pdfFile={pdf_src} content_width_type={'fullscreen'} width={window.innerWidth} height={window.innerHeight}/>
      </div>
   )
})


const AudioPost = React.memo(function AudioPost({audio_src, pre_upload}){
   return (
   <div className="props.image_container"
         style={{position: 'relative'}}
   >
      <ReactAudioPlayer
         className='react-player'
         src={pre_upload ? audio_src : paths.CONTENT_CLOUDFRONT + audio_src}
         // autoPlay
         controls
         style={{ width: '100%', margin: '0px 0px 16px 0px', borderRadius: '0px' }}
         // onLoadedMetadata={props.handleAudioLoadMetadata}
      />


   </div>
)})



const CommunityPost = (
   {
      post_index, 
      username, 
      display_name,
      user_icon, 
      current_user_icon, 
      influencer_name, 
      time, 
      subscription, 
      text, 
      photos, 
      video, 
        threads, 
        tags_list,
      n_threads, 
      n_comments,
      loadAdditionalThreads, 
      post_id, 
      deletePost, 
      submitThread, 
      deleteThread, 
      submitComment, 
      deleteComment, 
      content_type,
      content_file,
      editPost, 
      subscriber_tier,
      editThread, 
      editComment, 
      post_like_count, 
      post_user_value_count, 
      loadAdditionalComments, 
      postLikeChange,
      post_tier,
      influencer_tier_names = {},
      threadLikeChange, 
      commentLikeChange, 
      current_username, 
      influencer_info, 
      OpenSubscribePopup, 
      OpenWaitingListPopup, 
      current_subscription_tier,
      CloseSubscribePopup, 
      CloseWaitingListPopup, 
      currency, 
      current_tier, 
      redirectCallback,
      resetThreadTextId,
      resetCommentTextId,
      setResetThreadTextId,
      setResetCommentTextId,
      resetPostEditTextId,
      setResetPostEditTextId,
      resetThreadEditTextId,
      setResetThreadEditTextId,
      resetCommentEditTextId,
      setResetCommentEditTextId,
      snackbarMsgOuter,
      snackbarOpenOuter,
      snackbarColorOuter,
      setSnackbarOpenOuter,
      snackbarTypeOuter,
      onClose,
      windowWidth,
      event_time,
      scheduled_date,
      community_post_title,
      setSelectedFileThread,
      setSelectedPreviewUrlThread,
      setSelectedPreviewIdThread,
      selectedPreviewIdThread,
      setSelectedPreviewIdComment,
      selectedPreviewIdComment,
      setFileTypeThread,
      setShowPostButtonThread,
      setIsMediaAttachedThread,
      setSelectedFileComment,
      setSelectedPreviewUrlComment,
      setFileTypeComment,
      setShowPostButtonComment,
      setIsMediaAttachedComment,
      isMediaAttachedThread,
      selectedFileThread,
      selectedPreviewUrlThread,
      fileTypeThread,
      showPostButtonThread,
      isMediaAttachedComment,
      selectedFileComment,
      selectedPreviewUrlComment,
      fileTypeComment,
      showPostButtonComment,
      isMediaAttachedEdit,
      selectedFileEdit,
      selectedPreviewUrlEdit,
      fileTypeEdit,
      setSelectedFileEdit,
      setSelectedPreviewUrlEdit,
      setFileTypeEdit,
      setIsMediaAttachedEdit,
      setEmbedUrlIsOpen,
      setSnackbarEmbed,
      setEmbedUrlType,
      setDocModalOpen,
      setSnackbarOpenDoc,
      setDocType,
      setActiveDocFileType,
      setMeetingModalOpen,
      setMeetingType,
      setSnackbarOpenMeeting,
      setMeetingTimeComment,
      embedUrlKeyThread,
      embedUrlKeyComment,
      link,
      setPostMeetingTime,
      setUpdateEditPostData,
      snackbarSeverityOuter,
      snackbarPreMsgClick,
      snackbarPostMsgClick,
      snackbarTextClick,
        saveFile,
      recordedFileFormat,
      snackbarOpenClick,
      snackbarSeverityClick,
      snackbarColorClick,
        setSnackbarOpenClick,
        setMeetingTimeEditPost,
      handleUpdatePinnedPost,
      handleRemovePinnedPost,
      pinnedPost,
      isPinnedPost,
        getBrandColor,
        currentTabInfo,
        editPostTags,
        setEditPostTags,
        is_me,
        meetingImageEdit,
        setMeetingImageEdit,
        meetingImageFileNameEdit,
        setMeetingImageFileNameEdit,
        meetingType,
        onEditCategory,
        openInEditMode,
        late_payment,
        stripe_customer_id2,
   }
) => {
   const { t } = useTranslation();
   const isPostScheduled = !!(scheduled_date && new Date(scheduled_date) > new Date());
   // undefined = untouched, null = cleared, Date = newly picked
   const [scheduleDateEdit, setScheduleDateEdit] = useState(undefined);
   const [scheduleDateEditError, setScheduleDateEditError] = useState('');
   const scheduleDateEditValue = scheduleDateEdit === undefined
      ? (isPostScheduled ? new Date(scheduled_date) : undefined)
      : (scheduleDateEdit === null ? undefined : scheduleDateEdit);

   const [currentUser, setCurrentUser] = useState(current_username)
   const [votes, setVotes] = useState(0);
   // const [latestCommentIndex, setLastComment] = useState(null);

   const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false);
   const [newThreadText, setNewThreadText] = useState('');
   const [isExploding, setIsExploding] = React.useState(false);
   const [explodingIndex, setExplodingIndex] = useState(null)

   const [showInputIndex, setShowInputIndex] = useState(-1);
   const [replyPlaceHolderText, setReplyPlaceHolderText] = useState('');
   const [replyText, setReplyText] = useState('');
   const [replyTo, setReplyTo] = useState('');
   const [isReplyingNested, setIsReplyingNested] = useState(false);
   const [expandedThreads, setExpandedThreads] = useState([]);

   const [replyIsHovered, setReplyIsHovered] = useState(false);
   const [hoveredIndex, setHoveredIndex] = useState(null);

   const [menuOpen, setMenuOpen] = useState(false);
   const [menuAnchorEl, setMenuAnchorEl] = useState(null);
   const [menuIdentifier, setMenuIdentifier] = useState('');

   const [menuPostID, setMenuPostID] = useState('');
   const [menuPostIndex, setMenuPostIndex] = useState('');

   const [menuThreadID, menuSetThreadID] = useState('');
   const [menuThreadPostIndex, setMenuThreadPostIndex] = useState('');
   const [menuThreadIndex, setMenuThreadIndex] = useState('');
   const [menuCommentID, setMenuCommentID] = useState('');
   const [menuCommentIndex, setMenuCommentIndex] = useState('');
   const [anchorElEdit, setAnchorElEdit] = useState('');
   const [anchorElComment, setAnchorElComment] = useState('');
   const [anchorElThread, setAnchorElThread] = useState('');
   const [anchorElEditVideo, setAnchorElEditVideo] = useState('');
   const [anchorElCommentVideo, setAnchorElCommentVideo] = useState('');
   const [anchorElThreadVideo, setAnchorElThreadVideo] = useState('');
   const [anchorElEditMeeting, setAnchorElEditMeeting] = useState('');
   const [anchorElCommentMeeting, setAnchorElCommentMeeting] = useState('');
   const [anchorElThreadMeeting, setAnchorElThreadMeeting] = useState('');
   const [anchorElEditDoc, setAnchorElEditDoc] = useState('');
   const [anchorElCommentDoc, setAnchorElCommentDoc] = useState('');
   const [anchorElThreadDoc, setAnchorElThreadDoc] = useState('');

    const sanitizedPostTags = useMemo(() => (
       Array.isArray(tags_list)
          ? tags_list.filter(tag => typeof tag === 'string' && tag.trim() !== '')
          : []
    ), [tags_list]);

    const availableCategories = useMemo(() => {
       const combined = ['all'];
       
       // Get valid categories from currentTabInfo.tags (these are the valid categories from the backend)
       const validTabTags = currentTabInfo && Array.isArray(currentTabInfo.tags) 
          ? currentTabInfo.tags.map(t => typeof t === 'string' ? t.trim().toLowerCase() : '').filter(t => t)
          : [];
       
       // Add categories from currentTabInfo.tags (these are the valid categories from the backend)
       if (currentTabInfo && Array.isArray(currentTabInfo.tags) && currentTabInfo.tags.length > 0) {
          currentTabInfo.tags.forEach(tag => {
             if (typeof tag === 'string' && tag.trim() !== '') {
                combined.push(tag.trim());
             }
          });
       }
       
       // Add categories from editPostTags (for pending new categories being created)
       if (Array.isArray(editPostTags) && editPostTags.length > 0) {
          editPostTags.forEach(tag => {
             if (typeof tag === 'string' && tag.trim() !== '' && tag.trim().toLowerCase() !== 'all') {
                const tagLower = tag.trim().toLowerCase();
                // Only add if not already in combined (to avoid duplicates)
                if (!combined.some(c => c.toLowerCase() === tagLower)) {
                   combined.push(tag.trim());
                }
             }
          });
       }
       
       // Remove duplicates while preserving order (case-insensitive)
       const seen = new Map();
       combined.forEach(tag => {
          if (typeof tag !== 'string') return;
          const trimmed = tag.trim();
          if (!trimmed) return;
          const key = trimmed.toLowerCase();
          if (!seen.has(key)) {
             seen.set(key, trimmed);
          }
        });
        
        const result = Array.from(seen.values());
        // Ensure we always have at least 'all'
        return result.length > 0 ? result : ['all'];
    }, [currentTabInfo, editPostTags]);

    const selectedCategory = useMemo(() => {
       if (Array.isArray(editPostTags) && editPostTags.length > 0 && editPostTags[0]) {
          return editPostTags[0];
       }
       if (sanitizedPostTags.length > 0) {
          return sanitizedPostTags[0];
       }
       return 'all';
    }, [editPostTags, sanitizedPostTags]);

    const handleCategoryChange = (event) => {
       if (typeof setEditPostTags === 'function') {
          const value = event.target.value;
          setEditPostTags(value ? [value] : ['all']);
       }
    };

    const primaryCategory = useMemo(() => {
       const firstNonAll = sanitizedPostTags.find(tag => tag && tag.toLowerCase() !== 'all');
       return firstNonAll || null;
    }, [sanitizedPostTags]);

   const [editPostModal, setEditPostModal] = useState(false);
   const [editPostModalAnimating, setEditPostModalAnimating] = useState(false);
   const [editPostData, setEditPostData] = useState('');
   const [editPostTextLength, setEditPostTextLength] = useState(0);
   const [postId, setPostId] = useState('');
   const [postIndex, setPostIndex] = useState('');
   const [fullscreenPDFOpen, setFullscreenPDFOpen] = useState(false);
   const [fullscreenPDFSrc, setFullscreenPDFSrc] = useState('');
   const hasOpenedEditModalRef = useRef(false);

   // Register setEditPostData callback with parent component
   useEffect(() => {
      if (typeof setUpdateEditPostData === 'function') {
         setUpdateEditPostData(() => setEditPostData);
      }
      return () => {
         if (typeof setUpdateEditPostData === 'function') {
            setUpdateEditPostData(null);
         }
      };
   }, [setUpdateEditPostData]);
   
   // Auto-open edit modal if openInEditMode prop is true
   useEffect(() => {
      if (openInEditMode && text !== undefined && text !== null && post_id && (post_index !== null && post_index !== undefined && post_index !== '') && !hasOpenedEditModalRef.current) {
         hasOpenedEditModalRef.current = true;
         // Small delay to ensure parent modal is fully rendered
         setTimeout(() => {
            handleEditPost(text, post_id, post_index, content_file, tags_list);
         }, 100);
      }
      // Reset ref when openInEditMode becomes false
      if (!openInEditMode) {
         hasOpenedEditModalRef.current = false;
      }
   }, [openInEditMode, text, post_id, post_index, content_file, tags_list]);

   // The join-window timer that used to live here is gone: the event button is
   // always enabled now, so there was nothing left for a 1s interval to compute.

   const handleAddToCalendar = () => {
      if (!event_time || !link || !community_post_title) return;
      
      const eventDateTime = new Date(event_time);
      
      // Validate date
      if (isNaN(eventDateTime.getTime())) {
         return;
      }
      
      // Format dates for ICS (YYYYMMDDTHHmmssZ)
      const formatICSDate = (date) => {
         const year = date.getUTCFullYear();
         const month = String(date.getUTCMonth() + 1).padStart(2, '0');
         const day = String(date.getUTCDate()).padStart(2, '0');
         const hours = String(date.getUTCHours()).padStart(2, '0');
         const minutes = String(date.getUTCMinutes()).padStart(2, '0');
         const seconds = String(date.getUTCSeconds()).padStart(2, '0');
         return `${year}${month}${day}T${hours}${minutes}${seconds}Z`;
      };
      
      const startDate = formatICSDate(eventDateTime);
      const endDate = formatICSDate(new Date(eventDateTime.getTime() + 60 * 60 * 1000)); // 1 hour later
      
      // Escape special characters for ICS format
      const escapeICS = (text) => {
         return text ? text.replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\n/g, '\\n') : '';
      };
      
      // Generate ICS file
      const icsContent = [
         'BEGIN:VCALENDAR',
         'VERSION:2.0',
         'PRODID:-//WithMe//Event//EN',
         'BEGIN:VEVENT',
         `DTSTART:${startDate}`,
         `DTEND:${endDate}`,
         `SUMMARY:${escapeICS(community_post_title)}`,
         `DESCRIPTION:${escapeICS(text || '')}\\n${escapeICS(link)}`,
         `LOCATION:${escapeICS(link)}`,
         `URL:${link}`,
         'STATUS:CONFIRMED',
         'SEQUENCE:0',
         'BEGIN:VALARM',
         'TRIGGER:-PT15M',
         'ACTION:DISPLAY',
         `DESCRIPTION:Reminder: ${escapeICS(community_post_title)}`,
         'END:VALARM',
         'END:VEVENT',
         'END:VCALENDAR'
      ].join('\r\n');
      
      const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const linkEl = document.createElement('a');
      linkEl.href = url;
      linkEl.download = `${community_post_title.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.ics`;
      document.body.appendChild(linkEl);
      linkEl.click();
      document.body.removeChild(linkEl);
      URL.revokeObjectURL(url);
   };

   const handleFullscreenPDFOpen = (pdf_src) => {
      // console.log(pdf_src, 'opened pdf fullscreen')
      setFullscreenPDFSrc(pdf_src);
      setFullscreenPDFOpen(true);
   }
   const handleFullscreenPDFClose = () => {
      setFullscreenPDFOpen(false);
   }
    const handleEditPost = (data, post_id, post_index, content_file, postTags = []) => {
       setEditPostData(data);
       setPostId(post_id);
       setPostIndex(post_index);
       setScheduleDateEdit(isPostScheduled ? new Date(scheduled_date) : undefined);
       setScheduleDateEditError('');
       const hasFile = Boolean(content_file);
       const isEmbedType = ['vey', 'vel', 'vev', 'vtw', 'vwi'].includes(content_type);
       // Meeting/doc posts keep their URL in `link` and may ALSO have an image in
       // `file`. This value is what gets submitted back as `link`, so the link has
       // to win over the file - when `hasFile` won first, editing anything on an
       // event post with an image overwrote the meeting URL with the image's
       // CloudFront URL and the Join button opened the image.
       setSelectedPreviewUrlEdit(['mot', 'mgm', 'mzm', 'mmt', 'gos', 'god'].includes(content_type) ? (link || '') : hasFile ? (isEmbedType ? content_file : paths.CONTENT_CLOUDFRONT + content_file) : '');
       setFileTypeEdit(content_type);
       setIsMediaAttachedEdit(hasFile);
       // Initialize postMeetingTime and meetingTimeEditPost with existing event_time for meeting posts
       if (['mot', 'mgm', 'mzm', 'mmt'].includes(content_type) && event_time) {
          if (typeof setPostMeetingTime === 'function') {
             setPostMeetingTime(event_time);
          }
          if (typeof setMeetingTimeEditPost === 'function') {
             setMeetingTimeEditPost(event_time);
          }
          // Initialize meeting image for edit mode - set existing event image if it exists
          if (typeof setMeetingImageEdit === 'function' &&  content_file) {
             // Set the existing image URL (from CloudFront)
             setMeetingImageEdit(paths.CONTENT_CLOUDFRONT + content_file);
          }
          if (typeof setMeetingImageFileNameEdit === 'function' && content_file) {
             // We don't have the original filename, so leave it empty
             setMeetingImageFileNameEdit('');
          }
       }
       if (typeof setEditPostTags === 'function') {
          const normalizedTags = Array.isArray(postTags)
             ? postTags.filter(tag => typeof tag === 'string' && tag.trim() !== '')
             : [];
          if (normalizedTags.length > 0) {
             setEditPostTags(normalizedTags);
          } else {
             setEditPostTags(['all']);
          }
       }
       setEditPostModal(true);
       // Trigger animation after modal is set to true
       setTimeout(() => {
          setEditPostModalAnimating(true);
       }, 10);
    }

   const [editCommentThreadModal, setEditCommentThreadModal] = useState(false);
   const [editCommentThreadData, setEditCommentThreadData] = useState('');
   const [threadId, setThreadId] = useState('');
   const [threadIndex, setThreadIndex] = useState('');
   const handleEditCommentThread = (data, thread_id, post_index, thread_index, thread_content_file, thread_content_type, thread_link) => {
      setEditCommentThreadModal(true);
      setEditCommentThreadData(data);
      setThreadId(thread_id);
      setThreadIndex(thread_index);
      setPostIndex(post_index);
      const hasFile = Boolean(thread_content_file);
      const isEmbedType = ['vey', 'vel', 'vev', 'vtw', 'vwi'].includes(thread_content_type);
      // The thread's own link, not the parent post's - and it wins over the file,
      // since this value is submitted back as the thread's `link`.
      setSelectedPreviewUrlEdit(['mot', 'mgm', 'mzm', 'mmt'].includes(thread_content_type) ? (thread_link || '') : hasFile ? (isEmbedType ? thread_content_file : paths.CONTENT_CLOUDFRONT + thread_content_file) : '');
      setFileTypeEdit(thread_content_type)
      if (thread_content_file) {
         setIsMediaAttachedEdit(true)
      }
   }
   const [fullscreenViewOpen, setFullscreenViewOpen] = useState(false);
   const [selectedContentFullscreen, setSelectedContentFullscreen] = useState('');
   const [selectedContentFullscreenType, setSelectedContentFullscreenType] = useState('');

   const handleFullscreenOpen = (preview_src, preview_type) => {
      setSelectedContentFullscreen(preview_src);
      setSelectedContentFullscreenType(preview_type);
      setFullscreenViewOpen(true);
   }

   const handleFullscreenClose = () => {
      setFullscreenViewOpen(false);
   }

   const [editCommentModal, setEditCommentModal] = useState(false);
   const [editCommentData, setEditCommentData] = useState('');
   const [commentId, setCommentId] = useState('');
   const [commentIndex, setCommentIndex] = useState('');
   const handleEditComment = (data, comment_id, post_index, thread_index, comment_index, comment_content_file, comment_content_type, comment_link) => {
      setEditCommentData(data)
      setEditCommentModal(true);
      setCommentId(comment_id);
      setPostIndex(post_index);
      setThreadIndex(thread_index);
      setCommentIndex(comment_index);
      const hasFile = Boolean(comment_content_file);
      const isEmbedType = ['vey', 'vel', 'vev', 'vtw', 'vwi'].includes(comment_content_type);
      // The comment's own link, not the parent post's - and it wins over the file,
      // since this value is submitted back as the comment's `link`.
      setSelectedPreviewUrlEdit(['mot', 'mgm', 'mzm', 'mmt'].includes(comment_content_type) ? (comment_link || '') : hasFile ? (isEmbedType ? comment_content_file : paths.CONTENT_CLOUDFRONT + comment_content_file) : '');
      setFileTypeEdit(comment_content_type)
      if (comment_content_file) {
         setIsMediaAttachedEdit(true)
      }
   };

   const handlePostMenuOpen = (event, identifier, id, postIndex) => {
      setMenuOpen(true);
      setMenuAnchorEl(event.currentTarget);
      setMenuIdentifier(identifier);
      setMenuPostID(id)
      setMenuPostIndex(postIndex)
   };

   const handleThreadMenuOpen = (event, identifier, id, postIndex, index, data) => {
      setMenuOpen(true);
      setMenuAnchorEl(event.currentTarget);
      setMenuIdentifier(identifier);
      menuSetThreadID(id)
      setMenuThreadPostIndex(postIndex)
      setMenuThreadIndex(index)
      setEditCommentThreadData(data)
   };

   const handleEditModalClosed = () => {
      setSelectedFileComment('');
      setSelectedPreviewUrlEdit('');
       if (typeof setEditPostTags === 'function') {
          setEditPostTags(['all']);
       }
   }

   const closeEditPostModal = () => {
      setEditPostModalAnimating(false);
      setTimeout(() => {
         setEditPostModal(false);
         handleEditModalClosed();
         // Clean up event image preview if it's a blob URL
         if (meetingImageEdit && meetingImageEdit.startsWith('blob:')) {
            URL.revokeObjectURL(meetingImageEdit);
         }
         if (typeof setMeetingImageEdit === 'function') {
            setMeetingImageEdit('');
         }
         if (typeof setMeetingImageFileNameEdit === 'function') {
            setMeetingImageFileNameEdit('');
         }
      }, 300);
   }

   const handleCommentMenuOpen = (event, identifier, comment_id, postIndex, thread_index, comment_index, data) => {
      // console.log(postIndex, thread_index, comment_index)
      setMenuOpen(true);
      setMenuAnchorEl(event.currentTarget);
      setMenuIdentifier(identifier);
      setMenuThreadPostIndex(postIndex);
      setMenuThreadIndex(thread_index);
      setMenuCommentID(comment_id);
      setMenuCommentIndex(comment_index);
      setEditCommentData(data);
   };

   const handleMenuClose = () => {
      setMenuOpen(false);
      setMenuAnchorEl(null);
      setMenuIdentifier('');
      setMenuPostID('')
      setMenuPostIndex('')
      menuSetThreadID('')
      setMenuThreadPostIndex('')
      setMenuThreadIndex('')
   };

   const handleReplyClick = (index, commenter) => {
      setShowInputIndex(index);
      setReplyText('');
      setReplyTo('');
      setReplyPlaceHolderText('')
   };

   const handleReplyTextChange = (event) => {
      if (event.target.value.length >= 500) {
         setSnackbarColor('var(--danger-color)')
         setSnackbarType('error');
         setSnackbarMsg(t('community.post.maxCharLimit500'))
         setSnackbarOpen(true)
      } else {
         setReplyText(event.target.value);
      }
   }

   const validateUpdatedContent = (newData, fileType) => {
      if (((newData === '') && (fileType === 'txt')) || ((newData === null) && (fileType === 'txt')) || ((newData === undefined) && (fileType === 'txt'))) {
         handleSnackbar('var(--danger-color)', 'error', t('community.post.errorUpdatingContent'))
      } else {
         return true;
      }
   }

   const handleShareImageComment = (thread_id) => {
      const imageInput = document.createElement('input');
      imageInput.type = 'file';
      imageInput.accept = 'image/*';
      imageInput.onchange = (event) => {
         const file = event.target.files[0];
         if (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg') {
            const imageUrl = URL.createObjectURL(file);
            setSelectedFileComment(file);
            setSelectedPreviewUrlComment(imageUrl);
            setFileTypeComment('img');
            setShowPostButtonComment(true)
            setIsMediaAttachedComment(true)
            setSelectedPreviewIdComment(thread_id);
         } else {
            setSnackbarType('error');
            setSnackbarOpen(true)
            setSnackbarColor('var(--danger-color)')
            setSnackbarMsg(t('community.post.unsupportedImageType'))
         }
      };
      imageInput.click();
   };

   const handleShareImageThread = (post_id) => {
      const imageInput = document.createElement('input');
      imageInput.type = 'file';
      imageInput.accept = 'image/*';
      imageInput.onchange = (event) => {
         const file = event.target.files[0];
         if (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg') {
            const imageUrl = URL.createObjectURL(file);
            setSelectedFileThread(file);
            setSelectedPreviewUrlThread(imageUrl);
            setSelectedPreviewIdThread(post_id);
            setFileTypeThread('img');
            setShowPostButtonThread(true)
            setIsMediaAttachedThread(true)
         } else {
            setSnackbarType('error');
            setSnackbarOpen(true)
            setSnackbarColor('var(--danger-color)')
            setSnackbarMsg(t('community.post.unsupportedImageType'))
         }
      };
      imageInput.click();
   };

   const handleEditImage = () => {
      const imageInput = document.createElement('input');
      imageInput.type = 'file';
      imageInput.accept = 'image/*';
      imageInput.onchange = (event) => {
         const file = event.target.files[0];
         if (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg') {
            const imageUrl = URL.createObjectURL(file);
            setSelectedFileEdit(file);
            setSelectedPreviewUrlEdit(imageUrl);
            setFileTypeEdit('img');
            setIsMediaAttachedEdit(true)
         } else {
            setSnackbarType('error');
            setSnackbarOpen(true)
            setSnackbarColor('var(--danger-color)')
            setSnackbarMsg(t('community.post.unsupportedImageType'))
         }
      };
      imageInput.click();
   };

   const handleRemoveContentThread = () => {
      setSelectedFileThread('');
      setSelectedPreviewUrlThread('');
      setFileTypeThread('txt');
      setIsMediaAttachedThread(false)
      setShowPostButtonThread(false);
      setSelectedPreviewIdThread('');
   };

   const handleRemoveContentComment = () => {
      setSelectedFileComment('');
      setSelectedPreviewUrlComment('');
      setFileTypeComment('txt');
      setIsMediaAttachedComment(false)
      setShowPostButtonComment(false);
      setSelectedPreviewIdComment('');
   };

   const handleRemoveEditContent = () => {
      setSelectedFileEdit('');
      setSelectedPreviewUrlEdit('');
      setFileTypeEdit('txt');
      setIsMediaAttachedEdit(false);
   };

   const handlePostReply = (thread_id, thread_index, post_index, post_id) => {
      submitComment(replyText, thread_id, post_index, thread_index, post_id);
   };

   const handleReplyMouseEnter = (index) => {
      setHoveredIndex(index);
   };

   const handleReplyMouseLeave = () => {
      setHoveredIndex(null);
   };


   // Passed in the type of vote ('up' === + 1 or 'down' === -1), id is the post/thread/comment ID
   const handleVote = (id) => {
         // console.log(id)
         setExplodingIndex(id)
         setIsExploding(true)
   }

   const [latestOpenCount, setLatestOpenCount] = useState(1);


   const [postTier, setPostTier] = useState(post_tier)


   useEffect(() => {
      setPostTier(post_tier)
   }, [post_tier])

   const [metReplyCriteria, setMetReplyCriteria] = useState(null);

   useEffect(() => {
      if (current_username === '') {
         setMetReplyCriteria(false)
         setDisabledReason(t('community.post.loginToJoin'))
      } else {
         if (current_tier >= postTier) {
            setDisabledReason(t('community.post.joinConversation'))
            setMetReplyCriteria(true)
         } else if (postTier === 0) {
            setDisabledReason(t('community.post.joinConversation'))
            setMetReplyCriteria(true)
         } else {
            setMetReplyCriteria(false)
            setDisabledReason(t('community.post.upgradeToJoin'))
         }
      }

   }, [post_tier, current_username])

   const [tierBadgeText, setTierBadgeText] = useState('')

   useEffect(() => {
      setTierBadgeText(influencer_tier_names[post_tier])
   }, [post_tier])



   const [disabledReason, setDisabledReason] = useState('');

   
   const [commentCount, setCommentCount] = useState();

   useEffect(() => {
      setCommentCount(n_comments)
      // console.log(commentCount)
   }, [n_comments])



   const handleSnackbar = (color, type, msg) => {
      setSnackbarColor(color)
      setSnackbarType(type);
      setSnackbarMsg(msg)
      setSnackbarOpen(true)
   }

   // Error Handling
   const [snackbarOpen, setSnackbarOpen] = useState(false);
   const [snackbarMsg, setSnackbarMsg] = useState('')
   const [snackbarType, setSnackbarType] = useState('false')
   const [snackbarColor, setSnackbarColor] = useState('false')

   // Comment handlers
   const handleClickCommentVideo = e => setAnchorElCommentVideo(e.currentTarget);
   const handleCloseCommentVideo = () => setAnchorElCommentVideo(null);
   const handleClickComment = e => setAnchorElComment(e.currentTarget);
   const handleCloseComment = () => setAnchorElComment(null);
   const handleClickCommentDoc = e => setAnchorElCommentDoc(e.currentTarget);
   const handleCloseCommentDoc = () => setAnchorElCommentDoc(null);
   const handleClickCommentMeeting = e => setAnchorElCommentMeeting(e.currentTarget);
   const handleCloseCommentMeeting = () => setAnchorElCommentMeeting(null);
   
   // Thread handlers
   const handleClickThreadVideo = e => setAnchorElThreadVideo(e.currentTarget);
   const handleCloseThreadVideo = () => setAnchorElThreadVideo(null);
   const handleClickThread = e => setAnchorElThread(e.currentTarget);
   const handleCloseThread = () => setAnchorElThread(null);
   const handleClickThreadDoc = e => setAnchorElThreadDoc(e.currentTarget);
   const handleCloseThreadDoc = () => setAnchorElThreadDoc(null);
   const handleClickThreadMeeting = e => setAnchorElThreadMeeting(e.currentTarget);
   const handleCloseThreadMeeting = () => setAnchorElThreadMeeting(null);
   
   // Edit handlers
   const handleClickEditVideo = e => setAnchorElEditVideo(e.currentTarget);
   const handleCloseEditVideo = () => setAnchorElEditVideo(null);
   const handleClickEdit = e => setAnchorElEdit(e.currentTarget);
   const handleCloseEdit = () => setAnchorElEdit(null);
   const handleClickEditDoc = e => setAnchorElEditDoc(e.currentTarget);
   const handleCloseEditDoc = () => setAnchorElEditDoc(null);
   const handleClickEditMeeting = e => setAnchorElEditMeeting(e.currentTarget);
   const handleCloseEditMeeting = () => setAnchorElEditMeeting(null);

   // Share handlers - placeholder implementations
   const handleShareVideoComment = (thread_id) => {
      const videoInput = document.createElement('input');
      videoInput.type = 'file';
      videoInput.accept = 'video/*';
      videoInput.onchange = (event) => {
         const file = event.target.files[0];
         if (file.type === 'video/mp4' || file.type === 'video/quicktime') {
            const videoUrl = URL.createObjectURL(file);
            setSelectedFileComment(file);
            setSelectedPreviewUrlComment(videoUrl);
            setFileTypeComment('vid');
            setShowPostButtonComment(true);
            setIsMediaAttachedComment(true);
            setSelectedPreviewIdComment(thread_id);
         } else {
            setSnackbarType('error');
            setSnackbarOpen(true);
            setSnackbarColor('var(--danger-color)');
            setSnackbarMsg(t('community.post.unsupportedVideoType'));
         }
      };
      videoInput.click();
   };

   const handleShareAudioComment = (thread_id) => {
      const audioInput = document.createElement('input');
      audioInput.type = 'file';
      audioInput.accept = 'audio/*';
      audioInput.onchange = (event) => {
         const file = event.target.files[0];
         const audioUrl = URL.createObjectURL(file);
         setSelectedFileComment(file);
         setSelectedPreviewUrlComment(audioUrl);
         setFileTypeComment('aud');
         setShowPostButtonComment(true);
         setIsMediaAttachedComment(true);
         setSelectedPreviewIdComment(thread_id);
      };
      audioInput.click();
   };

   const handleSharePdfComment = (thread_id) => {
      const pdfInput = document.createElement('input');
      pdfInput.type = 'file';
      pdfInput.accept = 'application/pdf';
      pdfInput.onchange = (event) => {
         const file = event.target.files[0];
         const pdfUrl = URL.createObjectURL(file);
         setSelectedFileComment(file);
         setSelectedPreviewUrlComment(pdfUrl);
         setFileTypeComment('pdf');
         setShowPostButtonComment(true);
         setIsMediaAttachedComment(true);
         setSelectedPreviewIdComment(thread_id);
      };
      pdfInput.click();
   };

   const handleShareVideoThread = (post_id) => {
      const videoInput = document.createElement('input');
      videoInput.type = 'file';
      videoInput.accept = 'video/*';
      videoInput.onchange = (event) => {
         const file = event.target.files[0];
         if (file.type === 'video/mp4' || file.type === 'video/quicktime') {
            const videoUrl = URL.createObjectURL(file);
            setSelectedFileThread(file);
            setSelectedPreviewUrlThread(videoUrl);
            setFileTypeThread('vid');
            setShowPostButtonThread(true);
            setIsMediaAttachedThread(true);
            setSelectedPreviewIdThread(post_id);
         } else {
            setSnackbarType('error');
            setSnackbarOpen(true);
            setSnackbarColor('var(--danger-color)');
            setSnackbarMsg(t('community.post.unsupportedVideoType'));
         }
      };
      videoInput.click();
   };

   const handleShareAudioThread = (post_id) => {
      const audioInput = document.createElement('input');
      audioInput.type = 'file';
      audioInput.accept = 'audio/*';
      audioInput.onchange = (event) => {
         const file = event.target.files[0];
         const audioUrl = URL.createObjectURL(file);
         setSelectedFileThread(file);
         setSelectedPreviewUrlThread(audioUrl);
         setFileTypeThread('aud');
         setShowPostButtonThread(true);
         setIsMediaAttachedThread(true);
         setSelectedPreviewIdThread(post_id);
      };
      audioInput.click();
   };

   const handleSharePdfThread = (post_id) => {
      const pdfInput = document.createElement('input');
      pdfInput.type = 'file';
      pdfInput.accept = 'application/pdf';
      pdfInput.onchange = (event) => {
         const file = event.target.files[0];
         const pdfUrl = URL.createObjectURL(file);
         setSelectedFileThread(file);
         setSelectedPreviewUrlThread(pdfUrl);
         setFileTypeThread('pdf');
         setShowPostButtonThread(true);
         setIsMediaAttachedThread(true);
         setSelectedPreviewIdThread(post_id);
      };
      pdfInput.click();
   };

   const handleEditVideo = () => {
      const videoInput = document.createElement('input');
      videoInput.type = 'file';
      videoInput.accept = 'video/*';
      videoInput.onchange = (event) => {
         const file = event.target.files[0];
         if (file.type === 'video/mp4' || file.type === 'video/quicktime') {
            const videoUrl = URL.createObjectURL(file);
            setSelectedFileEdit(file);
            setSelectedPreviewUrlEdit(videoUrl);
            setFileTypeEdit('vid');
            setIsMediaAttachedEdit(true);
         }
      };
      videoInput.click();
   };

   const handleEditAudio = () => {
      const audioInput = document.createElement('input');
      audioInput.type = 'file';
      audioInput.accept = 'audio/*';
      audioInput.onchange = (event) => {
         const file = event.target.files[0];
         const audioUrl = URL.createObjectURL(file);
         setSelectedFileEdit(file);
         setSelectedPreviewUrlEdit(audioUrl);
         setFileTypeEdit('aud');
         setIsMediaAttachedEdit(true);
      };
      audioInput.click();
   };

   const handleEditPDF = () => {
      const pdfInput = document.createElement('input');
      pdfInput.type = 'file';
      pdfInput.accept = 'application/pdf';
      pdfInput.onchange = (event) => {
         const file = event.target.files[0];
         const fileSizeMB = file.size / 1024 / 1024;
         if (fileSizeMB <= 5) {
            if (file.type === 'application/pdf') {
               const pdfUrl = URL.createObjectURL(file);
               setSelectedFileEdit(file);
               setSelectedPreviewUrlEdit(pdfUrl);
               setFileTypeEdit('pdf');
               setIsMediaAttachedEdit(true);
            } else {
               setSnackbarType('error');
               setSnackbarOpen(true)
               setSnackbarColor('var(--danger-color)')
               setSnackbarMsg(t('community.post.unsupportedPdf'))
            }
         } else {
            setSnackbarType('error');
            setSnackbarOpen(true)
            setSnackbarColor('var(--danger-color)')
            setSnackbarMsg(t('community.post.pdfSizeLimit'))
         }
      };
      pdfInput.click();
   };

   useEffect(() => {
      setCurrentUser(current_username)
   }, [current_username])

   useEffect(() => {
      if (post_id === resetThreadTextId){
         setNewThreadText('');
         setResetThreadTextId(null);
      }
   }, [resetThreadTextId])

   useEffect(() => {
      if (post_id === resetCommentTextId){
         setShowInputIndex(-1);
         setReplyText('');
         setReplyTo('');
         setIsReplyingNested(false);
         setResetCommentTextId(null);
      }
   }, [resetCommentTextId])

   useEffect(() => {
      if (post_id === resetPostEditTextId){
         setEditPostModal(false);
         setResetPostEditTextId(null);
      }
   }, [resetPostEditTextId])

   useEffect(() => {
      if (post_id === resetThreadEditTextId){
         setEditCommentThreadModal(false);
         setResetThreadEditTextId(null);
      }
   }, [resetThreadEditTextId])

   useEffect(() => {
      if (post_id === resetCommentEditTextId){
         setEditCommentModal(false);
         setResetCommentEditTextId(null);
      }
   }, [resetCommentEditTextId])
   // useEffect(() => {
   //    setWhoCanReplyTier(whoCanReply)
   // }, [whoCanReply])
   // const [commentSlice, setCommentSlice] = useState([0, 1]); // Initial state: display first 2 comments


   const timeString = time;
   const delta = getTimeDelta(timeString, t);
   // console.log(delta); // Example output: '2 days ago'
   // const commentsLength = threads.reduce((count, thread) => count + thread.comments.length, 0);
   // console.log(commentsLength)
   return (
      <div id={'post'+post_id} style={{padding: '20px 0px 10px 0px', backgroundColor: '#fff', borderRadius: '8px', position: 'relative'}}>

         <div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
            <Avatar alt={current_username} src={user_icon} style={{marginRight: '10px'}}/>
            <div>
               <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                  <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginRight: '2px' }}>
                     {TruncateWithEllipsis(display_name, 20)}
                  </Typography>


      <div style={{ minWidth: post_tier === 0 ? (subscription === 'Creator' ? '150px' : '150px') : (subscription === 'Creator' ? '300px' : '100px'), display: 'flex', marginBottom: '2px' }}>

                  {
                     subscription === 'Creator' && (
                        <BiSolidBadgeCheck style={{  fontSize: '16px', color: getBrandColor() }}/>
                     )
                     }


                     {/* who can reply */}

                     {post_tier === 0 ? '' : <span
                        style={{
                           margin: '0px 5px 0px 0px',
                           display: 'inline-flex',
                           alignItems: 'center',
                           backgroundColor: '#e1e4ff',
                           color: 'var(--brand-color)',
                           padding: '4px 8px',
                           fontSize: '11px',
                           fontWeight: '600',
                           borderRadius: '50px',
                        }}
                     >
                        {
                           window.innerWidth < 400 ?
                              <>
                                 {TruncateWithEllipsis(tierBadgeText, 16)}
                              </>
                              :
                              <>
                                 {
                                    window.innerWidth < 900 ?
                                       <>
                                          {TruncateWithEllipsis(tierBadgeText, 20)}
                                       </>
                                       :
                                       <>
                                          {TruncateWithEllipsis(tierBadgeText, 40)}
                                       </>
                                 }

                              </>

                        }

                     </span>}
                  </div>
               </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '2px', flexWrap: 'wrap' }}>
                   <Typography variant="body2" color="textSecondary" sx={{ fontSize: '12px', marginTop: '-2px' }}>
                      {getTimeDelta(time, t)}
                   </Typography>
                   {primaryCategory && (
      

<Typography variant="body2" color="textSecondary" sx={{ fontSize: '12px'}}>
{formatCategoryName(primaryCategory)}
</Typography>
                   )}
                </div>
               {/*<Button*/}
               { }
               {/*>*/}
               {/*   Delete*/}
               {/*</Button>*/}
            </div>
         </div>
         {
            pinnedPost ?
               <>
                  {
                     currentUser === influencer_name  ?
                        <DarkTooltip title={t('community.post.removePin')} placement="bottom">
                           <div style={{
                              position: 'absolute',
                              top: '25px',
                              right: '30px',
                              display: 'flex',
                              color: 'var(--brand-color)',
                              flexDirection: 'column',
                              alignItems: 'center',
                              cursor: 'pointer',
                           }}
                                onClick={() => {handleRemovePinnedPost(post_id, post_index);}}
                           >
                              <BsFillPinAngleFill style={{ fontSize: '18px' }}/>
                           </div>
                        </DarkTooltip>
                        :
                        <DarkTooltip title={t('community.post.pinnedPost')} placement="bottom">
                           <div style={{
                              position: 'absolute',
                              top: '25px',
                              right: content_type === 'txt' && currentUser !== username ? '0px' : '30px',
                              display: 'flex',
                              color: 'var(--brand-color)',
                              flexDirection: 'column',
                              alignItems: 'center',
                           }}>
                              <BsFillPinAngleFill style={{ fontSize: '18px' }}/>
                           </div>
                        </DarkTooltip>
                  }
               </>
               :
               null

         }
         {  currentUser === '' ?
            null
            :
            <>
               {  currentUser === username ?
                  <div style={{
                     position: 'absolute',
                     top: '25px',
                     right: '80px',
                     display: 'flex',
                     flexDirection: 'column',
                     alignItems: 'center',
                     cursor: 'pointer',
                     zIndex: 1001
                  }}
                       onClick={(event) => handlePostMenuOpen(event, 'postMenu', post_id, post_index)}
                  >
                     <HiOutlineDotsHorizontal

                     />
                  </div>
                  :
                  <>
                     {/* Influencer Delete Menu Here */}
                     {  currentUser === influencer_name ?
                        <div style={{
                           position: 'absolute',
                           top: '25px',
                           right: '80px',
                           display: 'flex',
                           flexDirection: 'column',
                           alignItems: 'center',
                           cursor: 'pointer',
                           zIndex: 1001
                        }}
                             onClick={(event) => handlePostMenuOpen(event, 'postMenuInfluencer', post_id, post_index)}
                        >
                           {/*<p>{t('community.deleteMenu')}</p>*/}
                           <HiOutlineDotsHorizontal/>
                        </div>
                        :
                        null
                     }
                  </>
               }
            </>
         }

         {/* Close button - only show on mobile */}
         {onClose && (!windowWidth || windowWidth < 900) && (
            <div style={{
               position: 'absolute',
               top: '22px',
               right: '0px',
               display: 'flex',
               flexDirection: 'row',
               alignItems: 'center',
               cursor: 'pointer',
               width: '24px',
               height: '24px',
               borderRadius: '50%',
               backgroundColor: 'rgba(0, 0, 0, 0.1)',
               justifyContent: 'center',
               transition: 'all 0.2s ease',
               zIndex: 1000
            }}
            onClick={onClose}
            >
               <IoClose
                  style={{
                     fontSize: '14px',
                     color: '#666',
                     transition: 'color 0.2s ease'
                  }}
               />
            </div>
         )}

         {/* Close button - only show on mobile */}
         {onClose && (
            <div style={{
               position: 'absolute',
               top: '22px',
               right: '0px',
               display: 'flex',
               flexDirection: 'row',
               alignItems: 'center',
               cursor: 'pointer',
               width: '24px',
               height: '24px',
               borderRadius: '50%',
               backgroundColor: 'rgba(0, 0, 0, 0.1)',
               justifyContent: 'center',
               transition: 'all 0.2s ease',
               zIndex: 1000
            }}
               onClick={onClose}
            >
               <IoClose
                  style={{
                     fontSize: '14px',
                     color: '#666',
                     transition: 'color 0.2s ease',
                     backgroundColor: 'none',
                  }}
               />
            </div>
         )}

         <div style={{position: 'absolute', top: '22px', right: '30px', display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer',
            borderRadius: '50px', backgroundColor: post_user_value_count === 1 ? '#eaebfd' : '#fff', padding: '2px 6px', zIndex: 1001}}
              onClick={
                 currentUser === '' ?

                    e => OpenSubscribePopup(
                       e,
                       influencer_info['icon_image_path'],
                       influencer_info['influencer'],
                       influencer_info['current_tier'],
                       '',
                       influencer_info['influencer_name'],
                       currency,
                    )
                    :

                    () => {

                       postLikeChange(post_id, post_index);
                       if (post_user_value_count === 0){
                           handleVote(post_id);
                        }
                  }
            }
         >

            <span
                    style={{cursor: 'pointer', fontSize: '16px', margin: '0px 3px 0px 0px',
                       color: post_user_value_count === 1 ? 'var(--brand-color)' : '#222'
                    }}
            >
               {post_user_value_count === 1 ? '👍' : '👍'}
            </span>
            <>{isExploding && explodingIndex === post_id &&
            <ConfettiExplosion
               zIndex={10000}
               onComplete={() => {setExplodingIndex(''); setIsExploding(false) }}
               duration={2300} force={0.15} particleCount={10} width={200} particleSize={6} colors={confettiColors}/>}</>
            <Typography variant="subtitle1"
                        style={{fontWeight: 'bold', fontSize: '15px', marginBottom: '0px', margin: '0px', lineHeight: '20px',
                           color: post_user_value_count === 1 ? 'var(--brand-color)' : '#222'}}>
               {/* post like count is the total like sum, user_like_value is the logged in user's value */}
                {post_like_count}
            </Typography>

            {/*<MdKeyboardArrowDown onClick={() => handleVote('down', post_id)} style={{marginTop: '0px', cursor: 'pointer', fontSize: '18px'}}/>*/}
         </div>

         <Typography className="text_content" variant="body1" style={{marginBottom: '16px', wordBreak: 'break-word', whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{ __html: text }}/>
         
         {/* Content */}
         <div>
            <>
               {(content_file || (link && ['mot', 'mzm', 'mgm', 'mmt', 'gos', 'god'].includes(content_type))) &&
               <div style={{ position: 'relative', padding: '0px 0px 0px 0px' }}>
                  {content_type === 'img' &&
                  <>
                  <ImagePost image_src={content_file} handleFullscreenOpen={handleFullscreenOpen}/>
                  </>
                  }
                  {content_type === 'vid' &&
                  <>
                  <div style={{ borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                     <VideoPost video_src={content_file}/>
                  </div>
                  </>

                  }
                  {content_type === 'vey' &&
                  <>
                  <div style={{ borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                     <YoutubePost video_src={content_file}/>
                  </div>
                  </>
                  }
                  {content_type === 'vel' &&
                  <>
                  <div style={{ borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                     <LoomPost video_src={content_file}/>
                  </div>
                  </>
                  }
                  {content_type === 'vev' &&
                  <>
                  <div style={{ borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                     <VimeoPost video_src={content_file}/>
                  </div>
                  </>
                  }
                  {content_type === 'vtw' &&
                  <>
                  <div style={{ borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                     <TwitchPost video_src={content_file}/>
                  </div>
                  </>
                  }
                  {content_type === 'vwi' &&
                  <>
                  <div style={{ borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                     <WistiaPost video_src={content_file}/>
                  </div>
                  </>
                  }
                  {['gos', 'god'].includes(content_type) &&
                     <Box
                        sx={{
                           display: 'flex',
                           alignItems: 'center',
                           height: '60px',
                           border: '1px solid #E4EBF6',
                           backgroundColor: '#fff',
                           borderRadius: '8px',
                           padding: '0 16px',
                           marginBottom: '16px',
                           position: 'relative'
                        }}
                     >
                        {content_type === 'gos' && <img src={GoogleSheetsImage} alt={t('dashboard.paidDms.googleSheets')} style={{ width: '24px', marginRight: '16px' }} />}
                        {content_type === 'god' && <img src={GoogleDocsImage} alt={t('dashboard.paidDms.googleDocs')} style={{ width: '24px', marginRight: '16px' }} />}
                        <Box sx={{ flexGrow: 1 }}>
                           <p style={{ fontWeight: 500, fontFamily: 'Roboto', color: '#000', margin: 0 }}>
                              {content_type === 'gos' && 'Google Sheets'}
                              {content_type === 'god' && 'Google Docs'}
                           </p>
                        </Box>

                        <Button
                           variant="contained"
                           disableElevation
                           onClick={() => handleFullscreenOpen(normalizeExternalHref(link), content_type)}
                           rel="noopener noreferrer"
                           sx={{
                              padding: '5px 7px',
                              display: 'inline-block',
                              marginLeft: 'auto',
                              borderRadius: '8px !important',
                              textTransform: 'none',
                              textAlign: 'center',
                              backgroundColor: 'var(--brand-color)',
                              '&:hover': {
                                 backgroundColor: 'var(--brand-color-hover)'
                              },
                              cursor: 'pointer'
                           }}>
                           <span className="fa fa-search" style={{ fontWeight: '500', fontSize: '14px' }}>
                              Open
                           </span>
                        </Button>
                     </Box>
                  }
                  {content_type === 'aud' &&

                  <div style={{ position: 'relative' }}>
                     <AudioPost audio_src={content_file}/>
                  </div>
                  }
                  {content_type === 'pdf' &&
                  <>
                     <PDFPost fullscreen={fullscreenViewOpen} pdf_src={content_file} content_width_type={'post'} handleFullscreenPDFOpen={handleFullscreenPDFOpen}/>
                  </>
                  }
               </div>
               }
               {(link && ['mot', 'mgm', 'mzm', 'mmt'].includes(content_type)) &&
               <>
                  <div style={{ position: 'relative', padding: '0px' }}>
                     <Box
                        sx={{
                           display: 'flex',
                           alignItems: 'center',
                           height: '60px',
                           border: '1px solid #E4EBF6',
                           backgroundColor: '#fff',
                           position: 'relative',
                           borderRadius: '8px',
                           padding: '0 16px',
                           marginBottom: '16px'
                        }}
                     >
                        {content_type === 'mot' && <FaLink style={{ width: '24px', marginRight: '16px', color: '#6C89AF' }} />}
                        {content_type === 'mgm' && <img src={GoogleMeetImage} alt={t('community.composer.googleMeet')} style={{ width: '24px', marginRight: '16px' }} />}
                        {content_type === 'mmt' && <img src={MicrosoftTeams} alt={t('community.composer.microsoftTeams')} style={{ width: '24px', marginRight: '16px' }} />}
                        {content_type === 'mzm' && <img src={ZoomImage} alt={t('profile.zoom')} style={{ width: '24px', marginRight: '16px' }} />}
                        <Box sx={{ flexGrow: 1 , display: 'flex', alignItems: 'center'}}>
                           <p style={{ fontWeight: 500, fontFamily: 'Roboto', color: '#000', margin: 0 }}>
                              {content_type === 'mot' && 'Meeting'}
                              {content_type === 'mgm' && 'Google Meet'}
                              {content_type === 'mmt' && 'Microsoft Teams'}
                              {content_type === 'mzm' && 'Zoom'}
                           </p>
                           {/* <p style={{ color: '#6C89AF', fontSize: '0.75rem', fontWeight: '500', margin: '2px 0px 0px 0px' }}>
                              {content_type === 'mzm' ? 'Tomorrow at 10:00 AM' : 'Today at 3:00 PM'}
                           </p> */}
                        </Box>

                        <span style={{ display: 'inline-flex', marginLeft: 'auto' }}>
                           <Button
                              variant="contained"
                              disableElevation
                              // Joinable at any time, matching the feed card (EventPost.js).
                              // The old `!canJoinEvent` gate only opened in the hour BEFORE
                              // the start and closed again the moment the event began, so a
                              // live call - or one people join late - could not be joined.
                              onClick={(e) => {
                                 window.open(normalizeExternalHref(link), '_blank', 'noopener,noreferrer');
                              }}
                              sx={{
                                 padding: '5px 7px',
                                 display: 'inline-block',
                                 borderRadius: '8px !important',
                                 textTransform: 'none',
                                 textAlign: 'center',
                                 backgroundColor: 'var(--brand-color)',
                                 '&:hover': {
                                    backgroundColor: 'var(--brand-color-hover)'
                                 },
                                 cursor: 'pointer'
                              }}
                           >
                              <span className="fa fa-search" style={{ fontWeight: '500', fontSize: '14px' }}>
                                 {t('community.post.join')}
                              </span>
                           </Button>
                        </span>
                     </Box>
                  </div>
                  
                  {/* Add to Calendar is always offered now. It used to sit behind
                      `!canJoinEvent` alongside a "button enabled 1 hour before" hint;
                      the button no longer waits, so the hint would be untrue. */}
                  <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', marginTop: '-5px', marginBottom: '16px' }}>
                        <Button
                           variant="outlined"
                           size="small"
                           onClick={(e) => {
                              e.stopPropagation();
                              handleAddToCalendar();
                           }}
                           startIcon={<TbPlus style={{ fontSize: '14px' }} />}
                           sx={{
                              borderColor: '#E4EBF6',
                              color: '#1D1D1D',
                              textTransform: 'none',
                              fontWeight: '500',
                              fontSize: '11px',
                              padding: '4px 8px',
                              borderRadius: '6px',
                              minWidth: 'auto',
                              height: '24px',
                              '&:hover': {
                                 borderColor: '#C7D1DE',
                                 backgroundColor: '#F9FAFB'
                              }
                           }}
                        >
                           {t('community.post.addToCalendar')}
                        </Button>
                  </div>

                  {content_file && (
                     <Box sx={{ margin: '16px 0px 0px 0px' }}>
                        <ImagePost image_src={content_file} handleFullscreenOpen={handleFullscreenOpen}/>
                     </Box>
                  )}
               </>
               }
            </>
         </div>
         <div style={{ borderTop: '1px solid #f5f5f5', paddingTop: '10px' }}>

            {/* Comment section (top 2 comments displayed), nested comments only in expanded view and primarily where discussion happens */}
            <List>
               {
                  n_threads > threads.length ?
                     <Button
                     sx={{
                        backgroundColor: 'transparent',
                        fontSize: '12px',
                        padding: '0',
                        margin: '0px 0px 10px 0px',
                        textAlign: 'left',
                        textTransform: 'uppercase',
                        color: 'var(--brand-color)',
                        minWidth: '0px',
                        '&:hover': {
                           textDecoration: 'underline',
                           backgroundColor: '#fff'
                        },
                        '.MuiButton-text': {
                           textTransform: 'uppercase',
                        },
                     }}
                     // need to add click to load more previous threads
                     onClick={() => {
                        loadAdditionalThreads(post_id, post_index)
                     }}
                  >
                     Load previous
                  </Button> : ''
               }

               {/*{*/}
               {/*   threads.length > 2 ?*/}

               {/*      <Button*/}
               {/*         color="primary"*/}
               {/*         sx={{*/}
               {/*            backgroundColor: 'transparent',*/}
               {/*            fontSize: '12px',*/}
               {/*            padding: '0',*/}
               {/*            margin: '3px 0px 0px 0px',*/}
               {/*            textAlign: 'left',*/}
               {/*            textTransform: 'uppercase',*/}
               {/*            color: 'var(--brand-color)',*/}
               {/*            minWidth: '0px',*/}
               {/*            '&:hover': {*/}
               {/*               textDecoration: 'underline',*/}
               {/*               backgroundColor: '#fff'*/}
               {/*            },*/}
               {/*            '.MuiButton-text': {*/}
               {/*               textTransform: 'uppercase',*/}
               {/*            },*/}
               {/*         }}*/}
               {/*         // onClick={() => {*/}
               {/*         //    setLatestOpenCount(2)*/}
               {/*         //    setExpandedThreads(expandedThreads.filter((i) => i !== index));*/}
               {/*         // }}*/}
               {/*      >*/}
               {/*         Hide previous <FiChevronUp style={{fontSize: '14px'}}/>*/}
               {/*      </Button>: ''*/}

               {/*}*/}


               {/* Threads */}
               {[...threads].reverse().map((thread, index) => {
                  const reversedIndex = threads.length - 1 - index;
                  return (<div
                        style={{
                           display: 'flex',
                           flexDirection: 'column',
                           margin: '5px 0px',
                           boxSizing: 'border-box',
                        }}
                        key={index}
                     >
                        <div style={{ display: 'flex', marginBottom: '10px' }}>
                           <Avatar alt={current_username} src={thread.user_icon} style={{ margin: '8px 10px 0px 0px' }} />
                           <div style={{ width: '100%', boxSizing: 'border-box' }}>
                              <div style={{ backgroundColor: '#F5F9FF', borderRadius: '10px', boxSizing: 'border-box', padding: '8px 10px', position: 'relative' }}>
                                 <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginRight: '6px' }}>
                                       {TruncateWithEllipsis(thread.user_display_name, 20)}
                                    </Typography>

                                 {
                                    window.innerWidth > 450 ?
                                       <Typography variant="body2" color="textSecondary" sx={{ fontSize: '12px', marginTop: '-2px' }}>
                                          {getTimeDelta(thread.time, t)}
                                       </Typography>
                                       :
                                       null
                                 }




                                 {/* <span style={{ fontSize: '12px', fontWeight: '500', color: '#b2bdd2', marginLeft: '8px' }}>{getTimeDelta(thread.time, t)}</span> */}
                              </div>

                              {
                                    window.innerWidth <= 450 ?
                                    <Typography variant="body2" color="textSecondary" sx={{ fontSize: '12px', marginTop: '0px' }}>
                                    {getTimeDelta(thread.time, t)}
                                    </Typography>
                                       :
                                       null
                                 }

                              


                              <Typography className="text_content" variant="body2" style={{ width: '90%', minWidth: '90%', maxWidth: '90%', wordBreak: 'break-word' }}>
                                 <Linkify options={{target:"_blank"}}>
                                    {thread.text.split('\n').map((line, index) => (
                                       <React.Fragment key={index}>
                                          {line}
                                          <br />
                                       </React.Fragment>
                                    ))}
                                    </Linkify>
                                 </Typography>
                                 <>
                                    {  currentUser === '' ?
                                       null
                                       :
                                       <>
                                          {  currentUser === thread.user ?
                                             <div style={{
                                                position: 'absolute',
                                                top: '12px',
                                                right: '45px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                             }}
                                                  onClick={(event) => handleThreadMenuOpen(event, 'threadMenu', thread.id, post_index, reversedIndex, thread.text)}
                                             >
                                                <HiOutlineDotsHorizontal/>
                                             </div>
                                             :
                                             <>
                                                {/* Influencer Delete Menu Here */}
                                                {  currentUser === influencer_name ?
                                                   <div style={{
                                                      position: 'absolute',
                                                      top: '12px',
                                                      right: '45px',
                                                      display: 'flex',
                                                      flexDirection: 'column',
                                                      alignItems: 'center',
                                                      cursor: 'pointer',
                                                   }}
                                                        onClick={(event) => handleThreadMenuOpen(event, 'threadMenuInfluencer', thread.id, post_index, reversedIndex, thread.text)}
                                                   >
                                                      {/*<p>{t('community.deleteMenu')}</p>*/}
                                                      <HiOutlineDotsHorizontal

                                                      />
                                                   </div>
                                                   :
                                                   null
                                                }
                                             </>
                                          }
                                       </>
                                    }


                              {/* Thread Content */}
                              <div>
                                 <>
                                    {(thread.file ||  (['mot', 'mzm', 'mgm', 'mmt', 'gos', 'god'].includes(thread.content_type) && thread.link)) &&
                                       <div style={{ position: 'relative', padding: '10px 0px 0px 0px' }}>
                                          {thread.content_type === 'img' &&
                                             <>
                                                <ImagePost image_src={thread.file} handleFullscreenOpen={handleFullscreenOpen} />
                                          </>

                                          }
                                          {thread.content_type === 'vid' &&

                                          <div style={{ borderRadius: '8px', overflow: 'hidden' }}>
                                             <VideoPost video_src={thread.file}/>
                                          </div>
                                          }
                                          {thread.content_type === 'vey' &&
                                          <>
                                          <div style={{ borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                                             <YoutubePost video_src={thread.file}/>
                                          </div>
                                          </>
                                          }
                                          {thread.content_type === 'vel' &&
                                          <>
                                          <div style={{ borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                                             <LoomPost video_src={thread.file}/>
                                          </div>
                                          </>
                                          }
                                          {thread.content_type === 'vev' &&
                                          <>
                                          <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                                             <iframe
                                                src={"https://player.vimeo.com/video/" + thread.file}
                                                frameborder="0"
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowfullscreen
                                                style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                             ></iframe>
                                          </div>
                                          </>
                                          }
                                          {thread.content_type === 'vtw' && thread.file &&
                                          <>
                                          <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                                             <iframe
                                                src={
                                                   thread.file.startsWith('ch')
                                                      ? "https://player.twitch.tv/?channel=" + thread.file.slice(2) + "&parent=" + window.location.hostname
                                                      : thread.file.startsWith('c')
                                                      ? "https://clips.twitch.tv/embed?clip=" + thread.file.slice(1) + "&parent=" + window.location.hostname
                                                      : "https://player.twitch.tv/?video=" + thread.file.slice(1) + "&parent=" + window.location.hostname
                                                }
                                                frameborder="0"
                                                allow="autoplay; fullscreen"
                                                allowfullscreen
                                                style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                             ></iframe>
                                          </div>
                                          </>
                                          }
                                          {thread.content_type === 'vwi' &&
                                          <>
                                          <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                                             <iframe
                                                src={"https://fast.wistia.com/embed/iframe/" + thread.file + "?autoPlay=false"}
                                                frameborder="0"
                                                allow="autoplay; fullscreen"
                                                allowfullscreen
                                                style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                             ></iframe>
                                          </div>
                                          </>
                                          }
                                          {['gos', 'god'].includes(thread.content_type) &&
                                          <Box
                                             sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                height: '60px',
                                                border: '1px solid #E4EBF6',
                                                backgroundColor: '#fff',
                                                borderRadius: '8px',
                                                padding: '0 16px',
                                                marginBottom: '16px',
                                                position: 'relative'
                                             }}
                                          >
                                             {thread.content_type === 'gos' && <img src={GoogleSheetsImage} alt={t('dashboard.paidDms.googleSheets')} style={{ width: '24px', marginRight: '16px' }} />}
                                             {thread.content_type === 'god' && <img src={GoogleDocsImage} alt={t('dashboard.paidDms.googleDocs')} style={{ width: '24px', marginRight: '16px' }} />}
                                             <Box sx={{ flexGrow: 1 }}>
                                                <p style={{ fontWeight: 500, fontFamily: 'Roboto', color: '#000', margin: 0 }}>
                                                   {thread.content_type === 'gos' && 'Google Sheets'}
                                                   {thread.content_type === 'god' && 'Google Docs'}
                                                </p>
                                             </Box>

                                             <Button
                                                variant="contained"
                                                disableElevation
                                                onClick={() => handleFullscreenOpen(normalizeExternalHref(thread.link), thread.content_type)}
                                                rel="noopener noreferrer"
                                                sx={{
                                                   padding: '5px 7px',
                                                   display: 'inline-block',
                                                   marginLeft: 'auto',
                                                   borderRadius: '8px !important',
                                                   textTransform: 'none',
                                                   textAlign: 'center',
                                                   backgroundColor: 'var(--brand-color)',
                                                   '&:hover': {
                                                      backgroundColor: 'var(--brand-color-hover)'
                                                   },
                                                   cursor: 'pointer'
                                                }}>
                                                <span className="fa fa-search" style={{ fontWeight: '500', fontSize: '14px' }}>
                                                   Open
                                                </span>
                                             </Button>
                                          </Box>
                                          }
                                          {thread.content_type === 'aud' &&
                                          <div style={{ position: 'relative' }}>

                                          <div className="image_container"
                                             style={{
                                                // width: '100%',
                                                position: 'relative'
                                             }}
                                          >
                                          
                                             {/*<img className={'image'}  src={audioPreviewUrl} alt={t('common.audioFile')} />*/}
                                             <ReactAudioPlayer
                                                className='react-player'
                                                src={paths.CONTENT_CLOUDFRONT + thread.file}
                                                // autoPlay
                                                controls
                                                style={{ width: '100%', margin: '0px', borderRadius: '0px' }}
                                                // onLoadedMetadata={handleAudioLoadMetadata}
                                             />
                                          </div>

                                          </div>
                                          }
                                          {thread.content_type === 'pdf' &&
                                          <>
                                          <PDFPost fullscreen={fullscreenViewOpen} pdf_src={thread.file} content_width_type={'thread'} handleFullscreenPDFOpen={handleFullscreenPDFOpen}/>
                                          </>
                                          }
                                          {(thread.link && ['mot', 'mgm', 'mzm', 'mmt'].includes(thread.content_type)) &&
                                          <div style={{ position: 'relative', padding: '0px' }}>
                                          <Box
                                             sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                height: '60px',
                                                border: '1px solid #E4EBF6',
                                                backgroundColor: '#fff',
                                                borderRadius: '8px',
                                                padding: '0 16px',
                                             }}
                                          >
                                             {thread.content_type === 'mot' && <FaLink style={{ width: '24px', marginRight: '16px', color: '#6C89AF' }} />}
                                             {thread.content_type === 'mgm' && <img src={GoogleMeetImage} alt={t('community.composer.googleMeet')} style={{ width: '24px', marginRight: '16px' }} />}
                                             {thread.content_type === 'mmt' && <img src={MicrosoftTeams} alt={t('community.composer.microsoftTeams')} style={{ width: '24px', marginRight: '16px' }} />}
                                             {thread.content_type === 'mzm' && <img src={ZoomImage} alt={t('profile.zoom')} style={{ width: '24px', marginRight: '16px' }} />}
                                             <Box sx={{ flexGrow: 1 , display: 'flex', alignItems: 'center'}}>
                                                <p style={{ fontWeight: 500, fontFamily: 'Roboto', color: '#000', margin: 0 }}>
                                                   {thread.content_type === 'mot' && 'Meeting'}
                                                   {thread.content_type === 'mgm' && 'Google Meet'}
                                                   {thread.content_type === 'mmt' && 'Microsoft Teams'}
                                                   {thread.content_type === 'mzm' && 'Zoom'}
                                                </p>
                                             </Box>
                                             <Button
                                                                  variant="contained"
                                                                  disableElevation
                                                                  // onClick={() => window.open(thread.link, '_blank', 'noopener,noreferrer')}
                                                                  href={normalizeExternalHref(thread.link)}
                                                                  target="_blank"
                                                                  rel="noopener noreferrer"
                                                                  sx={{
                                                                     padding: '5px 7px',
                                                                     display: 'inline-block',
                                                                     marginLeft: 'auto',
                                                                     borderRadius: '8px !important',
                                                                     textTransform: 'none',
                                                                     textAlign: 'center',
                                                                     backgroundColor: 'var(--brand-color)',
                                                                     '&:hover': {
                                                                        backgroundColor: 'var(--brand-color-hover)'
                                                                     },
                                                                     cursor: 'pointer'
                                                                  }}>

                                                                  <span className="fa fa-search" style={{ fontWeight: '500', fontSize: '14px' }}>
                                                                     {t('community.post.join')}
                                                                  </span>
                                                               </Button>
                                          </Box>
                                          </div>}

                                       </div>
                                       }
                                    </>
                                 </div>

                                    <div style={{position: 'absolute', top: '8px', right: '5px', display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer',
                                       borderRadius: '50px',  padding: '2px 6px'}}

                                         onClick={
                                            currentUser === '' ?
                                               e => OpenSubscribePopup(
                                                  e,
                                                  influencer_info['icon_image_path'],
                                                  influencer_info['influencer'],
                                                  influencer_info['current_tier'],
                                                  '',
                                                  influencer_info['influencer_name'],
                                                  currency,
                                               )
                                               :
                                               () => {
                                                   threadLikeChange(thread.id, post_index, reversedIndex); 
                                                   if (thread.user_like_value === 0){
                                                      handleVote(thread.id);
                                                   }
                                                }
                                         }
                                    >
                                       <span
                                               style={{marginBottom: '0px', cursor: 'pointer', fontSize: '14px', marginRight: '3px',
                                                  color: thread.user_like_value === 1 ? 'var(--brand-color)' : '#222'

                                               }}>
                                          {thread.user_like_value === 1 ? '👍' : '👍'}
                                       </span>
                                       <>{isExploding && explodingIndex === thread.id &&
                                          <ConfettiExplosion zIndex={10000}
                                          onComplete={() => {setExplodingIndex(''); setIsExploding(false) }}

                                                         duration={2800} force={0.15} particleCount={10} width={200} particleSize={6}
                                                         colors={confettiColors}/>}</>
                                       <Typography variant="subtitle1" style={{
                                          fontWeight: 'bold',
                                          fontSize: '12px',
                                          marginBottom: '0px',
                                          margin: '0px',
                                          lineHeight: '20px',
                                          color: thread.user_like_value === 1 ? 'var(--brand-color)' : '#222'
                                       }}>
                                          {thread.like_count}
                                       </Typography>
                                    </div>
                                 </>
                              </div>

                              <Button
                                 color="primary"
                                 sx={{
                                    backgroundColor: 'transparent',
                                    fontSize: '12px',
                                    padding: '0',
                                    margin: '3px 0px 0px 10px',
                                    textAlign: 'left',
                                    textTransform: 'uppercase',
                                    color: 'var(--brand-color)',
                                    minWidth: '0px',
                                    '&:hover': {
                                       backgroundColor: '#fff',
                                       textDecoration: 'underline'
                                    },
                                    '.MuiButton-root MuiButton-text': {
                                       textTransform: 'uppercase',
                                    },
                                 }}
                                 onClick={

                                    // If not logged in show sub modal, if logged in reply
                                    currentUser === '' ?
                                       e => OpenSubscribePopup(
                                       e,
                                       influencer_info['icon_image_path'],
                                       influencer_info['influencer'],
                                       influencer_info['current_tier'],
                                       '',
                                       influencer_info['influencer_name'],
                                       currency,
                                    )
                                       :
                                       () => {
                                          handleReplyClick(index, thread.user);
                                          setIsReplyingNested(true);
                                       }
                                 }
                                 onMouseEnter={() => handleReplyMouseEnter(index)}
                                 onMouseLeave={handleReplyMouseLeave}
                              >
                                 {t('community.post.reply')}
                              </Button>


                              {/* Thread Comments */}
                              {thread.comments && thread.n_comments > 0 && (
                                 <div className={'feed-padding'}>
                                    {latestOpenCount === thread.n_comments || thread.n_comments <= 1 ?
                                       null
                                       :
                                       <Button
                                          color="primary"
                                          sx={{
                                             backgroundColor: 'transparent',
                                             fontSize: '12px',
                                             padding: '0',
                                             margin: '3px 10px 0px 0px',
                                             textAlign: 'left',
                                             textTransform: 'uppercase',
                                             color: 'var(--brand-color)',
                                             minWidth: '0px',
                                             '&:hover': {
                                                textDecoration: 'underline',
                                                backgroundColor: '#fff'
                                             },
                                             '.MuiButton-text': {
                                                textTransform: 'uppercase',
                                             },
                                          }}
                                          onClick={() => {
                                             loadAdditionalComments(thread.id, post_index, reversedIndex);
                                             setExpandedThreads([...expandedThreads, index]);
                                             setLatestOpenCount(thread.comments.length)
                                          }}
                                       >
                                          Load previous <FiChevronDown style={{ fontSize: '14px' }}/>
                                       </Button>

                                    }


                                    {thread.n_comments > 1 && (
                                       <>
                                          {expandedThreads.includes(index) && (
                                             <Button
                                                color="primary"
                                                sx={{
                                                   backgroundColor: 'transparent',
                                                   fontSize: '12px',
                                                   padding: '0',
                                                   margin: '3px 0px 0px 0px',
                                                   textAlign: 'left',
                                                   textTransform: 'uppercase',
                                                   color: 'var(--brand-color)',
                                                   minWidth: '0px',
                                                   '&:hover': {
                                                      textDecoration: 'underline',
                                                      backgroundColor: '#fff'
                                                   },
                                                   '.MuiButton-text': {
                                                      textTransform: 'uppercase',
                                                   },
                                                }}
                                                onClick={() => {
                                                   setExplodingIndex('')
                                                   setLatestOpenCount(1)
                                                   setExpandedThreads(expandedThreads.filter((i) => i !== index));
                                                }}
                                             >
                                                Hide previous <FiChevronUp style={{ fontSize: '14px' }}/>
                                             </Button>
                                          )}
                                       </>
                                    )}


                                    {expandedThreads.includes(index) ? (
                                       // Expanded thread is open and all comments are rendered
                                       [...thread.comments].reverse().map((nestedComment, nestedIndex) => {
                                          const reversedNestedIndex = [...thread.comments].length - 1 - nestedIndex;
                                          return (
                                          <div
                                             style={{
                                                display: 'flex',
                                                marginBottom: '10px',
                                                position: 'relative',
                                             }}
                                             key={nestedIndex} 
                                          >
                                             <Avatar
                                                alt={current_username}
                                                src={nestedComment.user_icon}
                                                style={{ margin: '8px 10px 0px 0px' }}
                                             />
                                             <div style={{ width: '100%', boxSizing: 'border-box' }}>
                                                <div
                                                   style={{
                                                      backgroundColor: '#F5F9FF',
                                                      borderRadius: '10px',
                                                      boxSizing: 'border-box',
                                                      padding: '8px 10px',
                                                      position: 'relative',
                                                   }}
                                                > <div style={{ display: 'flex', alignItems: 'center' }}>
                                                   <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginRight: '6px' }}>
                                                      {TruncateWithEllipsis(nestedComment.commenter_display_name, 20)}



                                                      </Typography>
                                                      {
                                                            window.innerWidth > 450 ?
                                                               <Typography variant="body2" color="textSecondary" sx={{ fontSize: '12px', marginTop: '-2px' }}>
                                                                  {getTimeDelta(nestedComment.time, t)}
                                                               </Typography>
                                                               :
                                                               null
                                                         }
                                                      </div>

                                                     
                                                      {
                                                         window.innerWidth <= 450 ?
                                                            <Typography variant="body2" color="textSecondary" sx={{ fontSize: '12px', marginTop: '0px' }}>
                                                               {getTimeDelta(nestedComment.time, t)}
                                                            </Typography>
                                                            :
                                                            null
                                                      }

                                                      <Typography className="text_content" variant="body2" style={{ width: '90%', wordBreak: 'break-word' }}>
                                                         <Linkify options={{ target: "_blank" }}>
                                                            {nestedComment.text.split('\n').map((line, index) => (
                                                               <React.Fragment key={index}>
                                                            {line}
                                                            <br />
                                                         </React.Fragment>
                                                      ))}
                                                      </Linkify>
                                                   </Typography>
                                                   <>

                                                      {  currentUser === '' ?
                                                         null
                                                         :
                                                         <>
                                                            {  currentUser === nestedComment.commenter ?
                                                               <div
                                                                  onClick={(event) => {handleCommentMenuOpen(event, 'commentMenu', nestedComment.id, post_index, reversedIndex, reversedNestedIndex, nestedComment['text'])}}

                                                                  style={{
                                                                     position: 'absolute',
                                                                     top: '12px',
                                                                     right: '45px',
                                                                     display: 'flex',
                                                                     flexDirection: 'column',
                                                                     alignItems: 'center',
                                                                     cursor: 'pointer',
                                                                  }}
                                                               >
                                                                  <HiOutlineDotsHorizontal />
                                                               </div>
                                                               :
                                                               <>
                                                                  {/* Influencer Delete Menu Here */}
                                                                  {  currentUser === influencer_name ?
                                                                     <div style={{
                                                                        position: 'absolute',
                                                                        top: '12px',
                                                                        right: '45px',
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        alignItems: 'center',
                                                                        cursor: 'pointer',
                                                                     }}
                                                                          onClick={(event) => {handleCommentMenuOpen(event, 'commentMenuInfluencer', nestedComment.id, post_index, reversedIndex, reversedNestedIndex, nestedComment['text'])}}
                                                                     >
                                                                        <HiOutlineDotsHorizontal/>
                                                                     </div>
                                                                     :
                                                                     null
                                                                  }
                                                               </>
                                                            }
                                                         </>
                                                      }


                                                {/* Nested Comment Content */}
                                                <div>
                                                      <>
                                                         {(nestedComment.file || (['mot', 'mzm', 'mgm', 'mmt', 'gos', 'god'].includes(nestedComment.content_type) && nestedComment.link)) &&
                                                         <div style={{ position: 'relative', padding: '10px 0px 0px 0px' }}>
                                                            {nestedComment.content_type === 'img' &&
                                                            <>
                                                               <ImagePost image_src={nestedComment.file} handleFullscreenOpen={handleFullscreenOpen}/>
                                                            </>
                                                            }
                                                            {nestedComment.content_type === 'vid' &&
                                                               <div style={{ borderRadius: '8px', overflow: 'hidden' }}>
                                                                  <VideoPost video_src={nestedComment.file}/>
                                                               </div>
                                                            }
                                                            {nestedComment.content_type === 'vey' &&
                                                               <>
                                                               <div style={{ borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                                                                  <YoutubePost video_src={nestedComment.file}/>
                                                               </div>
                                                               </>
                                                            }
                                                            {nestedComment.content_type === 'vel' &&
                                                               <>
                                                               <div style={{ borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                                                                  <LoomPost video_src={nestedComment.file}/>
                                                               </div>
                                                               </>
                                                            }
                                                            {nestedComment.content_type === 'vev' &&
                                                               <>
                                                               <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                                                                  <iframe
                                                                     src={"https://player.vimeo.com/video/" + nestedComment.file}
                                                                     frameborder="0"
                                                                     allow="autoplay; fullscreen; picture-in-picture"
                                                                     allowfullscreen
                                                                     style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                                                  ></iframe>
                                                               </div>
                                                               </>
                                                            }
                                                            {nestedComment.content_type === 'vtw' && nestedComment.file &&
                                                               <>
                                                               <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                                                                  <iframe
                                                                     src={
                                                                        nestedComment.file.startsWith('ch')
                                                                           ? "https://player.twitch.tv/?channel=" + nestedComment.file.slice(2) + "&parent=" + window.location.hostname
                                                                           : nestedComment.file.startsWith('c')
                                                                           ? "https://clips.twitch.tv/embed?clip=" + nestedComment.file.slice(1) + "&parent=" + window.location.hostname
                                                                           : "https://player.twitch.tv/?video=" + nestedComment.file.slice(1) + "&parent=" + window.location.hostname
                                                                     }
                                                                     frameborder="0"
                                                                     allow="autoplay; fullscreen"
                                                                     allowfullscreen
                                                                     style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                                                  ></iframe>
                                                               </div>
                                                               </>
                                                            }
                                                            {nestedComment.content_type === 'vwi' &&
                                                               <>
                                                               <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                                                                  <iframe
                                                                     src={"https://fast.wistia.com/embed/iframe/" + nestedComment.file + "?autoPlay=false"}
                                                                     frameborder="0"
                                                                     allow="autoplay; fullscreen"
                                                                     allowfullscreen
                                                                     style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                                                  ></iframe>
                                                               </div>
                                                               </>
                                                            }
                                                            {['gos', 'god'].includes(nestedComment.content_type) &&
                                                               <Box
                                                                  sx={{
                                                                     display: 'flex',
                                                                     alignItems: 'center',
                                                                     height: '60px',
                                                                     border: '1px solid #E4EBF6',
                                                                     backgroundColor: '#fff',
                                                                     borderRadius: '8px',
                                                                     padding: '0 16px',
                                                                     marginBottom: '16px',
                                                                     position: 'relative'
                                                                  }}
                                                               >
                                                                  {nestedComment.content_type === 'gos' && <img src={GoogleSheetsImage} alt={t('dashboard.paidDms.googleSheets')} style={{ width: '24px', marginRight: '16px' }} />}
                                                                  {nestedComment.content_type === 'god' && <img src={GoogleDocsImage} alt={t('dashboard.paidDms.googleDocs')} style={{ width: '24px', marginRight: '16px' }} />}
                                                                  <Box sx={{ flexGrow: 1 }}>
                                                                     <p style={{ fontWeight: 500, fontFamily: 'Roboto', color: '#000', margin: 0 }}>
                                                                        {nestedComment.content_type === 'gos' && 'Google Sheets'}
                                                                        {nestedComment.content_type === 'god' && 'Google Docs'}
                                                                     </p>
                                                                  </Box>

                                                                  <Button
                                                                     variant="contained"
                                                                     disableElevation
                                                                     onClick={() => handleFullscreenOpen(normalizeExternalHref(nestedComment.link), nestedComment.content_type)}
                                                                     rel="noopener noreferrer"
                                                                     sx={{
                                                                        padding: '5px 7px',
                                                                        display: 'inline-block',
                                                                        marginLeft: 'auto',
                                                                        borderRadius: '8px !important',
                                                                        textTransform: 'none',
                                                                        textAlign: 'center',
                                                                        backgroundColor: 'var(--brand-color)',
                                                                        '&:hover': {
                                                                           backgroundColor: 'var(--brand-color-hover)'
                                                                        },
                                                                        cursor: 'pointer'
                                                                     }}>
                                                                     <span className="fa fa-search" style={{ fontWeight: '500', fontSize: '14px' }}>
                                                                        Open
                                                                     </span>
                                                                  </Button>
                                                               </Box>
                                                            }
                                                            {nestedComment.content_type === 'aud' &&

                                                            <div style={{ position: 'relative' }}>

                                                               <div className="image_container"
                                                                    style={{
                                                                       position: 'relative'
                                                                    }}
                                                               >
                                                         
                                                                  <ReactAudioPlayer
                                                                     className='react-player'
                                                                     src={paths.CONTENT_CLOUDFRONT + nestedComment.file}
                                                                     controls
                                                                     style={{ width: '100%', margin: '0px', borderRadius: '0px' }}
                                                                  />
                                                               </div>
                                                            </div>
                                                            }
                                                            {nestedComment.content_type === 'pdf' &&
                                                            <>
                                                               <PDFPost fullscreen={fullscreenViewOpen} pdf_src={nestedComment.file} content_width_type={'comment'} handleFullscreenPDFOpen={handleFullscreenPDFOpen}/>
                                                            </>
                                                            }
     
                                                            {(nestedComment.link && ['mot', 'mgm', 'mzm', 'mmt'].includes(nestedComment.content_type)) &&
                                                            <div style={{ position: 'relative', padding: '0px' }}>
                                                               <Box
                                                                  sx={{
                                                                     display: 'flex',
                                                                     alignItems: 'center',
                                                                     height: '60px',
                                                                     border: '1px solid #E4EBF6',
                                                                     backgroundColor: '#fff',
                                                                     borderRadius: '8px',
                                                                     padding: '0 16px',
                                                                     // marginBottom: '16px'
                                                                  }}
                                                               >
                                                                  {nestedComment.content_type === 'mot' && <FaLink style={{ width: '24px', marginRight: '16px', color: '#6C89AF' }} />}
                                                                  {nestedComment.content_type === 'mgm' && <img src={GoogleMeetImage} alt={t('community.composer.googleMeet')} style={{ width: '24px', marginRight: '16px' }} />}
                                                                  {nestedComment.content_type === 'mmt' && <img src={MicrosoftTeams} alt={t('community.composer.microsoftTeams')} style={{ width: '24px', marginRight: '16px' }} />}
                                                                  {nestedComment.content_type === 'mzm' && <img src={ZoomImage} alt={t('profile.zoom')} style={{ width: '24px', marginRight: '16px' }} />}
                                                                  <Box sx={{ flexGrow: 1 , display: 'flex', alignItems: 'center'}}>
                                                                              <p style={{ fontWeight: 500, fontFamily: 'Roboto', color: '#000', margin: 0 }}>
                                                                                 {nestedComment.content_type === 'mot' && 'Meeting'}
                                                                                 {nestedComment.content_type === 'mgm' && 'Google Meet'}
                                                                                 {nestedComment.content_type === 'mmt' && 'Microsoft Teams'}
                                                                                 {nestedComment.content_type === 'mzm' && 'Zoom'}
                                                                              </p>
                                                                              <Button
                                                                                 variant="contained"
                                                                                 disableElevation
                                                                                 href={normalizeExternalHref(nestedComment.link)}
                                                                                 target="_blank"
                                                                                 rel="noopener noreferrer"
                                                                                 sx={{
                                                                                    padding: '5px 7px',
                                                                                    display: 'inline-block',
                                                                                    marginLeft: 'auto',
                                                                                    borderRadius: '8px !important',
                                                                                    textTransform: 'none',
                                                                                    textAlign: 'center',
                                                                                    backgroundColor: 'var(--brand-color)',
                                                                                    '&:hover': {
                                                                                       backgroundColor: 'var(--brand-color-hover)'
                                                                                    }
                                                                                 }}>

                                                                                 <span className="fa fa-search" style={{ fontWeight: '500', fontSize: '14px' }}>
                                                                                    {t('community.post.join')}
                                                                                 </span>
                                                                              </Button>
                                                                           </Box>
                                                               </Box>
                                                            </div>}
                                                         </div>
                                                         }
                                                      </>
                                                   </div>

                                                      <div style={{position: 'absolute', top: '8px', right: '5px', display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer',
                                                         borderRadius: '50px', padding: '2px 6px'}}
                                                           onClick={
                                                              currentUser === '' ?
                                                                 e => OpenSubscribePopup(
                                                                    e,
                                                                    influencer_info['icon_image_path'],
                                                                    influencer_info['influencer'],
                                                                    influencer_info['current_tier'],
                                                                    '',
                                                                    influencer_info['influencer_name'],
                                                                    currency,
                                                                 )
                                                                 :
                                                                 () => {
                                                                  commentLikeChange(nestedComment.id, post_index, reversedIndex, reversedNestedIndex);
                                                                  if (nestedComment.user_like_value === 0){
                                                                     handleVote(nestedComment.id);
                                                                  }
                                                               }
                                                           }
                                                      >
                                                         <span
                                                            style={{
                                                               marginBottom: '0px',
                                                               cursor: 'pointer',
                                                               fontSize: '14px',
                                                               color: nestedComment.user_like_value === 1 ? 'var(--brand-color)' : '#222',
                                                               marginRight: '3px',
                                                            }}
                                                         >
                                                            {nestedComment.user_like_value === 1 ? '👍' : '👍'}
                                                         </span>
                                                            <>
                                                               {isExploding && explodingIndex === nestedComment.id && (
                                                                  <ConfettiExplosion
                                                                     zIndex={10000}
                                                                     duration={2800}
                                                                     force={0.15}
                                                                     particleCount={10}
                                                                     width={200}
                                                                     particleSize={6}
                                                                     colors={confettiColors}
                                                                     onComplete={() => {setExplodingIndex(''); setIsExploding(false) }}
                                                                  />
                                                               )}
                                                            </>
                                                            <Typography
                                                               variant="subtitle1"
                                                            style={{
                                                               fontWeight: 'bold',
                                                               fontSize: '12px',
                                                               marginBottom: '0px',
                                                               margin: '0px',
                                                               lineHeight: '20px',
                                                               color: nestedComment.user_like_value === 1 ? 'var(--brand-color)' : '#222',
                                                            }}
                                                         >
                                                            {nestedComment.like_count}
                                                         </Typography>
                                                      </div>
                                                   </>
                                                </div>
                                                <Button
                                                   color="primary"
                                                   sx={{
                                                      backgroundColor: 'transparent',
                                                      fontSize: '12px',
                                                      padding: '0',
                                                      margin: '3px 0px 0px 10px',
                                                      textAlign: 'left',
                                                      textTransform: 'uppercase',
                                                      color: 'var(--brand-color)',
                                                      minWidth: '0px',
                                                      '&:hover': {
                                                         backgroundColor: '#fff',
                                                         textDecoration: 'underline'
                                                      },
                                                      '.MuiButton-root MuiButton-text': {
                                                         textTransform: 'uppercase',
                                                      },
                                                   }}

                                                   onClick={

                                                      // If not logged in show sub modal, if logged in reply
                                                      currentUser === '' ?
                                                         e => OpenSubscribePopup(
                                                            e,
                                                            influencer_info['icon_image_path'],
                                                            influencer_info['influencer'],
                                                            influencer_info['current_tier'],
                                                            '',
                                                            influencer_info['influencer_name'],
                                                            currency,
                                                         )
                                                         :
                                                         () => {
                                                            handleReplyClick(index, nestedComment.commenter);
                                                            setIsReplyingNested(true);
                                                         }
                                                   }

                                                   onMouseEnter={() => handleReplyMouseEnter(nestedIndex)}
                                                   onMouseLeave={handleReplyMouseLeave}
                                                >
                                                   {t('community.post.reply')}
                                                </Button>
                                             </div>
                                          </div>
                                       )})
                                    ) :

                                       // Only one comment is rendered initially, two if one is added by user
                                       (

                                          [...thread.comments]
                                             .reverse()
                                             .slice(Math.max(0, thread.comments.length - 1))
                                             .map((nestedComment, nestedIndex, reversedComments) => {
                                                const reversedNestedIndex = reversedComments.length - 1 - nestedIndex;
                                                return (
                                                   <div
                                                      style={{
                                                         display: 'flex',
                                                         marginBottom: '10px',
                                                         position: 'relative',
                                                      }}
                                                      key={nestedIndex}
                                                   >
                                                      <Avatar
                                                         alt={current_username}
                                                         src={nestedComment.user_icon}
                                                         style={{ margin: '8px 10px 0px 0px' }}
                                                      />
                                                      <div style={{ width: '100%', boxSizing: 'border-box' }}>
                                                         <div
                                                            style={{
                                                               backgroundColor: '#F5F9FF',
                                                               borderRadius: '10px',
                                                               boxSizing: 'border-box',
                                                               padding: '8px 10px',
                                                               position: 'relative',
                                                            }}
                                                         > <div style={{ display: 'flex', alignItems: 'center' }}>
                                                               <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginRight: '6px' }}>
                                                                  {TruncateWithEllipsis(nestedComment.commenter_display_name, 20)}

                                                               </Typography>
                                                               {
                                                                  window.innerWidth > 450 ?
                                                                     <Typography variant="body2" color="textSecondary" sx={{ fontSize: '12px', marginTop: '-2px' }}>
                                                                        {getTimeDelta(nestedComment.time, t)}
                                                                     </Typography>
                                                                     :
                                                                     null
                                                               }

                                                            </div>
                                                            {
                                                               window.innerWidth <= 450 ?
                                                                  <Typography variant="body2" color="textSecondary" sx={{ fontSize: '12px', marginTop: '0px' }}>
                                                                     {getTimeDelta(nestedComment.time, t)}
                                                                  </Typography>
                                                                  :
                                                                  null
                                                            }

                                                            <Typography className="text_content" variant="body2" style={{ width: '90%', wordBreak: 'break-word' }}>
                                                               <Linkify options={{ target: "_blank" }}>
                                                                  {nestedComment.text.split('\n').map((line, index) => (
                                                                     <React.Fragment key={index}>
                                                                        {line}
                                                                        <br />
                                                                     </React.Fragment>
                                                      ))}
                                                   </Linkify>
                                                   </Typography>
                                                   <>


                                                      {  currentUser === '' ?
                                                         null
                                                         :
                                                         <>
                                                            {  currentUser === nestedComment.commenter ?
                                                               <div
                                                                  onClick={(event) => handleCommentMenuOpen(event, 'commentMenu', nestedComment.id, post_index, reversedIndex, reversedNestedIndex, nestedComment.text)}

                                                                  style={{
                                                                     position: 'absolute',
                                                                     top: '12px',
                                                                     right: '45px',
                                                                     display: 'flex',
                                                                     flexDirection: 'column',
                                                                     alignItems: 'center',
                                                                     cursor: 'pointer',
                                                                  }}
                                                               >
                                                                  <HiOutlineDotsHorizontal />
                                                               </div>
                                                               :
                                                               <>
                                                                  {/* Influencer Delete Menu Here */}
                                                                  {  currentUser === influencer_name ?
                                                                     <div style={{
                                                                        position: 'absolute',
                                                                        top: '12px',
                                                                        right: '45px',
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        alignItems: 'center',
                                                                        cursor: 'pointer',
                                                                     }}
                                                                          onClick={(event) => handleCommentMenuOpen(event, 'commentMenuInfluencer', nestedComment.id, post_index, reversedIndex, reversedNestedIndex, nestedComment.text)}
                                                                     >
                                                                        <HiOutlineDotsHorizontal

                                                                        />
                                                                     </div>
                                                                     :
                                                                     null
                                                                  }
                                                               </>
                                                            }
                                                         </>
                                                      }

                                                   <div>
                                                      <>
                                                         {(nestedComment.file || (['mot', 'mzm', 'mgm', 'mmt', 'gos', 'god'].includes(nestedComment.content_type) && nestedComment.link)) &&
                                                         <div style={{ position: 'relative', padding: '10px 0px 0px 0px' }}>
                                                            {nestedComment.content_type === 'img' &&
                                                            <>
                                                               <ImagePost image_src={nestedComment.file} handleFullscreenOpen={handleFullscreenOpen}/>
                                                            </>

                                                            }
                                                            {nestedComment.content_type === 'vid' &&
                                                               <div style={{ borderRadius: '8px', overflow: 'hidden' }}>
                                                                  <VideoPost video_src={nestedComment.file}/>
                                                               </div>


                                                            }
                                                            {nestedComment.content_type === 'vey' &&
                                                               <>
                                                               <div style={{ borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                                                                  <YoutubePost video_src={nestedComment.file}/>
                                                               </div>
                                                               </>
                                                            }
                                                            {nestedComment.content_type === 'vel' &&
                                                               <>
                                                               <div style={{ borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                                                                  <LoomPost video_src={nestedComment.file}/>
                                                               </div>
                                                               </>
                                                            }
                                                            {nestedComment.content_type === 'vev' &&
                                                               <>
                                                               <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                                                                  <iframe
                                                                     src={"https://player.vimeo.com/video/" + nestedComment.file}
                                                                     frameborder="0"
                                                                     allow="autoplay; fullscreen; picture-in-picture"
                                                                     allowfullscreen
                                                                     style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                                                  ></iframe>
                                                               </div>
                                                               </>
                                                            }
                                                            {nestedComment.content_type === 'vtw' && nestedComment.file &&
                                                               <>
                                                               <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                                                                  <iframe
                                                                     src={
                                                                        nestedComment.file.startsWith('ch')
                                                                           ? "https://player.twitch.tv/?channel=" + nestedComment.file.slice(2) + "&parent=" + window.location.hostname
                                                                           : nestedComment.file.startsWith('c')
                                                                           ? "https://clips.twitch.tv/embed?clip=" + nestedComment.file.slice(1) + "&parent=" + window.location.hostname
                                                                           : "https://player.twitch.tv/?video=" + nestedComment.file.slice(1) + "&parent=" + window.location.hostname
                                                                     }
                                                                     frameborder="0"
                                                                     allow="autoplay; fullscreen"
                                                                     allowfullscreen
                                                                     style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                                                  ></iframe>
                                                               </div>
                                                               </>
                                                            }
                                                            {nestedComment.content_type === 'vwi' &&
                                                               <>
                                                               <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden', marginBottom: '16px' }}>
                                                                  <iframe
                                                                     src={"https://fast.wistia.com/embed/iframe/" + nestedComment.file + "?autoPlay=false"}
                                                                     frameborder="0"
                                                                     allow="autoplay; fullscreen"
                                                                     allowfullscreen
                                                                     style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                                                  ></iframe>
                                                               </div>
                                                               </>
                                                            }
                                                            {['gos', 'god'].includes(nestedComment.content_type) &&
                                                               <Box
                                                                  sx={{
                                                                     display: 'flex',
                                                                     alignItems: 'center',
                                                                     height: '60px',
                                                                     border: '1px solid #E4EBF6',
                                                                     backgroundColor: '#fff',
                                                                     borderRadius: '8px',
                                                                     padding: '0 16px',
                                                                     marginBottom: '16px',
                                                                     position: 'relative'
                                                                  }}
                                                               >
                                                                  {nestedComment.content_type === 'gos' && <img src={GoogleSheetsImage} alt={t('dashboard.paidDms.googleSheets')} style={{ width: '24px', marginRight: '16px' }} />}
                                                                  {nestedComment.content_type === 'god' && <img src={GoogleDocsImage} alt={t('dashboard.paidDms.googleDocs')} style={{ width: '24px', marginRight: '16px' }} />}
                                                                  <Box sx={{ flexGrow: 1 }}>
                                                                     <p style={{ fontWeight: 500, fontFamily: 'Roboto', color: '#000', margin: 0 }}>
                                                                        {nestedComment.content_type === 'gos' && 'Google Sheets'}
                                                                        {nestedComment.content_type === 'god' && 'Google Docs'}
                                                                     </p>
                                                                  </Box>

                                                                  <Button
                                                                     variant="contained"
                                                                     disableElevation
                                                                     onClick={() => handleFullscreenOpen(normalizeExternalHref(nestedComment.link), nestedComment.content_type)}
                                                                     rel="noopener noreferrer"
                                                                     sx={{
                                                                        padding: '5px 7px',
                                                                        display: 'inline-block',
                                                                        marginLeft: 'auto',
                                                                        borderRadius: '8px !important',
                                                                        textTransform: 'none',
                                                                        textAlign: 'center',
                                                                        backgroundColor: 'var(--brand-color)',
                                                                        '&:hover': {
                                                                           backgroundColor: 'var(--brand-color-hover)'
                                                                        },
                                                                        cursor: 'pointer'
                                                                     }}>
                                                                     <span className="fa fa-search" style={{ fontWeight: '500', fontSize: '14px' }}>
                                                                        Open
                                                                     </span>
                                                                  </Button>
                                                               </Box>
                                                            }
                                                            {nestedComment.content_type === 'aud' &&
                                                            <div style={{ position: 'relative' }}>
                                                               <div className="image_container"
                                                                    style={{
                                                                       position: 'relative'
                                                                    }}
                                                               >
                                                                  <ReactAudioPlayer
                                                                     className='react-player'
                                                                     src={paths.CONTENT_CLOUDFRONT + nestedComment.file}
                                                                     // autoPlay
                                                                     controls
                                                                     style={{ width: '100%', margin: '0px', borderRadius: '0px' }}
                                                                  />
                                                               </div>
                                                            </div>
                                                            }
                                                            {nestedComment.content_type === 'pdf' &&
                                                            <>
                                                               <PDFPost fullscreen={fullscreenViewOpen} pdf_src={nestedComment.file} content_width_type={'comment'} handleFullscreenPDFOpen={handleFullscreenPDFOpen}/>
                                                            </>
                                                            }
     
                                                            {(nestedComment.link && ['mot', 'mgm', 'mzm', 'mmt'].includes(nestedComment.content_type)) &&
                                                            <div style={{ position: 'relative', padding: '0px' }}>
                                                               <Box
                                                                  sx={{
                                                                     display: 'flex',
                                                                     alignItems: 'center',
                                                                     height: '60px',
                                                                     border: '1px solid #E4EBF6',
                                                                     backgroundColor: '#fff',
                                                                     borderRadius: '8px',
                                                                     padding: '0 16px',
                                                                     // marginBottom: '16px'
                                                                  }}
                                                               >
                                                                  {nestedComment.content_type === 'mot' && <FaLink style={{ width: '24px', marginRight: '16px', color: '#6C89AF' }} />}
                                                                  {nestedComment.content_type === 'mgm' && <img src={GoogleMeetImage} alt={t('community.composer.googleMeet')} style={{ width: '24px', marginRight: '16px' }} />}
                                                                  {nestedComment.content_type === 'mmt' && <img src={MicrosoftTeams} alt={t('community.composer.microsoftTeams')} style={{ width: '24px', marginRight: '16px' }} />}
                                                                  {nestedComment.content_type === 'mzm' && <img src={ZoomImage} alt={t('profile.zoom')} style={{ width: '24px', marginRight: '16px' }} />}
                                                                  <Box sx={{ flexGrow: 1 , display: 'flex', alignItems: 'center'}}>
                                                                              <p style={{ fontWeight: 500, fontFamily: 'Roboto', color: '#000', margin: 0 }}>
                                                                                 {nestedComment.content_type === 'mot' && 'Meeting'}
                                                                                 {nestedComment.content_type === 'mgm' && 'Google Meet'}
                                                                                 {nestedComment.content_type === 'mmt' && 'Microsoft Teams'}
                                                                                 {nestedComment.content_type === 'mzm' && 'Zoom'}
                                                                              </p>
                                                                              <Button
                                                                                 variant="contained"
                                                                                 disableElevation
                                                                                 href={normalizeExternalHref(nestedComment.link)}
                                                                                 target="_blank"
                                                                                 rel="noopener noreferrer"
                                                                                 sx={{
                                                                                    padding: '5px 7px',
                                                                                    display: 'inline-block',
                                                                                    marginLeft: 'auto',
                                                                                    borderRadius: '8px !important',
                                                                                    textTransform: 'none',
                                                                                    textAlign: 'center',
                                                                                    backgroundColor: 'var(--brand-color)',
                                                                                    '&:hover': {
                                                                                       backgroundColor: 'var(--brand-color-hover)'
                                                                                    }
                                                                                 }}>

                                                                                 <span className="fa fa-search" style={{ fontWeight: '500', fontSize: '14px' }}>
                                                                                    {t('community.post.join')}
                                                                                 </span>
                                                                              </Button>
                                                                           </Box>
                                                               </Box>
                                                            </div>}
                                                         </div>
                                                         }
                                                      </>
                                                   </div>


                                                      <div style={{position: 'absolute', top: '8px', right: '5px', display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer',
                                                         borderRadius: '50px',  padding: '2px 6px'}}

                                                           onClick={
                                                              currentUser === '' ?
                                                                 e => OpenSubscribePopup(
                                                                    e,
                                                                    influencer_info['icon_image_path'],
                                                                    influencer_info['influencer'],
                                                                    influencer_info['current_tier'],
                                                                    '',
                                                                    influencer_info['influencer_name'],
                                                                    currency,
                                                                 )
                                                                 :
                                                                 () => {
                                                                     commentLikeChange(nestedComment.id, post_index, reversedIndex, reversedNestedIndex);
                                                                     if (nestedComment.user_like_value === 0){
                                                                        handleVote(nestedComment.id);
                                                                     }
                                                               }
                                                           }
                                                      >
                                                         <span
                                                            style={{
                                                               marginBottom: '0px',
                                                               cursor: 'pointer',
                                                               fontSize: '14px',
                                                               color: nestedComment.user_like_value === 1 ? 'var(--brand-color)' : '#222',
                                                               marginRight: '3px',
                                                            }}
                                                         >
                                                            {nestedComment.user_like_value === 1 ? '👍' : '👍'}
                                                         </span>
                                                       <>
                                                               {isExploding && explodingIndex === nestedComment.id && (
                                                                  <ConfettiExplosion
                                                                     zIndex={10000}
                                                                     duration={2800}
                                                                     force={0.15}
                                                                     particleCount={10}
                                                                     width={200}
                                                                     particleSize={6}
                                                                     colors={confettiColors}
                                                                     onComplete={() => {setExplodingIndex(''); setIsExploding(false) }}

                                                                  />
                                                               )}
                                                            </>
                                                         <Typography
                                                            variant="subtitle1"
                                                            style={{
                                                               fontWeight: 'bold',
                                                               fontSize: '12px',
                                                               marginBottom: '0px',
                                                               margin: '0px',
                                                               lineHeight: '20px',
                                                               color: nestedComment.user_like_value === 1 ? 'var(--brand-color)' : '#222',
                                                            }}
                                                         >
                                                            {nestedComment.like_count}
                                                         </Typography>
                                                      </div>
                                                   </>
                                                </div>
                                                <Button
                                                   color="primary"
                                                   sx={{
                                                      backgroundColor: 'transparent',
                                                      fontSize: '12px',
                                                      padding: '0',
                                                      margin: '3px 0px 0px 10px',
                                                      textAlign: 'left',
                                                      textTransform: 'uppercase',
                                                      color: 'var(--brand-color)',
                                                      minWidth: '0px',
                                                      '&:hover': {
                                                         textDecoration: 'underline',
                                                         backgroundColor: '#fff'
                                                      },
                                                      '.MuiButton-text': {
                                                         textTransform: 'uppercase',
                                                      },
                                                   }}
                                                   onClick={
                                                      currentUser === '' ?
                                                         e => OpenSubscribePopup(
                                                            e,
                                                            influencer_info['icon_image_path'],
                                                            influencer_info['influencer'],
                                                            influencer_info['current_tier'],
                                                            '',
                                                            influencer_info['influencer_name'],
                                                            currency,
                                                         )
                                                         :
                                                         () => {
                                                            handleReplyClick(index, nestedComment.commenter);
                                                            setIsReplyingNested(true);
                                                         }
                                                   }
                                                >
                                                   {t('community.post.reply')}
                                                </Button>
                                             </div>
                                          </div>
                                          )
                                    })
                                    )}
                                 </div>
                              )}

                              {showInputIndex === index && (
                                 <Fade opposite>
                                 <div className={'feed-padding'} style={{display: 'flex'}}>
                                       <Avatar alt={current_username} src={current_user_icon} style={{marginRight: '12px'}}/>
                                       <TextareaAutosize
                                          id="emailCaptureInput"
                                          maxRows={5}
                                          className={"text-input community-inputs"}
                                          style={{
                                             border: '#C7D1DE 1px solid',
                                             display: 'block',
                                             fontWeight: '500',
                                             margin: 'auto auto auto auto',
                                             fontSize: '16px',
                                             padding: '10px 15px',
                                             height: '18px',
                                             color: '#1D1D1D',
                                             borderRadius: '8px',
                                             width: '100%',
                                             fontFamily: 'Roboto',
                                             resize: 'none', // Disable textarea resizing
                                          }}
                                          disabled={!metReplyCriteria}
                                          placeholder={disabledReason}
                                          maxLength={5000}
                                          value={replyText}
                                          onChange={handleReplyTextChange}
                                       />


                                       {(((replyText.length > 0) || (selectedPreviewUrlComment !== '')) && (selectedPreviewUrlComment !== 'temp')) ? <Button
                                          variant="contained"
                                          disableElevation
                                          disabled={false}
                                          onClick={() => {handlePostReply(thread.id, reversedIndex, post_index, post_id)}}
                                          sx={{
                                             marginLeft: '8px',
                                             padding: '2px 5px',
                                             textAlign: 'center',
                                             height: '42px',
                                             maxWidth: '42px',
                                             minWidth: '42px',
                                             fontWeight: '600',
                                             display: 'inline-block',
                                             borderRadius: '7px',
                                             border: '2px var(--brand-color) solid',
                                             boxSizing: 'border-box',
                                             textTransform: 'none',
                                             color: 'var(--brand-color)',
                                             backgroundColor: 'var(--brand-color)',
                                             fontSize: '15px',
                                             '&:hover': {
                                                backgroundColor: 'var(--brand-color-hover)',
                                                color: '#fff',
                                                border: '2px var(--brand-color-hover) solid',
                                                '& .modal-close-icon': {
                                                   color: '#fff',
                                                },
                                             },
                                          }}
                                       >
                                          <div style={{ width: '100%', height: '100%', display: 'flex', fontSize: '15px !important' }}>
                                             <IoSend style={{ color: '#fff', margin: 'auto', fontSize: '15px !important' }} />
                                          </div>
                                       </Button> : ''}

                                       <Button
                                          variant="contained"
                                          disableElevation
                                          onClick={
                                             () => {
                                                setShowInputIndex(-1);
                                                setIsReplyingNested(false);
                                             }}
                                          sx={{
                                             marginLeft: '8px',
                                             padding: '2px 5px',
                                             textAlign: 'center',
                                             height: '42px',
                                             maxWidth: '42px',
                                             minWidth: '42px',
                                             fontWeight: '600',
                                             display: 'inline-block',
                                             borderRadius: '7px',
                                             border: '2px var(--brand-color) solid',
                                             boxSizing: 'border-box',
                                             textTransform: 'none',
                                             backgroundColor: 'var(--brand-color)',
                                             fontSize: '15px',
                                             '&:hover': {
                                                backgroundColor: 'var(--brand-color-hover)',
                                                color: '#fff',
                                                border: '2px var(--brand-color-hover) solid',
                                                '& .modal-close-icon': {
                                                   color: '#fff',
                                                },
                                             },
                                          }}
                                       >
                                          <div style={{ width: '100%', height: '100%', display: 'flex' }}>
                                             <IoClose className="modal-close-icon" style={{ color: '#fff', margin: 'auto' }} />
                                          </div>
                                       </Button>
                                    </div>
                                    <>
                                    {((selectedPreviewUrlComment) && (selectedPreviewIdComment === thread.id)) &&
                                    <div style={{ position: 'relative', padding: '10px 0px 0px 0px'}}>
                                    {fileTypeComment === 'img' &&
                                    <>
                                       <ImagePost pre_upload={true} image_src={selectedPreviewUrlComment} handleFullscreenOpen={handleFullscreenOpen}/>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveContentComment} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </>

                                    }
                                    {fileTypeComment === 'vid' &&

                                       <div style={{ borderRadius: '8px', overflow: 'hidden' }}>
                                          <VideoPost video_src={selectedPreviewUrlComment} pre_upload={true}/>
                                             <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                                <IconButton onClick={handleRemoveContentComment} size="small"
                                                   sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                   <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                                </IconButton>
                                             </div>
                                       </div>

                                    }
                                    {fileTypeComment === 'vey' &&
                                       <div style={{width:'100%', height: '100%',
                                          aspectRatio: '16/9', borderRadius: '8px', overflow: 'hidden'}}>
                
                                          <iframe 
                                             position='absolute'
                                             border='none'
                                             width="100%" 
                                             height="100%" 
                                             src={"https://www.youtube-nocookie.com/embed/" + embedUrlKeyComment + "?si=zjwU1BLkbSYRvl1j?rel=0&amp;modestbranding=1"}
                                             title={t('dashboard.widgets.articles.youtubePlayer')}
                                             frameborder="0"
                                             allow="accelerometer; encrypted-media; gyroscope; fullscreen;"
                                             referrerpolicy="strict-origin-when-cross-origin"
                                             allowfullscreen
                                          ></iframe> 
                                          <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                             <IconButton onClick={handleRemoveContentComment} size="small"
                                                sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                             </IconButton>
                                          </div>
                                       </div>
                                    }
                                    {fileTypeComment === 'vel' &&
                                       <div style={{position: 'relative',
                                          paddingBottom: '56.25%',
                                          height: '0'}}>

                                          <iframe
                                             src={"https://www.loom.com/embed/" + embedUrlKeyComment + "?sid=879009a9-7ce5-4bc0-84cc-dc6633dc222c?autoplay=false"}
                                             frameborder="0"
                                             webkitallowfullscreen
                                             mozallowfullscreen
                                             allowfullscreen
                                             style={
                                                {
                                                   position: 'absolute',
                                                   top: '0',
                                                   left: '0',
                                                   width: '100%',
                                                   height: '100%'
                                                }
                                             }
                                          ></iframe>
                                          <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                             <IconButton onClick={handleRemoveContentComment} size="small"
                                                sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                             </IconButton>
                                          </div>
                                       </div>
                                    }
                                    {fileTypeComment === 'vev' &&
                                       <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden' }}>
                                          <iframe
                                             src={"https://player.vimeo.com/video/" + embedUrlKeyComment}
                                             frameborder="0"
                                             allow="autoplay; fullscreen; picture-in-picture"
                                             allowfullscreen
                                             style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                          ></iframe>
                                          <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                             <IconButton onClick={handleRemoveContentComment} size="small"
                                                sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                             </IconButton>
                                          </div>
                                       </div>
                                    }
                                    {fileTypeComment === 'vtw' && embedUrlKeyComment &&
                                       <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden' }}>
                                          <iframe
                                             src={
                                                embedUrlKeyComment.startsWith('ch')
                                                   ? "https://player.twitch.tv/?channel=" + embedUrlKeyComment.slice(2) + "&parent=" + window.location.hostname
                                                   : embedUrlKeyComment.startsWith('c')
                                                   ? "https://clips.twitch.tv/embed?clip=" + embedUrlKeyComment.slice(1) + "&parent=" + window.location.hostname
                                                   : "https://player.twitch.tv/?video=" + embedUrlKeyComment.slice(1) + "&parent=" + window.location.hostname
                                             }
                                             frameborder="0"
                                             allow="autoplay; fullscreen"
                                             allowfullscreen
                                             style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                          ></iframe>
                                          <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                             <IconButton onClick={handleRemoveContentComment} size="small"
                                                sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                             </IconButton>
                                          </div>
                                       </div>
                                    }
                                    {fileTypeComment === 'vwi' &&
                                       <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden' }}>
                                          <iframe
                                             src={"https://fast.wistia.com/embed/iframe/" + embedUrlKeyComment + "?autoPlay=false"}
                                             frameborder="0"
                                             allow="autoplay; fullscreen"
                                             allowfullscreen
                                             style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                          ></iframe>
                                          <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                             <IconButton onClick={handleRemoveContentComment} size="small"
                                                sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                             </IconButton>
                                          </div>
                                       </div>
                                    }

                                 {['gos', 'god'].includes(fileTypeComment) &&
                                    <Box
                                       sx={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          height: '60px',
                                          backgroundColor: '#fff',
                                          border: '1px solid #E4EBF6',
                                          borderRadius: '8px',
                                          padding: '0 16px',
                                          marginBottom: '16px',
                                          position: 'relative'
                                       }}
                                    >
                                       {fileTypeComment === 'gos' && <img src={GoogleSheetsImage} alt={t('dashboard.paidDms.googleSheets')} style={{ width: '24px', marginRight: '16px' }} />}
                                       {fileTypeComment === 'god' && <img src={GoogleDocsImage} alt={t('dashboard.paidDms.googleDocs')} style={{ width: '24px', marginRight: '16px' }} />}
                                       <Box sx={{ flexGrow: 1 }}>
                                          <p style={{ fontWeight: 500, fontFamily: 'Roboto', color: '#000', margin: 0 }}>
                                             {fileTypeComment === 'gos' && 'Google Sheets'}
                                             {fileTypeComment === 'god' && 'Google Docs'}
                                          </p>
                                       </Box>
                                       <Button
                                          variant="contained"
                                          disableElevation
                                          onClick={() => handleFullscreenOpen(normalizeExternalHref(selectedPreviewUrlComment), fileTypeComment)}
                                          rel="noopener noreferrer"
                                          sx={{
                                             padding: '5px 7px',
                                             display: 'inline-block',
                                             marginLeft: 'auto',
                                             borderRadius: '8px !important',
                                             textTransform: 'none',
                                             textAlign: 'center',
                                             backgroundColor: 'var(--brand-color)',
                                             '&:hover': {
                                                backgroundColor: 'var(--brand-color-hover)'
                                             },
                                             cursor: 'pointer'
                                          }}>
                                          <span className="fa fa-search" style={{ fontWeight: '500', fontSize: '14px' }}>
                                             Open
                                          </span>
                                       </Button>
                                       <div style={{ position: 'absolute', top: '-10px', right: '-10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveContentComment} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </Box>
                                 }
                                    {fileTypeComment === 'aud' &&
                                    <div style={{ position: 'relative' }}>

                                       <div className="image_container"
                                            style={{
                                               // width: '100%',
                                               position: 'relative'
                                            }}
                                       >
                       
                                          <ReactAudioPlayer
                                             className='react-player'
                                             src={selectedPreviewUrlComment}
                                             controls
                                             style={{ width: '100%', margin: '0px', borderRadius: '0px' }}
                                          />

                                          <div style={{ justifyContent: 'flex-end', display: 'flex',  width: '30px', position: 'absolute', top: '11px', right: '10px' }}>


                                             <div style={{border:'1px #D3DCE7 solid',backgroundColor: '#fff', padding: '5px', height: '18px', width: '18px', margin: '0px 0px 0px 0px',
                                                borderRadius: '20px', '&:hover': {cursor: 'pointer'}}}>
                                                <a onClick={handleRemoveContentComment}>
                                                   <IoClose className={'content-upload-icons'}/>
                                                </a>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                    }
                                    {['mgm', 'mzm', 'mmt', 'mot'].includes(fileTypeComment) &&
                                       <div style={{ position: 'relative' }}>
                                          <Box
                                             sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                height: '60px',
                                                border: '1px solid #E4EBF6',
                                                backgroundColor: '#fff',
                                                borderRadius: '8px',
                                                padding: '0 16px',
                                             }}
                                          >
                                             {fileTypeComment === 'mgm' && <img src={GoogleMeetImage} alt={t('community.composer.googleMeet')} style={{ width: '24px', marginRight: '16px' }} />}
                                             {fileTypeComment === 'mzm' && <img src={ZoomImage} alt={t('profile.zoom')} style={{ width: '24px', marginRight: '16px' }} />}
                                             {fileTypeComment === 'mmt' && <img src={MicrosoftTeams} alt={t('community.composer.microsoftTeams')} style={{ width: '24px', marginRight: '16px' }} />}
                                             {fileTypeComment === 'mot' && <FaLink style={{ width: '24px', marginRight: '16px', color: '#6C89AF' }} />}
                                             <Box sx={{ flexGrow: 1 , display: 'flex', alignItems: 'center'}}>
                                                <p style={{ fontWeight: 500, fontFamily: 'Roboto', color: '#000', margin: 0 }}>
                                                   {fileTypeComment === 'mgm' && 'Google Meet'}
                                                   {fileTypeComment === 'mzm' && 'Zoom'}
                                                   {fileTypeComment === 'mmt' && 'Microsoft Teams'}
                                                   {fileTypeComment === 'mot' && 'Meeting'}
                                                </p>
                                             </Box>
                                             <Button
                                                variant="contained"
                                                disableElevation
                                                href={normalizeExternalHref(selectedPreviewUrlComment)}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                sx={{
                                                   padding: '5px 7px',
                                                   display: 'inline-block',
                                                   marginLeft: 'auto',
                                                   borderRadius: '8px !important',
                                                   textTransform: 'none',
                                                   textAlign: 'center',
                                                   backgroundColor: 'var(--brand-color)',
                                                   '&:hover': {
                                                      backgroundColor: 'var(--brand-color-hover)'
                                                   }
                                                }}>
                                                <span className="fa fa-search" style={{ fontWeight: '500', fontSize: '14px' }}>
                                                   {t('community.post.join')}
                                                </span>
                                             </Button>
                                          </Box>
                                          <div style={{position: 'absolute', top: '-10px', right: '-10px', '&:hover': {cursor: 'pointer'}, }}>
                                             <a onClick={handleRemoveContentComment}>
                                                <div style={{ backgroundColor: 'rgba(255,255,255,0.75)', borderRadius: '50px', padding: '5px', height: '20px', width: '20px', display: 'flex' }}>
                                                   <IoClose className={'modal-close-icon'} style={{ color: '#222222', margin: 'auto' }}/>
                                                </div>
                                             </a>
                                          </div>
                                       </div>
                                    }
                                    {fileTypeComment === 'pdf' &&
                                    <>

                                       <PDFPost fullscreen={fullscreenViewOpen} pdf_src={selectedPreviewUrlComment} pre_upload={true} content_width_type={'comment'} handleFullscreenPDFOpen={handleFullscreenPDFOpen}/>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveContentComment} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </>
                                    }

                                 </div>
                                    }
                                    {
                                       (((isMediaAttachedComment) && (selectedPreviewIdComment === thread.id)) || !metReplyCriteria) ?
                                          // NOT SHOWING CONTENT UPLOAD OPTIONS IF UPLOADED & IN PREVIEW (ONLY ONE CONTENT UPLOAD PER POST)
                                          null
                                          :
                                          <div
                                             className="community-compose-actions"
                                             style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'flex-start',
                                                marginTop: 8,
                                                gap: 8,
                                                marginLeft: '52px',
                                             }}
                                          >
                                             {/* Image */}
                                             <span
                                                onClick={() => handleShareImageComment(thread.id)}
                                                style={{
                                                   display: 'inline-flex',
                                                   alignItems: 'center',
                                                   cursor: 'pointer',
                                                   borderRadius: '6px',
                                                   transition: 'background 0.15s',
                                                   padding: '4px'
                                                }}
                                                onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f1f1f1'}
                                                onMouseLeave={e => e.currentTarget.style.backgroundColor = ''}
                                             >
                                                <TbPhoto style={{ color: '#666666', fontSize: 18 }} />
                                             </span>

                                             {/* Video */}
                                             <DarkTooltip title={t('community.composer.uploadOrEmbedVideo')} placement="bottom">
                                                <span
                                                   onClick={handleClickCommentVideo}
                                                   style={{
                                                      display: 'inline-flex',
                                                      alignItems: 'center',
                                                      cursor: 'pointer',
                                                      borderRadius: '6px',
                                                      transition: 'background 0.15s',
                                                      padding: '4px'
                                                   }}
                                                   onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f1f1f1'}
                                                   onMouseLeave={e => e.currentTarget.style.backgroundColor = ''}
                                                >
                                                   <TbVideo style={{ color: '#666666', fontSize: 18 }} />
                                                </span>
                                             </DarkTooltip>
                                             <Menu
                                                id="comment-video-menu"
                                                anchorEl={anchorElCommentVideo}
                                                keepMounted
                                                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                                                open={Boolean(anchorElCommentVideo)}
                                                onClose={handleCloseCommentVideo}
                                                sx={{
                                                   "& .MuiPaper-root": {
                                                      backgroundColor: "#fff",
                                                      boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 12px 0px, rgba(229, 229, 229, 0.05) 0px 0px 0px 1px;',
                                                      border: '1px #f4f4f4 solid'
                                                   },
                                                   zIndex: 9999,
                                                }}
                                             >
                                                <MenuItem
                                                   type="button"
                                                   onClick={() => {
                                                      handleCloseCommentVideo();
                                                      handleShareVideoComment(thread.id);
                                                   }}
                                                   sx={{ color: 'black', fontWeight: 500, fontSize: 14 }}
                                                >
                                                   <TbVideo style={{ verticalAlign: 'middle', color: '#666666', marginRight: 8, width: 16, height: 16 }} />
                                                   {t('community.composer.upload')}
                                                </MenuItem>
                                                <MenuItem
                                                   onClick={() => {
                                                      handleCloseCommentVideo();
                                                      setEmbedUrlIsOpen(true);
                                                      setSnackbarEmbed(false);
                                                      setEmbedUrlType('comment');
                                                      setSelectedPreviewIdComment(thread.id);
                                                   }}
                                                   sx={{ color: 'black', fontWeight: 500, fontSize: 14 }}
                                                >
                                                   <ImEmbed2 style={{ verticalAlign: 'middle', color: '#666666', marginRight: 8, width: 16, height: 16 }} />
                                                   {t('community.composer.embed')}
                                                </MenuItem>
                                             </Menu>

                                             {/* Audio */}
                                             <DarkTooltip title={t('community.post.audio')} placement="bottom">
                                                <span
                                                   onClick={() => {
                                                      handleCloseComment();
                                                      handleShareAudioComment(thread.id);
                                                   }}
                                                   style={{
                                                      display: 'inline-flex',
                                                      alignItems: 'center',
                                                      cursor: 'pointer',
                                                      borderRadius: '6px',
                                                      transition: 'background 0.15s',
                                                      padding: '4px'
                                                   }}
                                                   onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f1f1f1'}
                                                   onMouseLeave={e => e.currentTarget.style.backgroundColor = ''}
                                                >
                                                   <TbMicrophone style={{ color: '#666666', fontSize: 18 }} />
                                                </span>
                                             </DarkTooltip>
                                             <Menu
                                                id="comment-audio-menu"
                                                anchorEl={anchorElComment}
                                                keepMounted
                                                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                                                open={Boolean(anchorElComment)}
                                                onClose={handleCloseComment}
                                                sx={{
                                                   "& .MuiPaper-root": {
                                                      backgroundColor: "#fff",
                                                      boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 12px 0px, rgba(229, 229, 229, 0.05) 0px 0px 0px 1px;',
                                                      border: '1px #f4f4f4 solid'
                                                   },
                                                   zIndex: 9999,
                                                }}
                                             >
                                                <MenuItem
                                                   type="button"
                                                   onClick={() => {
                                                      handleCloseComment();
                                                      handleShareAudioComment(thread.id);
                                                   }}
                                                   sx={{ color: 'black', fontWeight: 500, fontSize: 14 }}
                                                >
                                                   <TbMicrophone style={{ verticalAlign: 'middle', color: '#666666', marginRight: 8, width: 16, height: 16 }} />
                                                   {t('community.composer.upload')}
                                                </MenuItem>
                                             </Menu>

                                             {/* Document */}
                                             <DarkTooltip title={t('community.post.document')} placement="bottom">
                                                <span
                                                   onClick={handleClickCommentDoc}
                                                   style={{
                                                      display: 'inline-flex',
                                                      alignItems: 'center',
                                                      cursor: 'pointer',
                                                      borderRadius: '6px',
                                                      transition: 'background 0.15s',
                                                      padding: '4px'
                                                   }}
                                                   onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f1f1f1'}
                                                   onMouseLeave={e => e.currentTarget.style.backgroundColor = ''}
                                                >
                                                   <TbFile style={{ color: '#666666', fontSize: 18 }} />
                                                </span>
                                             </DarkTooltip>
                                             <Menu
                                                id="comment-doc-menu"
                                                anchorEl={anchorElCommentDoc}
                                                keepMounted
                                                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                                                open={Boolean(anchorElCommentDoc)}
                                                onClose={handleCloseCommentDoc}
                                                sx={{
                                                   "& .MuiPaper-root": {
                                                      backgroundColor: "#fff",
                                                      boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 12px 0px, rgba(229, 229, 229, 0.05) 0px 0px 0px 1px;',
                                                      border: '1px #f4f4f4 solid'
                                                   },
                                                   zIndex: 9999,
                                                }}
                                             >
                                                <MenuItem
                                                   type="button"
                                                   onClick={() => {
                                                      handleCloseCommentDoc();
                                                      handleSharePdfComment(thread.id);
                                                   }}
                                                   sx={{ color: 'black', fontWeight: 500, fontSize: 14 }}
                                                >
                                                   <TbFile style={{ verticalAlign: 'middle', color: '#666666', marginRight: 8 }} />
                                                   {t('community.post.uploadPdf')}
                                                </MenuItem>
                                                <MenuItem
                                                   onClick={() => {
                                                      handleCloseCommentDoc();
                                                      setDocModalOpen(true);
                                                      setFileTypeComment('gos');
                                                      setDocType('comment');
                                                      setActiveDocFileType('gos');
                                                      setSnackbarOpenDoc(false);
                                                      setSelectedPreviewIdComment(thread.id);
                                                   }}
                                                   sx={{ color: 'black', fontWeight: 500, fontSize: 14 }}
                                                >
                                                   <img src={GoogleSheetsImage}
                                                      alt={t('dashboard.paidDms.googleSheets')}
                                                      style={{ verticalAlign: 'middle', width: 16, height: 16, marginRight: 8 }} />
                                                   {t('community.composer.googleSheet')}
                                                </MenuItem>
                                                <MenuItem
                                                   onClick={() => {
                                                      handleCloseCommentDoc();
                                                      setDocModalOpen(true);
                                                      setFileTypeComment('god');
                                                      setDocType('comment');
                                                      setActiveDocFileType('god');
                                                      setSnackbarOpenDoc(false);
                                                      setSelectedPreviewIdComment(thread.id);
                                                   }}
                                                   sx={{ color: 'black', fontWeight: 500, fontSize: 14 }}
                                                >
                                                   <img src={GoogleDocsImage}
                                                      alt={t('dashboard.paidDms.googleDocs')}
                                                      style={{ verticalAlign: 'middle', width: 16, height: 16, marginRight: 8 }} />
                                                   {t('community.composer.googleDoc')}
                                                </MenuItem>
                                             </Menu>
                                          </div>
                                       
                                       }
                                    </>
                                 </Fade>
                              )}

                           </div>

                        </div>
                     </div>
                  )})}
            </List>

            {

               isReplyingNested ?
                  <></>
                  :
                  <div style={{
                     display: 'flex',
                     width: fileTypeThread.content_type === 'pdf' ? 'calc(100% - 50px)' : '100%',
                     maxWidth: fileTypeThread.content_type === 'pdf' ? 'calc(100% - 50px)' : '100%',
                     borderTop: n_threads >= 1 ? '1px solid #f5f5f5' : '',
                     padding: n_threads >= 1 ? '30px 0px 10px 0px' : '',}}>
                     <Avatar alt={current_username} src={current_user_icon} style={{marginRight: '12px'}}/>

                     {
                        metReplyCriteria ?

                        <div style={{ display: 'block',
                           width: selectedPreviewUrlThread ? 'calc(100% - 103px)' : '100%',
                           padding: '0px 0px 10px 0px', boxSizing: 'border-box' }}>
                           <TextareaAutosize
                              id="emailCaptureInput"
                              maxRows={5}
                              className={"text-input community-inputs"}
                              style={{
                                 border: '#C7D1DE 1px solid',
                                 display: 'block',
                                 fontWeight: '500',
                                 margin: 'auto auto auto auto',
                                 fontSize: '16px',
                                 padding: '10px 15px',
                                 height: '18px',
                                 color: '#1D1D1D',
                                 borderRadius: '8px',
                                 width: 'calc(100% - 30px)',
                                 fontFamily: 'Roboto',
                                 resize: 'none', // Disable textarea resizing
                              }}
                              maxLength={5000}
                              disabled={!metReplyCriteria}
                              placeholder={disabledReason}
                              value={newThreadText}
                              onChange={(event) => setNewThreadText(event.target.value)}
                           />
                           {((selectedPreviewUrlThread) && (selectedPreviewIdThread === post_id)) &&
                              <div style={{ position: 'relative', padding: (((fileTypeThread === 'aud-rec') || (fileTypeThread === 'vid-rec')) && (window.length < 600)) ? '0px 0px 0px 0px' : '10px 0px 0px 0px'}}>
                                 {fileTypeThread === 'img' &&
                                 <>
                                    <ImagePost pre_upload={true} image_src={selectedPreviewUrlThread} handleFullscreenOpen={handleFullscreenOpen}/>
                                    <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                       <IconButton onClick={handleRemoveContentThread} size="small"
                                          sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                          <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                       </IconButton>
                                    </div>
                                 </>

                                 }
                                    {fileTypeThread === 'vid' &&
                                          <div style={{ borderRadius: '8px', overflow: 'hidden' }}>
                                             <VideoPost pre_upload={true} video_src={selectedPreviewUrlThread}/>

                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveContentThread} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </div>

                                    }
                                    {fileTypeThread === 'vey' &&
                                       <div style={{width:'100%', height: '100%',
                                          aspectRatio: '16/9', borderRadius: '8px', overflow: 'hidden'}}>
                                          <iframe 
                                             position='absolute'
                                             border='none'
                                             width="100%" 
                                             height="100%" 
                                             src={"https://www.youtube-nocookie.com/embed/" + embedUrlKeyThread + "?si=zjwU1BLkbSYRvl1j?rel=0&amp;modestbranding=1"}
                                             title={t('dashboard.widgets.articles.youtubePlayer')}
                                             frameborder="0"
                                             allow="accelerometer; encrypted-media; gyroscope; fullscreen;"
                                             referrerpolicy="strict-origin-when-cross-origin"
                                             allowfullscreen
                                          ></iframe> 
                                          <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                             <IconButton onClick={handleRemoveContentThread} size="small"
                                                sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                             </IconButton>
                                          </div>
                                       </div>
                                    }
                                    {fileTypeThread === 'vel' &&
                                       <div style={{position: 'relative',
                                          paddingBottom: '56.25%',
                                          height: '0'}}>
                                          <iframe 
                                             src={"https://www.loom.com/embed/" + embedUrlKeyThread + "?sid=879009a9-7ce5-4bc0-84cc-dc6633dc222c?autoplay=false"}
                                             frameborder="0" 
                                             webkitallowfullscreen 
                                             mozallowfullscreen 
                                             allowfullscreen 
                                             style={
                                                {
                                                   position: 'absolute',
                                                   top: '0', 
                                                   left: '0', 
                                                   width: '100%', 
                                                   height: '100%'
                                                }
                                             }
                                          ></iframe>
                                          <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                             <IconButton onClick={handleRemoveContentThread} size="small"
                                                sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                             </IconButton>
                                          </div>
                                       </div>
                                    }
                                    {fileTypeThread === 'vev' &&
                                       <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden' }}>
                                          <iframe
                                             src={"https://player.vimeo.com/video/" + embedUrlKeyThread}
                                             frameborder="0"
                                             allow="autoplay; fullscreen; picture-in-picture"
                                             allowfullscreen
                                             style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                          ></iframe>
                                          <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                             <IconButton onClick={handleRemoveContentThread} size="small"
                                                sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                             </IconButton>
                                          </div>
                                       </div>
                                    }
                                    {fileTypeThread === 'vtw' && embedUrlKeyThread &&
                                       <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden' }}>
                                          <iframe
                                             src={
                                                embedUrlKeyThread.startsWith('ch')
                                                   ? "https://player.twitch.tv/?channel=" + embedUrlKeyThread.slice(2) + "&parent=" + window.location.hostname
                                                   : embedUrlKeyThread.startsWith('c')
                                                   ? "https://clips.twitch.tv/embed?clip=" + embedUrlKeyThread.slice(1) + "&parent=" + window.location.hostname
                                                   : "https://player.twitch.tv/?video=" + embedUrlKeyThread.slice(1) + "&parent=" + window.location.hostname
                                             }
                                             frameborder="0"
                                             allow="autoplay; fullscreen"
                                             allowfullscreen
                                             style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                          ></iframe>
                                          <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                             <IconButton onClick={handleRemoveContentThread} size="small"
                                                sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                             </IconButton>
                                          </div>
                                       </div>
                                    }
                                    {fileTypeThread === 'vwi' &&
                                       <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden' }}>
                                          <iframe
                                             src={"https://fast.wistia.com/embed/iframe/" + embedUrlKeyThread + "?autoPlay=false"}
                                             frameborder="0"
                                             allow="autoplay; fullscreen"
                                             allowfullscreen
                                             style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                          ></iframe>
                                          <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                             <IconButton onClick={handleRemoveContentThread} size="small"
                                                sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                             </IconButton>
                                          </div>
                                       </div>
                                    }

                                    {['gos', 'god'].includes(fileTypeThread) &&
                                       <Box
                                          sx={{
                                             display: 'flex',
                                             alignItems: 'center',
                                             height: '60px',
                                             backgroundColor: '#fff',
                                             border: '1px solid #E4EBF6',
                                             borderRadius: '8px',
                                             padding: '0 16px',
                                             marginBottom: '16px',
                                             position: 'relative'
                                          }}
                                       >
                                          {fileTypeThread === 'gos' && <img src={GoogleSheetsImage} alt={t('dashboard.paidDms.googleSheets')} style={{ width: '24px', marginRight: '16px' }} />}
                                          {fileTypeThread === 'god' && <img src={GoogleDocsImage} alt={t('dashboard.paidDms.googleDocs')} style={{ width: '24px', marginRight: '16px' }} />}
                                          <Box sx={{ flexGrow: 1 }}>
                                             <p style={{ fontWeight: 500, fontFamily: 'Roboto', color: '#000', margin: 0 }}>
                                                {fileTypeThread === 'gos' && 'Google Sheets'}
                                                {fileTypeThread === 'god' && 'Google Docs'}
                                             </p>
                                          </Box>
                                          <Button
                                             variant="contained"
                                             disableElevation
                                             onClick={() => handleFullscreenOpen(normalizeExternalHref(selectedPreviewUrlThread), fileTypeThread)}
                                             rel="noopener noreferrer"
                                             sx={{
                                                padding: '5px 7px',
                                                display: 'inline-block',
                                                marginLeft: 'auto',
                                                borderRadius: '8px !important',
                                                textTransform: 'none',
                                                textAlign: 'center',
                                                backgroundColor: 'var(--brand-color)',
                                                '&:hover': {
                                                   backgroundColor: 'var(--brand-color-hover)'
                                                },
                                                cursor: 'pointer'
                                             }}>
                                             <span className="fa fa-search" style={{ fontWeight: '500', fontSize: '14px' }}>
                                                Open
                                             </span>
                                          </Button>
                                          <div style={{ position: 'absolute', top: '-10px', right: '-10px', cursor: 'pointer', zIndex: 10 }}>
                                             <IconButton onClick={handleRemoveContentThread} size="small"
                                                sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                             </IconButton>
                                          </div>
                                       </Box>
                                    }
                                    {fileTypeThread === 'aud' &&

                                    <div style={{ position: 'relative' }}>

                                       <div className="image_container"
                                            style={{
                                               // width: '100%',
                                               position: 'relative'
                                            }}
                                       >
                                          <ReactAudioPlayer
                                             className='react-player'
                                             src={selectedPreviewUrlThread}
                                             controls
                                             style={{ width: '100%', margin: '0px', borderRadius: '0px' }}
                                          />
                                          <div style={{ justifyContent: 'flex-end', display: 'flex',  width: '30px', position: 'absolute', top: '11px', right: '10px' }}>
                                             <div style={{border:'1px #D3DCE7 solid',backgroundColor: '#fff', padding: '5px', height: '18px', width: '18px', margin: '0px 0px 0px 0px',
                                                borderRadius: '20px', '&:hover': {cursor: 'pointer'}}}>
                                                <a onClick={handleRemoveContentThread}>
                                                   <IoClose className={'content-upload-icons'}/>
                                                </a>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                    }
                                    {(selectedPreviewUrlThread && ['mot', 'mgm', 'mzm', 'mmt'].includes(fileTypeThread)) &&
                                       <div style={{ position: 'relative', padding: '0px' }}>
                                          <Box
                                             sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                height: '60px',
                                                border: '1px solid #E4EBF6',
                                                backgroundColor: '#fff',
                                                borderRadius: '8px',
                                                padding: '0 16px',
                                                marginBottom: '16px'
                                             }}
                                          >
                                             {fileTypeThread === 'mot' && <FaLink style={{ width: '24px', marginRight: '16px', color: '#6C89AF' }} />}
                                             {fileTypeThread === 'mgm' && <img src={GoogleMeetImage} alt={t('community.composer.googleMeet')} style={{ width: '24px', marginRight: '16px' }} />}
                                             {fileTypeThread === 'mmt' && <img src={MicrosoftTeams} alt={t('community.composer.microsoftTeams')} style={{ width: '24px', marginRight: '16px' }} />}
                                             {fileTypeThread === 'mzm' && <img src={ZoomImage} alt={t('profile.zoom')} style={{ width: '24px', marginRight: '16px' }} />}
                                             <Box sx={{ flexGrow: 1 , display: 'flex', alignItems: 'center'}}>
                                                <p style={{ fontWeight: 500, fontFamily: 'Roboto', color: '#000', margin: 0 }}>
                                                   {fileTypeThread === 'mot' && 'Meeting'}
                                                   {fileTypeThread === 'mgm' && 'Google Meet'}
                                                   {fileTypeThread === 'mmt' && 'Microsoft Teams'}
                                                   {fileTypeThread === 'mzm' && 'Zoom'}
                                                </p>

                                                <Button
                                                   variant="contained"
                                                   disableElevation
                                                   href={normalizeExternalHref(selectedPreviewUrlThread)}
                                                   target="_blank"
                                                   rel="noopener noreferrer"
                                                   sx={{
                                                      padding: '5px 7px',
                                                      display: 'inline-block',
                                                      marginLeft: 'auto',
                                                      borderRadius: '8px !important',
                                                      textTransform: 'none',
                                                      textAlign: 'center',
                                                      backgroundColor: 'var(--brand-color)',
                                                      '&:hover': {
                                                         backgroundColor: 'var(--brand-color-hover)'
                                                      }
                                                   }}>
                                                   <span className="fa fa-search" style={{ fontWeight: '500', fontSize: '14px' }}>
                                                      {t('community.post.join')}
                                                   </span>
                                                </Button>

                                             </Box>
                                          </Box>
                                          <div style={{ position: 'absolute', top: '-10px', right: '-10px', zIndex: 1 }}>
                                             <div style={{border:'1px #D3DCE7 solid', backgroundColor: '#fff', padding: '5px', height: '18px', width: '18px',
                                                borderRadius: '20px', '&:hover': {cursor: 'pointer'}}}>
                                                <a onClick={handleRemoveContentThread}>
                                                   <IoClose className={'content-upload-icons'}/>
                                                </a>
                                             </div>
                                          </div>
                                       </div>
                                    }
                                    {fileTypeThread === 'pdf' &&
                                    <>
                                    <div style={{
                                       // width: '100%',
                                       width: fileTypeThread.content_type === 'pdf' ? 'calc(100% - 50px)' : '100%',
                                       maxWidth: fileTypeThread.content_type === 'pdf' ? 'calc(100% - 50px)' : '100%',
                                       boxSizing: 'border-box' }}>
                                       <PDFPost fullscreen={fullscreenViewOpen} pdf_src={selectedPreviewUrlThread} pre_upload={true} content_width_type={'thread'} handleFullscreenPDFOpen={handleFullscreenPDFOpen}/>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveContentThread} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </div>
                                    </>
                                    }
                              </div>
                              }
                                 {
                                    (((isMediaAttachedThread) && (selectedPreviewIdThread === post_id)) || !metReplyCriteria) ?
                                       // NOT SHOWING CONTENT UPLOAD OPTIONS IF UPLOADED & IN PREVIEW (ONLY ONE CONTENT UPLOAD PER POST)
                                       null
                                       :
                                             <div
                                                className="community-compose-actions"
                                                style={{
                                                   display: 'flex',
                                                   alignItems: 'center',
                                                   justifyContent: 'flex-start',
                                                   marginTop: 8,
                                                   gap: 8,
                                                }}
                                             >
                                                {/* Image */}
                                                <span
                                                   onClick={() => handleShareImageThread(post_id)}
                                                   style={{
                                                      display: 'inline-flex',
                                                      alignItems: 'center',
                                                      cursor: 'pointer',
                                                      borderRadius: '6px',
                                                      transition: 'background 0.15s',
                                                      padding: '4px'
                                                   }}
                                                   onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f1f1f1'}
                                                   onMouseLeave={e => e.currentTarget.style.backgroundColor = ''}
                                                >
                                                   <TbPhoto style={{ color: '#666666', fontSize: 18 }} />
                                                </span>

                                                {/* Video */}
                                                <DarkTooltip title={t('community.composer.uploadOrEmbedVideo')} placement="bottom">
                                                   <span
                                                      onClick={handleClickThreadVideo}
                                                      style={{
                                                         display: 'inline-flex',
                                                         alignItems: 'center',
                                                         cursor: 'pointer',
                                                         borderRadius: '6px',
                                                         transition: 'background 0.15s',
                                                         padding: '4px'
                                                      }}
                                                      onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f1f1f1'}
                                                      onMouseLeave={e => e.currentTarget.style.backgroundColor = ''}
                                                   >
                                                      <TbVideo style={{ color: '#666666', fontSize: 18 }} />
                                                   </span>
                                                </DarkTooltip>
                                                <Menu
                                                   id="thread-video-menu"
                                                   anchorEl={anchorElThreadVideo}
                                                   keepMounted
                                                   anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                                   transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                                                   open={Boolean(anchorElThreadVideo)}
                                                   onClose={handleCloseThreadVideo}
                                                   sx={{
                                                      "& .MuiPaper-root": {
                                                         backgroundColor: "#fff",
                                                         boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 12px 0px, rgba(229, 229, 229, 0.05) 0px 0px 0px 1px;',
                                                         border: '1px #f4f4f4 solid'
                                                      },
                                                      zIndex: 9999,
                                                   }}
                                                >
                                                   <MenuItem
                                                      type="button"
                                                      onClick={() => {
                                                         handleCloseThreadVideo();
                                                         handleShareVideoThread(post_id);
                                                      }}
                                                      sx={{ color: 'black', fontWeight: 500, fontSize: 14 }}
                                                   >
                                                      <TbVideo style={{ verticalAlign: 'middle', color: '#666666', marginRight: 8, width: 16, height: 16 }} />
                                                      {t('community.composer.upload')}
                                                   </MenuItem>
                                                   <MenuItem
                                                      onClick={() => {
                                                         handleCloseThreadVideo();
                                                         setEmbedUrlIsOpen(true);
                                                         setSnackbarEmbed(false);
                                                         setEmbedUrlType('thread');
                                                         setSelectedPreviewIdThread(post_id);
                                                      }}
                                                      sx={{ color: 'black', fontWeight: 500, fontSize: 14 }}
                                                   >
                                                      <ImEmbed2 style={{ verticalAlign: 'middle', color: '#666666', marginRight: 8, width: 16, height: 16 }} />
                                                      {t('community.composer.embed')}
                                                   </MenuItem>
                                                </Menu>

                                                {/* Audio */}
                                                <DarkTooltip title={t('community.composer.uploadAudio')} placement="bottom">
                                                   <span
                                                      onClick={() => {
                                                         handleShareAudioThread(post_id);
                                                      }}
                                                      style={{
                                                         display: 'inline-flex',
                                                         alignItems: 'center',
                                                         cursor: 'pointer',
                                                         borderRadius: '6px',
                                                         transition: 'background 0.15s',
                                                         padding: '4px'
                                                      }}
                                                      onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f1f1f1'}
                                                      onMouseLeave={e => e.currentTarget.style.backgroundColor = ''}
                                                   >
                                                      <TbMicrophone style={{ color: '#666666', fontSize: 18 }} />
                                                   </span>
                                                </DarkTooltip>

                                                {/* Document */}
                                                <DarkTooltip title={t('community.post.document')} placement="bottom">
                                                   <span
                                                      onClick={handleClickThreadDoc}
                                                      style={{
                                                         display: 'inline-flex',
                                                         alignItems: 'center',
                                                         cursor: 'pointer',
                                                         borderRadius: '6px',
                                                         transition: 'background 0.15s',
                                                         padding: '4px'
                                                      }}
                                                      onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f1f1f1'}
                                                      onMouseLeave={e => e.currentTarget.style.backgroundColor = ''}
                                                   >
                                                      <TbFile style={{ color: '#666666', fontSize: 18 }} />
                                                   </span>
                                                </DarkTooltip>
                                                <Menu
                                                   id="thread-doc-menu"
                                                   anchorEl={anchorElThreadDoc}
                                                   keepMounted
                                                   anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                                   transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                                                   open={Boolean(anchorElThreadDoc)}
                                                   onClose={handleCloseThreadDoc}
                                                   sx={{
                                                      "& .MuiPaper-root": {
                                                         backgroundColor: "#fff",
                                                         boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 12px 0px, rgba(229, 229, 229, 0.05) 0px 0px 0px 1px;',
                                                         border: '1px #f4f4f4 solid'
                                                      },
                                                      zIndex: 9999,
                                                   }}
                                                >
                                                   <MenuItem
                                                      type="button"
                                                      onClick={() => {
                                                         handleCloseThreadDoc();
                                                         handleSharePdfThread(post_id);
                                                      }}
                                                      sx={{ color: 'black', fontWeight: 500, fontSize: 14 }}
                                                   >
                                                      <TbFile style={{ verticalAlign: 'middle', color: '#666666', marginRight: 8 }} />
                                                      {t('community.post.uploadPdf')}
                                                   </MenuItem>
                                                   <MenuItem
                                                      onClick={() => {
                                                         handleCloseThreadDoc();
                                                         setDocModalOpen(true);
                                                         setFileTypeThread('gos');
                                                         setDocType('thread');
                                                         setActiveDocFileType('gos');
                                                         setSnackbarOpenDoc(false);
                                                         setSelectedPreviewIdThread(post_id);
                                                      }}
                                                      sx={{ color: 'black', fontWeight: 500, fontSize: 14 }}
                                                   >
                                                      <img src={GoogleSheetsImage}
                                                         alt={t('dashboard.paidDms.googleSheets')}
                                                         style={{ verticalAlign: 'middle', width: 16, height: 16, marginRight: 8 }} />
                                                      {t('community.composer.googleSheet')}
                                                   </MenuItem>
                                                   <MenuItem
                                                      onClick={() => {
                                                         handleCloseThreadDoc();
                                                         setDocModalOpen(true);
                                                         setFileTypeThread('god');
                                                         setDocType('thread');
                                                         setActiveDocFileType('god');
                                                         setSnackbarOpenDoc(false);
                                                         setSelectedPreviewIdThread(post_id);
                                                      }}
                                                      sx={{ color: 'black', fontWeight: 500, fontSize: 14 }}
                                                   >
                                                      <img src={GoogleDocsImage}
                                                         alt={t('dashboard.paidDms.googleDocs')}
                                                         style={{ verticalAlign: 'middle', width: 16, height: 16, marginRight: 8 }} />
                                                      {t('community.composer.googleDoc')}
                                                   </MenuItem>
                                                </Menu>
                                             </div>
                                          }
                              </div>
                           :
                           <>

                              {
                                 disabledReason === 'Login to join the conversation' ?
                                    <div
                                       id="emailCaptureInput"
                                       className={"text-input community-inputs"}
                                       style={{
                                          border: '#C7D1DE 1px solid',
                                          display: 'flex',
                                          alignItems: 'center',
                                          fontWeight: '500',
                                          margin: 'auto auto auto auto',
                                          fontSize: '16px',
                                          padding: '10px 15px',
                                          height: '20px',
                                          color: '#AFBED3',
                                          borderRadius: '8px',
                                          width: '100%',
                                          fontFamily: 'Roboto',
                                          resize: 'none',
                                          cursor: 'pointer',
                                          backgroundColor: '#FAFAFA',
                                       }}
                                       onClick={() => {
                                          redirectCallback(post_id);
                                       }
                                       }>
                                       {disabledReason}
                                    </div>

                                    : null
                              }


                              {

                                 disabledReason === 'Upgrade to join the conversation' ?

                                    <div
                                       id="emailCaptureInput"
                                       className={"text-input community-inputs"}
                                       style={{
                                          border: '#C7D1DE 1px solid',
                                          display: 'flex',
                                          alignItems: 'center',
                                          fontWeight: '500',
                                          margin: 'auto auto auto auto',
                                          fontSize: '16px',
                                          padding: '10px 15px',
                                          height: '20px',
                                          color: '#AFBED3',
                                          borderRadius: '8px',
                                          width: '100%',
                                          fontFamily: 'Roboto',
                                          resize: 'none',
                                          cursor: 'pointer',
                                          backgroundColor: '#FAFAFA',
                                       }}
                                       onClick={
                                          e => OpenSubscribePopup(
                                             e,
                                             influencer_info['icon_image_path'],
                                             influencer_info['influencer'],
                                             influencer_info['current_tier'],
                                             '',
                                             influencer_info['influencer_name'],
                                             currency,
                                          )
                                       }
                                    >
                                       {disabledReason}
                                    </div>
                                    :
                                    null
                              }
                           </>

                     }


                     {
                        currentUser !== '' ?
                           <>
                           {
                                 ((newThreadText === '' && selectedPreviewUrlThread === '') || (selectedPreviewUrlThread === 'temp')) ?
                                 null
                                 :
                                 <Fade>
                                 <Button
                                    variant="contained"
                                    disableElevation
                                    disabled={false}
                                    onClick={() =>
                                    {
                                       submitThread(newThreadText, post_id, post_index)
                                       // setNewThreadText('')
                                    }}
                                    sx={{
                                       marginLeft: '8px',
                                       padding: '2px 5px',
                                       textAlign: 'center',
                                       height: '42px',
                                       maxWidth: '42px',
                                       minWidth: '42px',
                                       fontWeight: '600',
                                       display: 'inline-block',
                                       borderRadius: '7px',
                                       border: '2px var(--brand-color) solid',
                                       boxSizing: 'border-box',
                                       textTransform: 'none',
                                       color: 'var(--brand-color)',
                                       backgroundColor: 'var(--brand-color)',
                                       fontSize: '15px',
                                       '&:hover': {
                                          backgroundColor: 'var(--brand-color-hover)',
                                          color: '#fff',
                                          border: '2px var(--brand-color-hover) solid',
                                          '& .modal-close-icon': {
                                             color: '#fff',
                                          },
                                       },
                                    }}
                                 >
                                    <div style={{ width: '100%', height: '100%', display: 'flex', fontSize: '15px !important' }}>
                                       <IoSend style={{ color: '#fff', margin: 'auto', fontSize: '15px !important' }} />
                                    </div>
                                 </Button>
                                 </Fade>
                           }
                           </>
                           : null
                     }
                  </div>
            }

         </div>

         {
            // FULLSCREEN MODAL
            fullscreenViewOpen ?

               <Modal
                  sx={{backgroundColor: 'black', overflow: 'auto', display:'flex', outline: 'none', width: '100vw', minHeight: '100vh', zIndex: '9999' }}
                  open={fullscreenViewOpen}
               >
                  <Fade in={fullscreenViewOpen}>
                     <a className={'hover_modal_icon'} style={{ zIndex: '1999', paddingBottom: '0px' }} onClick={() => {handleFullscreenClose()}}>
                        <IoClose
                           className="fullscreen_icon"
                           style={{ position: 'fixed', width: '20px', height: '20px', top: window.innerWidth > 1280 ? '6px' : (window.innerWidth > 900 ? '6px' : '10px'), right: window.innerWidth > 1280 ? '10px' : (window.innerWidth > 600 ? '10px' : '10px')
                           }}/>
                     </a>
                     <Grid
                        container
                        xs={12} md={12} lg={12}
                        alignItems="center"
                        justifyContent="center"
                        direction="column"
                        sx={{
                           width: '100vw',
                           minHeight:'100vh',
                           margin: 'auto auto 0px auto',
                           overflow: 'hidden',
                        }}
                     >
                        <Grid sx={{
                           minHeight: '240px',
                           backgroundColor: '#000',
                           margin: 'auto auto 0px auto',
                           width: '100%',
                           height: '100%',
                           minWidth: 'auto',
                           boxShadow: '0 5px 25px 0 rgba(35, 40, 105, 0.04)' ,
                           position: 'relative',
                        }}>

                           <Grid xs={12}
                                 container
                                 justifyContent={'center'}
                                 alignItems={'center'}
                           >

                              {/* Content displayed here*/}
                              <Grid xs={12}>
                                 {selectedContentFullscreen &&
                                 <div style={{ position: 'relative', padding: '0px 0px 0px 0px' }}>
                                    {selectedContentFullscreenType === 'img' &&
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                       <ImagePost image_src={selectedContentFullscreen} fullscreen={selectedContentFullscreen} />
                                    </div>
                                    }
                                    {selectedContentFullscreenType === 'gos' &&
                                    <div style={{ display: 'flex', justifyContent: 'center'}}>
                                       <GoogleSheetsPost video_src={selectedContentFullscreen} fullscreen={selectedContentFullscreen} />
                                    </div>
                                    }
                                    {selectedContentFullscreenType === 'god' &&
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                       <GoogleDocsPost video_src={selectedContentFullscreen} fullscreen={selectedContentFullscreen} />
                                    </div>
                                    }
                                 </div>
                                 }
                              </Grid>
                           </Grid>
                        </Grid>
                     </Grid>
                  </Fade>
               </Modal>
               : null
         }

         {
            // FULLSCREEN PDF
            fullscreenPDFOpen ?

               <Modal
                  sx={{backgroundColor: 'black', overflow: 'auto', display:'flex', outline: 'none', width: '100vw', minHeight: '100vh', zIndex: '9999' }}
                  open={fullscreenPDFOpen}
               >
                  <Fade in={fullscreenPDFOpen}>
                     <a className={'hover_modal_icon'} style={{ zIndex: '1999' }} onClick={() =>{handleFullscreenPDFClose()}}>
                        <IoClose
                           className="fullscreen_icon"
                           style={{ position: 'fixed', width: '20px', height: '20px', top: window.innerWidth > 1280 ? '10px' : (window.innerWidth > 600 ? '30px' : '10px'), right: window.innerWidth > 1280 ? '10px' : (window.innerWidth > 600 ? '30px' : '10px')
                           }}/>
                     </a>
                     <Grid
                        container
                        xs={12} md={12} lg={12}
                        alignItems="center"
                        justifyContent="center"
                        direction="column"
                        sx={{
                           width: '100vw',
                           minHeight:'100vh',
                           // paddingTop: 'calc(20px + 1vw)',
                           // paddingBottom: 'calc(20px + 1vw)',
                           overflow:'auto',
                           margin: '0px auto auto auto',
                        }}
                     >
                           <Grid xs={12} container justifyContent={'center'} alignItems={'center'}>
                              {/* Content displayed here*/}
                              <Grid xs={12}>
                                 <div style={{ position: 'relative', padding: '0px 0px 0px 0px' }}>
                                       <PDFPostFullscreen pdf_src={fullscreenPDFSrc} />
                                 </div>
                              </Grid>
                           </Grid>
                     </Grid>
                  </Fade>
               </Modal>
               : null
         }


{
            // EDIT POST MODAL
            editPostModal && createPortal(
               <div
                     style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        display: 'flex',
                        alignItems: window.innerWidth < 900 ? 'flex-end' : 'center',
                        justifyContent: 'center',
                        zIndex: 4000,
                        padding: window.innerWidth < 900 ? '0px' : '20px',
                        opacity: editPostModalAnimating ? 1 : 0,
                        transition: 'opacity 0.3s ease-in-out'
                     }}
                     onClick={closeEditPostModal}
                  >
                     <div
                        style={{
                           maxWidth: window.innerWidth < 600 ? '100%' : '800px',
                           width: '100%',
                           height: 'auto',
                           maxHeight: '85vh',
                           backgroundColor: '#fff',
                           borderRadius: window.innerWidth < 900 ? '20px 20px 0px 0px' : '16px',
                           position: 'relative',
                           boxShadow: window.innerWidth < 900 ? '0 -10px 40px rgba(0, 0, 0, 0.15)' : '0 20px 60px rgba(0, 0, 0, 0.15)',
                           overflow: 'visible',
                           display: 'flex',
                           flexDirection: 'column',
                           transform: editPostModalAnimating 
                              ? 'translateY(0)' 
                              : window.innerWidth < 900 
                                 ? 'translateY(100%)' 
                                 : 'scale(0.8) translateY(50px)',
                           opacity: editPostModalAnimating ? 1 : 0,
                           transition: 'all 0.3s ease-out',
                           outline: 'none'
                        }}
                        onClick={(e) => e.stopPropagation()}
                     >

                     {/* Close button */}
                     <div
                        style={{
                           position: 'absolute',
                           top: '15px',
                           right: '15px',
                           cursor: 'pointer',
                           zIndex: 1301,
                           width: '30px',
                           height: '30px',
                           borderRadius: '50%',
                           backgroundColor: 'rgba(0, 0, 0, 0.1)',
                           display: 'flex',
                           alignItems: 'center',
                           justifyContent: 'center',
                           transition: 'all 0.2s ease',
                           opacity: editPostModalAnimating ? 1 : 0,
                           transform: editPostModalAnimating ? 'scale(1)' : 'scale(0.8)',
                           transitionDelay: editPostModalAnimating ? '0.2s' : '0s'
                        }}
                     >
                        <IoClose
                           onClick={closeEditPostModal}
                           style={{
                              fontSize: '18px',
                              color: '#666',
                              transition: 'color 0.2s ease'
                           }}
                        />
                     </div>

                     {/* Header section */}
                     <div
                        style={{
                           padding: '25px 25px 20px 25px',
                           background: 'linear-gradient(135deg, rgba(247,249,252,0.8) 0%, rgba(255,255,255,0.4) 100%)',
                           borderBottom: '1px solid #E4EBF6',
                           opacity: editPostModalAnimating ? 1 : 0,
                           transform: editPostModalAnimating ? 'translateY(0)' : 'translateY(20px)',
                           transition: 'all 0.4s ease-out',
                           transitionDelay: editPostModalAnimating ? '0.1s' : '0s'
                        }}
                     >
                        <Typography
                           variant="h5"
                           style={{
                              color: '#1D1D1D',
                              fontWeight: '700',
                              fontSize: window.innerWidth < 600 ? '18px' : '20px',
                              textAlign: 'center',
                              fontFamily: 'Roboto, sans-serif',
                              letterSpacing: '-0.5px',
                              margin: 0
                           }}
                        >
                           {t('community.post.editPost')}
                        </Typography>
                     </div>

                     {/* Content section: editor outside scroll so popups (link/emoji) are not clipped on mobile */}
                     <div
                        style={{
                           flex: 1,
                           minHeight: 0,
                           display: 'flex',
                           flexDirection: 'column',
                           overflow: 'visible',
                           opacity: editPostModalAnimating ? 1 : 0,
                           transform: editPostModalAnimating ? 'translateY(0)' : 'translateY(20px)',
                           transition: 'all 0.4s ease-out',
                           transitionDelay: editPostModalAnimating ? '0.2s' : '0s',
                        }}
                     >
                        {/* Editor block - overflow visible so toolbar popups are not clipped */}
                        {/* <div style={{ flex: '0 0 auto', overflow: 'visible', padding: '20px 25px 10px 25px' }}>
                           <Grid xs={12} container justifyContent={'center'} alignItems={'center'}>
                              <Grid xs={12} style={{ paddingBottom: '10px', paddingTop: '10px', backgroundColor: 'white', borderRadius: '10px' }}>
                                 <Box sx={{ borderRadius: '8px', overflow: 'visible' }}>
                                    <TextEditor
                                       currentText={editPostData || ''}
                                       parentCallback={(text) => setEditPostData(text)}
                                       page="post"
                                       toolbarOptions={['inline', 'list', 'link', 'emoji', 'fontFamily']}
                                       textEditorTextLength={25000}
                                       lengthCallback={(length) => {
                                          setEditPostTextLength(length);
                                          if (length >= 25000) {
                                             setSnackbarColor('var(--danger-color)');
                                             setSnackbarType('error');
                                             setSnackbarMsg(t('community.post.maxCharLimit5000'));
                                             setSnackbarOpen(true);
                                          }
                                       }}
                                       placeholder={t('community.post.enterNewDescription')}
                                       editorClassName="editorClassNameTextText"
                                    />
                                 </Box>
                              </Grid>
                           </Grid>
                        </div> */}
                        {/* Scrollable form content below editor */}
                        <div
                           style={{
                              flex: 1,
                              minHeight: 0,
                              overflowY: 'auto',
                              overflowX: 'visible',
                              padding: '10px 25px 20px 25px',
                              WebkitOverflowScrolling: 'touch',
                           }}
                        >
                        {/* Editor block - overflow visible so toolbar popups are not clipped */}
                        <div style={{ flex: '0 0 auto', overflow: 'visible' }}>
                           <Grid xs={12} container justifyContent={'center'} alignItems={'center'}>
                              <Grid xs={12} style={{ paddingBottom: '10px', paddingTop: '10px', backgroundColor: 'white', borderRadius: '10px' }}>
                                 <Box sx={{ borderRadius: '8px', overflow: 'visible' }}>
                                    <MantineEditorWrapper>
                                       <MantineRichTextEditor
                                          value={editPostData || ''}
                                          onChange={(text) => {
                                             setEditPostData(decode(text));
                                             setEditPostTextLength(text.length);
                                             if (text.length >= 25000) {
                                                setSnackbarColor('var(--danger-color)');
                                                setSnackbarType('error');
                                                setSnackbarMsg(t('community.post.maxCharLimit5000'));
                                                setSnackbarOpen(true);
                                             }
                                          }}
                                          placeholder={t('community.post.enterNewDescription')}
                                          minHeight={200}
                                          maxHeight={300}
                                          maxLength={25000}
                                       />
                                    </MantineEditorWrapper>
                                 </Box>
                              </Grid>
                           </Grid>
                        </div>
                        <Grid xs={12}
                              container
                              justifyContent={'center'}
                              alignItems={'center'}
                        >
                              <Grid xs={12} style={{paddingBottom:'10px',paddingTop:'10px'}}>
                                 <Typography
                                    style={{
                                       color: '#1D1D1D',
                                       fontSize: '13px',
                                       fontWeight: 600,
                                       marginBottom: '6px',
                                    }}
                                 >
                                    {t('community.post.postCategory')}
                                 </Typography>
                                 <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                                    <FormControl fullWidth size="small" sx={{ flex: 1 }}>
                                       <Select
                                          value={selectedCategory || 'all'}
                                          onChange={handleCategoryChange}
                                          displayEmpty
                                          sx={{
                                             backgroundColor: '#fff',
                                             borderRadius: '8px',
                                             maxHeight: '42px',
                                             minHeight: '42px',
                                             '& .MuiSelect-select': {
                                                padding: '8px 14px',
                                                textTransform: 'capitalize',
                                             },
                                          }}
                                          MenuProps={{ 
                                             style: { zIndex: 9999 },
                                             PaperProps: {
                                                sx: {
                                                   maxHeight: 300,
                                                },
                                             },
                                          }}
                                       >
                                          {availableCategories && availableCategories.length > 0 ? (
                                             availableCategories.map((category) => (
                                                <MenuItem 
                                                   key={category} 
                                                   value={category}
                                                   sx={{
                                                      textTransform: 'capitalize',
                                                   }}
                                                >
                                                   {category.toLowerCase() === 'all' ? t('community.allTab') : formatCategoryName(category)}
                                                </MenuItem>
                                             ))
                                          ) : (
                                             <MenuItem value="all">{t('community.post.all')}</MenuItem>
                                          )}
                                       </Select>
                                    </FormControl>
                                    {onEditCategory && (
                                       <Button
                                          variant="outlined"
                                          size="small"
                                          onClick={() => {
                                             if (onEditCategory) {
                                                onEditCategory(null);
                                             }
                                          }}
                                          sx={{
                                             minWidth: 'auto',
                                             padding: '8px 16px',
                                             borderRadius: '8px',
                                             borderColor: '#C7D1DE',
                                             color: '#1D1D1D',
                                             fontSize: '13px',
                                             fontWeight: 500,
                                             textTransform: 'none',
                                             whiteSpace: 'nowrap',
                                             height: '42px',
                                             '&:hover': {
                                                borderColor: '#6C89AF',
                                                backgroundColor: 'rgba(110, 137, 175, 0.04)',
                                             },
                                          }}
                                       >
                                          {t('community.post.newCategory')}
                                       </Button>
                                    )}
                                 </div>
                                 <Typography
                                    variant="caption"
                                    style={{
                                       display: 'block',
                                       marginTop: '6px',
                                       color: '#6E89AF',
                                       fontSize: '11px',
                                       lineHeight: 1.4,
                                    }}
                                 >
                                    {t('community.post.categoryHint')}
                                 </Typography>
                              </Grid>

                              <Grid xs={12} style={{paddingBottom:'10px',paddingTop:'10px'}}>
                                 <Typography
                                    style={{
                                       color: '#1D1D1D',
                                       fontSize: '13px',
                                       fontWeight: 600,
                                       marginBottom: '6px',
                                       display: 'flex',
                                       alignItems: 'center',
                                    }}
                                 >
                                    {t('community.composer.scheduleThisPost')}
                                    <span style={{ color: '#9CA3AF', fontWeight: 500, marginLeft: '6px' }}>
                                       ({t('community.composer.optional')})
                                    </span>
                                 </Typography>
                                 <style>{`
                                    .community-edit-schedule-datetimepicker input {
                                       border-radius: 8px !important;
                                       border-color: rgba(0, 0, 0, 0.23) !important;
                                    }
                                    .community-edit-schedule-datetimepicker input:focus,
                                    .community-edit-schedule-datetimepicker input:active {
                                       border-color: var(--brand-color) !important;
                                    }
                                 `}</style>
                                 <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                                    <div style={{ flex: 1 }}>
                                       <DateTimePicker
                                          className="community-edit-schedule-datetimepicker"
                                          isCentered={true}
                                          id="community-edit-schedule-datetimepicker"
                                          placeholder={t('community.composer.selectScheduleDate')}
                                          value={scheduleDateEditValue}
                                          onChange={(newDateTime) => {
                                             if (newDateTime < new Date()) {
                                                setScheduleDateEditError(t('community.composer.scheduleDatePast'));
                                                return;
                                             }
                                             setScheduleDateEditError('');
                                             setScheduleDateEdit(newDateTime);
                                          }}
                                          formatStyle="large"
                                          okLabel={t('community.composer.schedulePost')}
                                          cancelLabel={t('common.cancel')}
                                          icon={<FaCalendar style={{ color: 'var(--secondary-icon-color)' }} />}
                                       />
                                       <p style={{ color: '#999', fontSize: '11px', margin: '6px 0 0 0', fontStyle: 'italic' }}>
                                          {Intl.DateTimeFormat().resolvedOptions().timeZone}
                                       </p>
                                    </div>
                                    {scheduleDateEditValue && (
                                       <Button
                                          variant="outlined"
                                          size="small"
                                          onClick={() => {
                                             setScheduleDateEdit(null);
                                             setScheduleDateEditError('');
                                          }}
                                          sx={{
                                             minWidth: 'auto',
                                             padding: '8px 16px',
                                             borderRadius: '8px',
                                             borderColor: 'var(--danger-color)',
                                             color: 'var(--danger-color)',
                                             fontSize: '13px',
                                             fontWeight: 500,
                                             textTransform: 'none',
                                             whiteSpace: 'nowrap',
                                             height: '42px',
                                             '&:hover': {
                                                borderColor: 'var(--danger-color)',
                                                backgroundColor: 'rgba(220, 38, 38, 0.04)',
                                             },
                                          }}
                                       >
                                          {t('community.composer.clearSchedule')}
                                       </Button>
                                    )}
                                 </div>
                                 {scheduleDateEditError && (
                                    <Typography variant="caption" sx={{ color: 'var(--danger-color)', display: 'block', marginTop: '6px' }}>
                                       {scheduleDateEditError}
                                    </Typography>
                                 )}
                              </Grid>

                              {/* Content displayed here*/}
                              <Grid xs={12} style={{paddingBottom:'10px',paddingTop:'10px',}}>
                                 {selectedPreviewUrlEdit &&
                                 <div style={{ position: 'relative', padding: '0px 0px 0px 0px'}}>
                                    {fileTypeEdit === 'img' &&
                                    <>
                                       {/* check if image updated or showing */}
                                       <ImagePost pre_upload={true} fullscreen={false} image_src={selectedPreviewUrlEdit} handleFullscreenOpen={handleFullscreenOpen}/>


                                       <div style={{position: 'absolute', top: '-10px', right: '-10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </>

                                    }
                                    {fileTypeEdit === 'vid' &&
                                    <div style={{ borderRadius: '8px', overflow: 'hidden' }}>
                                       <VideoPost pre_upload={true} video_src={selectedPreviewUrlEdit}/>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </div>
                                    }
                                    {fileTypeEdit === 'vey' &&
                                    <div style={{ borderRadius: '8px', overflow: 'hidden' }}>
                                       <YoutubePost video_src={selectedPreviewUrlEdit}/>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </div>
                                    }
                                    {fileTypeEdit === 'vel' &&
                                    <div style={{ borderRadius: '8px', overflow: 'hidden' }}>
                                       <LoomPost video_src={selectedPreviewUrlEdit}/>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </div>
                                    }
                                    {fileTypeEdit === 'vev' &&
                                    <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden' }}>
                                       <iframe
                                          src={"https://player.vimeo.com/video/" + selectedPreviewUrlEdit}
                                          frameborder="0"
                                          allow="autoplay; fullscreen; picture-in-picture"
                                          allowfullscreen
                                          style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                       ></iframe>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </div>
                                    }
                                    {fileTypeEdit === 'vtw' && selectedPreviewUrlEdit &&
                                    <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden' }}>
                                       <iframe
                                          src={
                                             selectedPreviewUrlEdit.startsWith('ch')
                                                ? "https://player.twitch.tv/?channel=" + selectedPreviewUrlEdit.slice(2) + "&parent=" + window.location.hostname
                                                : selectedPreviewUrlEdit.startsWith('c')
                                                ? "https://clips.twitch.tv/embed?clip=" + selectedPreviewUrlEdit.slice(1) + "&parent=" + window.location.hostname
                                                : "https://player.twitch.tv/?video=" + selectedPreviewUrlEdit.slice(1) + "&parent=" + window.location.hostname
                                          }
                                          frameborder="0"
                                          allow="autoplay; fullscreen"
                                          allowfullscreen
                                          style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                       ></iframe>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </div>
                                    }
                                    {fileTypeEdit === 'vwi' &&
                                    <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden' }}>
                                       <iframe
                                          src={"https://fast.wistia.com/embed/iframe/" + selectedPreviewUrlEdit + "?autoPlay=false"}
                                          frameborder="0"
                                          allow="autoplay; fullscreen"
                                          allowfullscreen
                                          style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                       ></iframe>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </div>
                                    }

                                    {['gos', 'god'].includes(fileTypeEdit) &&
                                       <Box
                                          sx={{
                                             display: 'flex',
                                             alignItems: 'center',
                                             height: '60px',
                                             backgroundColor: '#fff',
                                             border: '1px solid #E4EBF6',
                                             borderRadius: '8px',
                                             padding: '0 16px',
                                             marginBottom: '16px',
                                             position: 'relative'
                                          }}
                                       >
                                          {fileTypeEdit === 'gos' && <img src={GoogleSheetsImage} alt={t('dashboard.paidDms.googleSheets')} style={{ width: '24px', marginRight: '16px' }} />}
                                          {fileTypeEdit === 'god' && <img src={GoogleDocsImage} alt={t('dashboard.paidDms.googleDocs')} style={{ width: '24px', marginRight: '16px' }} />}
                                          <Box sx={{ flexGrow: 1 }}>
                                             <p style={{ fontWeight: 500, fontFamily: 'Roboto', color: '#000', margin: 0 }}>
                                                {fileTypeEdit === 'gos' && 'Google Sheets'}
                                                {fileTypeEdit === 'god' && 'Google Docs'}
                                             </p>
                                          </Box>
                                          <Button
                                             variant="contained"
                                             disableElevation
                                             onClick={() => handleFullscreenOpen(normalizeExternalHref(selectedPreviewUrlEdit), fileTypeEdit)}
                                             rel="noopener noreferrer"
                                             sx={{
                                                padding: '5px 7px',
                                                display: 'inline-block',
                                                marginLeft: 'auto',
                                                borderRadius: '8px !important',
                                                textTransform: 'none',
                                                textAlign: 'center',
                                                backgroundColor: 'var(--brand-color)',
                                                '&:hover': {
                                                   backgroundColor: 'var(--brand-color-hover)'
                                                },
                                                cursor: 'pointer'
                                             }}>
                                             <span className="fa fa-search" style={{ fontWeight: '500', fontSize: '14px' }}>
                                                Open
                                             </span>
                                          </Button>
                                          <div style={{ position: 'absolute', top: '-10px', right: '-10px', cursor: 'pointer', zIndex: 10 }}>
                                             <IconButton onClick={handleRemoveEditContent} size="small"
                                                sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                             </IconButton>
                                          </div>
                                       </Box>
                                    }  

                                    {fileTypeEdit === 'aud' &&

                                    <div style={{ position: 'relative' }}>
                                       <div className="image_container" style={{position: 'relative'}}>
                                          <ReactAudioPlayer
                                             className='react-player'
                                             src={selectedPreviewUrlEdit}
                                             // autoPlay
                                             controls
                                             style={{ width: '100%', margin: '0px', borderRadius: '0px' }}
                                             // onLoadedMetadata={handleAudioLoadMetadata}
                                          />
                                          <div style={{ position: 'absolute', top: '11px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                             <IconButton onClick={handleRemoveEditContent} size="small"
                                                sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                             </IconButton>
                                          </div>
                                       </div>
                                    </div>
                                    }
                            
                                    {(selectedPreviewUrlEdit && ['mot', 'mgm', 'mzm', 'mmt'].includes(fileTypeEdit)) &&
                                       <div style={{ position: 'relative', padding: '0px' }}>
                                          <Box
                                             sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                height: '60px',
                                                border: '1px solid #E4EBF6',
                                                backgroundColor: '#fff',
                                                borderRadius: '8px',
                                                padding: '0 16px',
                                                marginBottom: '16px'
                                             }}
                                          >
                                             {fileTypeEdit === 'mot' && <FaLink style={{ width: '24px', marginRight: '16px', color: '#6C89AF' }} />}
                                             {fileTypeEdit === 'mgm' && <img src={GoogleMeetImage} alt={t('community.composer.googleMeet')} style={{ width: '24px', marginRight: '16px' }} />}
                                             {fileTypeEdit === 'mmt' && <img src={MicrosoftTeams} alt={t('community.composer.microsoftTeams')} style={{ width: '24px', marginRight: '16px' }} />}
                                             {fileTypeEdit === 'mzm' && <img src={ZoomImage} alt={t('profile.zoom')} style={{ width: '24px', marginRight: '16px' }} />}
                                             <Box sx={{ flexGrow: 1 , display: 'flex', alignItems: 'center'}}>
                                                <p style={{ fontWeight: 500, fontFamily: 'Roboto', color: '#000', margin: 0 }}>
                                                   {fileTypeEdit === 'mot' && 'Meeting'}
                                                   {fileTypeEdit === 'mgm' && 'Google Meet'}
                                                   {fileTypeEdit === 'mmt' && 'Microsoft Teams'}
                                                   {fileTypeEdit === 'mzm' && 'Zoom'}
                                                </p>
                                                {/* <p style={{ color: '#6C89AF', fontSize: '0.75rem', fontWeight: '500', margin: '2px 0px 0px 0px' }}>
                                                   {fileTypeEdit === 'mzm' ? 'Tomorrow at 10:00 AM' : 'Today at 3:00 PM'}
                                                </p> */}
                                             </Box>

                                             <Button
                                                variant="contained"
                                                disableElevation
                                                href={normalizeExternalHref(selectedPreviewUrlEdit)}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                sx={{
                                                   padding: '5px 7px',
                                                   display: 'inline-block',
                                                   marginLeft: 'auto',
                                                   borderRadius: '8px !important',
                                                   textTransform: 'none',
                                                   textAlign: 'center',
                                                   backgroundColor: 'var(--brand-color)',
                                                   '&:hover': {
                                                      backgroundColor: 'var(--brand-color-hover)'
                                                   }
                                                }}>

                                                <span className="fa fa-search" style={{ fontWeight: '500', fontSize: '14px' }}>
                                                   {t('community.post.join')}
                                                </span>
                                             </Button>
                                          </Box>
                                          <div style={{ position: 'absolute', top: '-10px', right: '-10px', cursor: 'pointer', zIndex: 10 }}>
                                             <IconButton onClick={handleRemoveEditContent} size="small"
                                                sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                             </IconButton>
                                          </div>

                                          {/* Existing event image */}
                                          {(content_file && !selectedFileEdit) && (
                                             <Box sx={{ margin: '16px 0px 0px 0px' }}>
                                                <ImagePost image_src={content_file} handleFullscreenOpen={handleFullscreenOpen}/>
                                             </Box>
                                          )}

                                          {/* New event image */}
                                          {(meetingType === 'edit' && meetingImageEdit && selectedFileEdit) && (
                                             <Box sx={{ margin: '16px 0px 0px 0px' }}>
                                                <ImagePost 
                                                   image_src={meetingImageEdit.startsWith('blob:') || meetingImageEdit.startsWith('http') ? meetingImageEdit : paths.CONTENT_CLOUDFRONT + meetingImageEdit} 
                                                   handleFullscreenOpen={handleFullscreenOpen}
                                                   pre_upload={meetingImageEdit.startsWith('blob:')}
                                                />
                                             </Box>
                                          )}
                                       </div>
                                    }

                                    {fileTypeEdit === 'pdf' &&
                                    <>

                                       <PDFPost fullscreen={fullscreenViewOpen} pdf_src={selectedPreviewUrlEdit} pre_upload={true} content_width_type={'post'} handleFullscreenPDFOpen={handleFullscreenPDFOpen}/>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </>
                                    }

                                 </div>
                                 }                           
                                 <div>
                                    {

                                       isMediaAttachedEdit ?
                                          // NOT SHOWING CONTENT UPLOAD OPTIONS IF UPLOADED & IN PREVIEW (ONLY ONE CONTENT UPLOAD PER POST)
                                          null
                                          :
                                                <div
                                                   style={{
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      marginTop: '3px',
                                                      justifyContent: 'space-between', // Add spacing between the buttons
                                                   }}
                                                >
                                                   <DarkTooltip title={t('community.composer.uploadImage')} placement="bottom">
                                                   <span
                                                      onClick={handleEditImage}
                                                      className="fa fa-search" style={{fontWeight: '600', textAlign: 'center', fontSize: '14px', cursor: 'pointer', width: '19%', backgroundColor: '#F5F9FF',  display: 'flex', borderRadius: '6px'}}>
                                                                    {
                                                                       window.innerWidth > 1280 ?
                                                                          <div style={{ margin: 'auto', display: 'flex', width: '55px', padding: '8px 0px', justifyContent: 'center' }}>
                                                                             <FaFileImage style={{color: '#6C89AF', margin: 'auto 0px auto auto', width: '40px', fontSize: '14px', display: 'inline-block'}}/>
                                                                             <p style={{color: '#6C89AF', margin: 'auto auto auto 0px', display: 'inline-block', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.image')}</p>
                                                                          </div>
                                                                          :
                                                                          <div style={{ margin: 'auto', display: 'block', width: '100%', padding: '8px 0px' }}>
                                                                             <FaFileImage style={{color: '#6C89AF', margin: 'auto', width: '100%', fontSize: '16px'}}/>

                                                                             { window.innerWidth < 1280 ?
                                                                                <p style={{color: '#6C89AF', margin: ' 0px auto 0px auto', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.image')}</p>
                                                                                : null }
                                                                          </div>
                                                                    }

                                                               </span>
                                                   </DarkTooltip>


                                                   <DarkTooltip title={t('community.composer.uploadOrEmbedVideo')} placement="bottom">
                                                   <span
                                                      onClick={handleClickEditVideo}
                                                      className="fa fa-search" style={{fontWeight: '600', textAlign: 'center', fontSize: '14px', cursor: 'pointer', width: '19%', backgroundColor: '#F5F9FF',  display: 'flex', borderRadius: '6px'}}>
                                                                     {
                                                                        window.innerWidth > 1280 ?
                                                                           <div style={{ margin: 'auto', display: 'flex', width: '55px', padding: '8px 0px', justifyContent: 'center' }}>
                                                                              <FaFileVideo style={{color: '#6C89AF', margin: 'auto 0px auto auto', width: '40px', fontSize: '14px', display: 'inline-block'}}/>
                                                                              <p style={{color: '#6C89AF', margin: 'auto auto auto 0px', display: 'inline-block', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.video')}</p>
                                                                           </div>
                                                                           :
                                                                           <div style={{ margin: 'auto', display: 'block', width: '100%', padding: '8px 0px' }}>
                                                                              <FaFileVideo style={{color: '#6C89AF', margin: 'auto', width: '100%', fontSize: '16px'}}/>

                                                                              { window.innerWidth < 1280 ?
                                                                                 <p style={{color: '#6C89AF', margin: ' 0px auto 0px auto', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.video')}</p>
                                                                                 : null }
                                                                           </div>
                                                                     }

                                                               </span>
                                                   </DarkTooltip>
                                                   <Menu
                                                   id="simple-menu"
                                                   anchorEl={anchorElEditVideo}
                                                   keepMounted
                                                   anchorOrigin={{
                                                      vertical: 'bottom',
                                                      horizontal: 'center',
                                                   }}
                                                   transformOrigin={{
                                                      vertical: 'top',
                                                      horizontal: 'center',
                                                   }}
                                                   open={Boolean(anchorElEditVideo)}
                                                   onClose={handleClickEditVideo}
                                                   sx={{
                                                      "& .MuiPaper-root": {
                                                         backgroundColor: "#fff",
                                                         boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 12px 0px, rgba(229, 229, 229, 0.05) 0px 0px 0px 1px;',
                                                         border: '1px #f4f4f4 solid'
                                                      },
                                                      zIndex: 9999,
                                                   }}>

                                                   <div>

                                                      <MenuItem type="button" onClick={() => {
                                                         handleCloseEditVideo();
                                                         handleEditVideo();
                                                      }}
                                                      sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}>
                                                      <FaFileVideo
                                                      style={{ verticalAlign: 'middle', color: '#6C89AF', marginRight: '8px', width: '16px', height: '16px' }} />
                                                   {t('community.composer.upload')}
                                                      </MenuItem>
                                                      <MenuItem
                                                         onClick={() => {
                                                            handleCloseEditVideo();
                                                            setEmbedUrlIsOpen(true);
                                                            setSnackbarEmbed(false);
                                                            setEmbedUrlType('edit');
                                                         }}
                                                         sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}>
                                                         <ImEmbed2
                                                   style={{verticalAlign: 'middle', width: '16px', height: '16px', color: '#6C89AF', marginRight: '8px'}}/>
                                                      {t('community.composer.embed')}
                                                      </MenuItem>
                                                   </div>
                                                   </Menu>

                                                   <DarkTooltip title={t('community.composer.uploadAudio')} placement="bottom">
                                                   <span
                                                      // onClick={handleClickEdit}
                                                      onClick={() => {
                                                         handleCloseEdit();
                                                         handleEditAudio();
                                                      }}
                                                      className="fa fa-search" style={{fontWeight: '600', textAlign: 'center', fontSize: '14px', cursor: 'pointer', width: '19%', backgroundColor: '#F5F9FF',  display: 'flex', borderRadius: '6px'}}>
                                                                 {
                                                                    window.innerWidth > 1280 ?
                                                                       <div style={{ margin: 'auto', display: 'flex', width: '55px', padding: '8px 0px', justifyContent: 'center' }}>
                                                                          <FaFileAudio style={{color: '#6C89AF', margin: 'auto 0px auto auto', width: '40px', fontSize: '14px', display: 'inline-block'}}/>
                                                                          <p style={{color: '#6C89AF', margin: 'auto auto auto 0px', display: 'inline-block', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.audio')}</p>
                                                                       </div>
                                                                       :
                                                                       <div style={{ margin: 'auto', display: 'block', width: '100%', padding: '8px 0px' }}>
                                                                          <FaFileAudio style={{color: '#6C89AF', margin: 'auto', width: '100%', fontSize: '16px'}}/>

                                                                          { window.innerWidth < 1280 ?
                                                                             <p style={{color: '#6C89AF', margin: ' 0px auto 0px auto', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.audio')}</p>
                                                                             : null }
                                                                       </div>
                                                                 }

                                                               </span>
                                                   </DarkTooltip>
                                                   <Menu
                                                   id="simple-menu"
                                                   anchorEl={anchorElEdit}
                                                   keepMounted
                                                   anchorOrigin={{
                                                      vertical: 'bottom',
                                                      horizontal: 'center',
                                                   }}
                                                   transformOrigin={{
                                                      vertical: 'top',
                                                      horizontal: 'center',
                                                   }}
                                                   open={Boolean(anchorElEdit)}
                                                   onClose={handleClickEdit}
                                                   sx={{
                                                      "& .MuiPaper-root": {
                                                         backgroundColor: "#fff",
                                                         boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 12px 0px, rgba(229, 229, 229, 0.05) 0px 0px 0px 1px;',
                                                         border: '1px #f4f4f4 solid'
                                                      }
                                                   }}>
                                                   <div>

                                                      <MenuItem type="button" onClick={() => {
                                                         handleCloseEdit();
                                                         handleEditAudio();
                                                      }}
                                                      sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}>
                                                      <FaFileAudio
                                                      style={{ verticalAlign: 'middle', color: '#6C89AF', marginRight: '8px', width: '16px', height: '16px' }} />
                                                   {t('community.composer.upload')}
                                                      </MenuItem>
                                                   </div>
                                                   </Menu>

                                                   <DarkTooltip title={t('community.composer.uploadDoc')} placement="bottom">
                                                   <span
                                                      onClick={handleClickEditDoc}
                                                      className="fa fa-search" style={{fontWeight: '600', textAlign: 'center', fontSize: '14px', cursor: 'pointer', width: '19%', backgroundColor: '#F5F9FF',  display: 'flex', borderRadius: '6px'}}>
                                                                       {
                                                                          window.innerWidth > 1280 ?
                                                                             <div style={{ margin: 'auto', display: 'flex', width: '55px', padding: '8px 0px', justifyContent: 'center' }}>
                                                                                <FaFile style={{color: '#6C89AF', margin: 'auto 0px auto auto', width: '40px', fontSize: '14px', display: 'inline-block'}}/>
                                                                                <p style={{color: '#6C89AF', margin: 'auto auto auto 0px', display: 'inline-block', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.doc')}</p>
                                                                             </div>
                                                                             :
                                                                             <div style={{ margin: 'auto', display: 'block', width: '100%', padding: '8px 0px' }}>
                                                                                <FaFile style={{color: '#6C89AF', margin: 'auto', width: '100%', fontSize: '16px'}}/>

                                                                                { window.innerWidth < 1280 ?
                                                                                   <p style={{color: '#6C89AF', margin: ' 0px auto 0px auto', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.doc')}</p>
                                                                                   : null }
                                                                             </div>
                                                                       }

                                                               </span>
                                                   </DarkTooltip>
                                                   <Menu
                                                      id="simple-menu"
                                                      anchorEl={anchorElEditDoc}
                                                      keepMounted
                                                      anchorOrigin={{
                                                         vertical: 'bottom',
                                                         horizontal: 'center',
                                                      }}
                                                      transformOrigin={{
                                                         vertical: 'top',
                                                         horizontal: 'center',
                                                      }}
                                                      open={Boolean(anchorElEditDoc)}
                                                      onClose={handleCloseEditDoc}
                                                      sx={{
                                                         "& .MuiPaper-root": {
                                                            backgroundColor: "#fff",
                                                            boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 12px 0px, rgba(229, 229, 229, 0.05) 0px 0px 0px 1px;',
                                                            border: '1px #f4f4f4 solid'
                                                         },
                                                         zIndex: 9999,
                                                      }}>

                                                      {/*   comment.username === props.username || props.current_user_display_name === props.username ?*/}
                                                      <div>

                                                         <MenuItem type="button" onClick={() => {
                                                            handleCloseEditDoc();
                                                            handleEditPDF();
                                                         }}
                                                         sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}>
                                                         <FaFilePdf
                                                         style={{ verticalAlign: 'middle', color: '#6C89AF', marginRight: '8px' }} />
                                                      {t('community.post.uploadPdf')}
                                                         </MenuItem>


                                                         <MenuItem
                                                            onClick={() => {
                                                               handleCloseEditDoc();
                                                               setDocModalOpen(true);
                                                               setFileTypeEdit('gos');
                                                               setDocType('edit');
                                                               setActiveDocFileType('gos');
                                                               setSnackbarOpenDoc(false);
                                                            }}
                                                            sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}>
                                                            <img src={GoogleSheetsImage}
                                                           style={{ verticalAlign: 'middle', color: '#6C89AF', width: '16px', height: '16px', marginRight: '8px' }} />
                                                        {t('community.composer.googleSheet')}
                                                         </MenuItem>
                                                         <MenuItem
                                                            onClick={() => {
                                                               handleCloseEditDoc();
                                                               setDocModalOpen(true);
                                                               setFileTypeEdit('god');
                                                               setDocType('edit');
                                                               setActiveDocFileType('god');
                                                               setSnackbarOpenDoc(false);
                                                            }}
                                                            sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}>
                                                            <img src={GoogleDocsImage}
                                                            style={{ verticalAlign: 'middle', color: '#6C89AF', width: '16px', height: '16px', marginRight: '8px' }} />
                                                         {t('community.composer.googleDoc')}
                                                         </MenuItem>
                                                      </div>
                                                   </Menu>
                                                   <DarkTooltip title={t('community.composer.addMeeting')} placement="bottom">
                                                               <span
                                                                  onClick={handleClickEditMeeting}
                                                                  className="fa fa-search" style={{fontWeight: '600', textAlign: 'center', fontSize: '14px', cursor: 'pointer', width: '19%', backgroundColor: '#F5F9FF',  display: 'flex', borderRadius: '6px'}}>
                                                                     {/*<div style={{ margin: 'auto', display: 'block', width: '100%', padding: '8px 0px' }}>*/}
                                                                     {/*   <FaFileImage style={{color: '#6C89AF', margin: 'auto', width: '100%', fontSize: '16px'}}/>*/}
                                                                     {/*   <p style={{color: '#6C89AF', margin: ' 0px auto 0px auto', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.image')}</p>*/}
                                                                     {/*</div>*/}

                                                                     {
                                                                     window.innerWidth > 1280 ?
                                                                        <div style={{ margin: 'auto', display: 'flex', width: '55px', padding: '8px 0px', justifyContent: 'center' }}>
                                                                           <FaRegCalendarAlt style={{color: '#6C89AF', margin: 'auto 0px auto auto', width: '40px', fontSize: '14px', display: 'inline-block'}}/>
                                                                           <p style={{color: '#6C89AF', margin: 'auto auto auto 0px', display: 'inline-block', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.meet')}</p>
                                                                        </div>
                                                                        :
                                                                        <div style={{ margin: 'auto', display: 'block', width: '100%', padding: '8px 0px' }}>
                                                                           <FaRegCalendarAlt style={{color: '#6C89AF', margin: 'auto', width: '100%', fontSize: '16px'}}/>
                                                                           <p style={{color: '#6C89AF', margin: ' 0px auto 0px auto', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.meet')}</p>
                                                                        </div>
                                                                  }


                                                               </span>
                                                </DarkTooltip>
                                                <Menu
                                                   id="simple-menu"
                                                   anchorEl={anchorElEditMeeting}
                                                   keepMounted
                                                   anchorOrigin={{
                                                      vertical: 'bottom',
                                                      horizontal: 'center',
                                                   }}
                                                   transformOrigin={{
                                                      vertical: 'top',
                                                      horizontal: 'center',
                                                   }}
                                                   open={Boolean(anchorElEditMeeting)}
                                                   onClose={handleCloseEditMeeting}
                                                   sx={{
                                                      "& .MuiPaper-root": {
                                                         backgroundColor: "#fff",
                                                         boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 12px 0px, rgba(229, 229, 229, 0.05) 0px 0px 0px 1px;',
                                                         border: '1px #f4f4f4 solid'
                                                      },
                                                      zIndex: 9999,
                                                   }}>

                                                   {/*   comment.username === props.username || props.current_user_display_name === props.username ?*/}
                                                   <div>

                                                      <MenuItem type="button" onClick={() => {
                                                         handleCloseEditMeeting();
                                                         setMeetingModalOpen(true);
                                                         setFileTypeEdit('mzm');
                                                         setMeetingType('edit');
                                                         setSnackbarOpenMeeting(false);
                                                      }}
                                                      sx={{color: 'black', fontWeight: '500', fontSize: '14px'}}>
                                                      <img src={ZoomImage}
                                                   style={{verticalAlign: 'middle', height: 'auto', width: '16px',  marginRight: '8px'}}/>
                                                   Zoom 
                                                      </MenuItem>


                                                      <MenuItem
                                                         onClick={() => {
                                                            handleCloseEditMeeting();
                                                            setMeetingModalOpen(true);
                                                            setFileTypeEdit('mgm');
                                                            setSnackbarOpenMeeting(false);
                                                            setMeetingType('edit');
                                                         }}
                                                         sx={{color: 'black', fontWeight: '500', fontSize: '14px'}}>
                                                         <img src={GoogleMeetImage}
                                                      style={{verticalAlign: 'middle', height: 'auto', width: '16px',  marginRight: '8px'}}/>
                                                      Google Meet 
                                                      </MenuItem>
                                                      <MenuItem
                                                         onClick={() => {
                                                            handleCloseEditMeeting();
                                                            setMeetingModalOpen(true);
                                                            setFileTypeEdit('mmt');
                                                            setMeetingType('edit');
                                                            setSnackbarOpenMeeting(false);
                                                         }}
                                                         sx={{color: 'black', fontWeight: '500', fontSize: '14px'}}>
                                                         <img src={MicrosoftTeams}
                                                      style={{verticalAlign: 'middle', height: 'auto', width: '16px',  marginRight: '8px'}}/>
                                                      Microsoft Teams 
                                                      </MenuItem>
                                                      <MenuItem
                                                         onClick={() => {
                                                            handleCloseEditMeeting();
                                                            setMeetingModalOpen(true);
                                                            setFileTypeEdit('mot');
                                                            setMeetingType('edit');
                                                            setSnackbarOpenMeeting(false);
                                                         }}
                                                         sx={{color: 'black', fontWeight: '500', fontSize: '14px'}}>
                                                         <FaLink
                                                      style={{verticalAlign: 'middle', color: '#6C89AF', width: '16px', height: '16px', marginRight: '8px'}}/>
                                                      Other 
                                                      </MenuItem>
                                                   </div>
                                                </Menu>
                                                </div>
                                    }
                                 </div>
                              </Grid>
                        </Grid>
                     </div>

                     {/* Action button section - fixed at bottom for mobile */}
                     <div
                        style={{
                           padding: '20px 25px 25px 25px',
                           borderTop: '1px solid #E4EBF6',
                           flexShrink: 0,
                           backgroundColor: '#fff',
                           opacity: editPostModalAnimating ? 1 : 0,
                           transform: editPostModalAnimating ? 'translateY(0)' : 'translateY(20px)',
                           transition: 'all 0.4s ease-out',
                           transitionDelay: editPostModalAnimating ? '0.3s' : '0s',
                           position: window.innerWidth < 900 ? 'sticky' : 'relative',
                           bottom: window.innerWidth < 900 ? '0' : 'auto',
                           left: 0,
                           right: 0,
                           zIndex: 2,
                        }}
                     >
                        <Button
                           disableRipple
                           fullWidth
                           variant="contained"
                           disabled={selectedPreviewUrlEdit === 'temp'}
                           sx={{
                              backgroundColor: selectedPreviewUrlEdit === 'temp' ? '#E4EBF6' : 'var(--brand-color)',
                              color: selectedPreviewUrlEdit === 'temp' ? '#9CA3B4' : 'white',
                              fontSize: '14px',
                              textTransform: 'none',
                              borderRadius: '12px',
                              boxShadow: 'none',
                              fontWeight: '600',
                              padding: '12px 20px',
                              border: selectedPreviewUrlEdit === 'temp' ? '2px solid #E4EBF6' : '2px solid var(--brand-color)',
                              transition: 'all 0.2s ease-in-out',
                              cursor: selectedPreviewUrlEdit === 'temp' ? 'not-allowed' : 'pointer',
                              '&:hover': selectedPreviewUrlEdit === 'temp' ? {
                                 backgroundColor: '#E4EBF6',
                                 border: '2px solid #E4EBF6',
                                 transform: 'none',
                                 boxShadow: 'none',
                              } : {
                                 backgroundColor: 'var(--brand-color)',
                                 border: '2px solid var(--brand-color)',
                                 opacity: 0.8,
                                 transform: 'translateY(-1px)',
                                 boxShadow: 'none',
                              },
                           }}
                           type="submit"
                           value="submit"
                           onClick={() => {
                              if (validateUpdatedContent(editPostData, fileTypeEdit) === true) {
                                 const scheduleDateToSend = scheduleDateEdit === undefined ? undefined : (scheduleDateEdit === null ? null : scheduleDateEdit.toISOString());
                                 editPost(editPostData, postId, postIndex, selectedPreviewUrlEdit, scheduleDateToSend);
                                 setMeetingTimeEditPost('')
                                 closeEditPostModal();
                              }
                           }}
                        >
                           Update
                        </Button>
                     </div>
                        </div>
                  </div>
               </div>,
               document.body
            )
         }

{
            // Snackbars rendered AFTER modal in separate portal with higher z-index to appear above edit modal
            editPostModal && (snackbarOpenOuter || snackbarOpenClick) && createPortal(
               <div style={{ 
                  position: 'fixed', 
                  top: 0, 
                  left: 0, 
                  right: 0, 
                  bottom: 0, 
                  pointerEvents: 'none', 
                  zIndex: 5000,
                  display: 'flex',
                  alignItems: 'flex-end',
                  justifyContent: 'center',
                  paddingBottom: '50px'
               }}>
                  <div style={{ pointerEvents: 'auto', zIndex: 5000 }}>
                     <SnackbarAlert
                        msg={snackbarMsgOuter}
                        open={snackbarOpenOuter}
                        backgroundColor={snackbarColorOuter}
                        severity={snackbarSeverityOuter}
                        handleClose={() => {
                           setSnackbarOpenOuter(false)
                        }}
                        autoHide={4000}
                     />
                     <SnackbarAlertClick
                        msg_pre={snackbarPreMsgClick}
                        msg_post={snackbarPostMsgClick}
                        click_text={snackbarTextClick}
                        click_process={() => {
                           var currentdate = new Date(); 
                           var datetime = currentdate.getDate() + "/"
                                          + (currentdate.getMonth()+1)  + "/" 
                                          + currentdate.getFullYear() + "_"  
                                          + currentdate.getHours() + ":"  
                                          + currentdate.getMinutes() + ":" 
                                          + currentdate.getSeconds();

                           saveFile(selectedPreviewUrlEdit, datetime+'_'+'recording'+recordedFileFormat)
                        }}
                        open={snackbarOpenClick}
                        severity={snackbarSeverityClick}
                        backgroundColor={snackbarColorClick}
                        handleClose={() => {
                           setSnackbarOpenClick(false)
                        }}
                        autoHide={null}
                     />
                  </div>
               </div>,
               document.body
            )
         }


         {
            // EDIT THREADS MODAL (MAIN COMMENT)
            editCommentThreadModal ?

               <Modal
                  sx={{backgroundColor: 'transparent', overflow: 'auto', display:'flex', outline: 'none', width: '100vw', minHeight: '100vh', zIndex: '9998'}}
                  open={handleEditCommentThread}
                  // closeAfterTransition
               >
                  <Fade in={handleEditCommentThread}>
                     <Grid
                        container
                        xs={12} md={9} lg={6}
                        alignItems="center"
                        justifyContent="center"
                        direction="column"
                        sx={{
                           width: '100vw',
                           minHeight:'100vh',
                           paddingTop: 'calc(30px + 1vw)',
                           paddingBottom: 'calc(30px + 1vw)',
                           overflow:'auto',
                           margin: '0px auto auto auto',
                        }}
                     >
                        <SnackbarAlert
                           msg={snackbarMsgOuter}
                           open={snackbarOpenOuter}
                           backgroundColor={snackbarColorOuter}
                           severity={snackbarSeverityOuter}
                           handleClose={() => {
                              setSnackbarOpenOuter(false)
                           }}
                           autoHide={4000}
                        />
                        <SnackbarAlertClick
                           msg_pre={snackbarPreMsgClick}
                           msg_post={snackbarPostMsgClick}
                           click_text={snackbarTextClick}
                           click_process={() => {
                              var currentdate = new Date(); 
                              var datetime = currentdate.getDate() + "/"
                                             + (currentdate.getMonth()+1)  + "/" 
                                             + currentdate.getFullYear() + "_"  
                                             + currentdate.getHours() + ":"  
                                             + currentdate.getMinutes() + ":" 
                                             + currentdate.getSeconds();

                              saveFile(selectedPreviewUrlEdit, datetime+'_'+'recording'+recordedFileFormat)
                           }}
                           open={snackbarOpenClick}
                           severity={snackbarSeverityClick}
                           backgroundColor={snackbarColorClick}
                           handleClose={() => {
                              setSnackbarOpenClick(false)
                           }}
                           autoHide={null}
                        />
                        <Grid sx={{
                           minHeight: '240px', backgroundColor: '#fff', borderRadius: '10px', margin: '30px auto',
                           maxWidth: 'calc(100% - 20px)', width: window.innerWidth >= 1280 ? '100%' : '800px', overflow:'auto',
                           boxShadow: '0 5px 25px 0 rgba(35, 40, 105, 0.04)' , padding: '25px 20px', position: 'relative',
                        }}>

                           <IoClose
                              onClick={() => {setEditCommentThreadModal(false)}}
                              style={{
                                 fontSize: '20px',
                                 fontWeight: '300',
                                 textAlign: 'right',
                                 display: 'flex',
                                 top: '15px',
                                 right: '15px',
                                 position: 'absolute',
                                 padding: '0px',
                                 cursor: 'pointer'
                              }}
                              color= '#023648'
                           />

                           <Grid
                              xs={12}
                              alignItems='center'
                              justifyContent='center'
                           >
                              <Typography
                                 style={{
                                    color: 'black',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    textTransform: 'none',
                                    textAlign: 'center',
                                    cursor: 'default',
                                    margin: '0px 0px 3px 0px',
                                    padding: '0px',
                                    backgroundColor:'transparent',
                                    width: '100%',
                                 }}
                              >
                                 {t('community.post.editComment')}
                              </Typography>
                           </Grid>


                           <Grid xs={12}
                                 container
                                 justifyContent={'center'}
                                 alignItems={'center'}
                           >
                              <Grid xs={12}
                                    style={{paddingBottom:'10px',paddingTop:'10px', backgroundColor: 'white', borderRadius: '10px'}}
                              >

                                 <TextField
                                    size="small"
                                    hiddenLabel
                                    name="post_description"
                                    placeholder={t('community.post.enterNewDescription')}
                                    inputProps={{ maxLength: 5000 }}
                                    multiline
                                    maxRows={8}
                                    minRows={2}
                                    value={editCommentThreadData}
                                    onChange={(event) =>
                                       setEditCommentThreadData(event.target.value)
                                    }

                                    style = {{
                                       width: '100%',
                                       border: '1px solid #C7D1DE',
                                       justifyContent: 'center',
                                       fontWeight: '500',
                                       marginRight: 'auto',
                                       marginTop: '0px',
                                    }}

                                    id="filled-basic1" variant="filled"
                                    InputProps={{
                                       style: {
                                          fontSize: '16px',
                                          color: '#1D1D1D',
                                          fontWeight: '500',
                                          borderRadius: '8px',
                                          padding: '0px 10px',
                                          backgroundColor: '#FFF'
                                       },
                                       disableUnderline: true,
                                    }}
                                    sx={{
                                       marginBottom: '0px',
                                       borderRadius: '5px',
                                       border: '0px',
                                       backgroundColor: '#fff',
                                       input : {
                                          color: '#1D1D1D',
                                       },
                                    }}
                                 />

                              </Grid>


                              {/* Content displayed here*/}
                              <Grid xs={12} style={{paddingBottom:'10px',paddingTop:'10px',}}>
                                 {selectedPreviewUrlEdit &&
                                 <div style={{ position: 'relative', padding: '0px 0px 0px 0px'}}>
                                    {fileTypeEdit === 'img' &&
                                    <>
                                       <ImagePost pre_upload={true} fullscreen={false} image_src={selectedPreviewUrlEdit} handleFullscreenOpen={handleFullscreenOpen}/>

                                       {/*<img*/}
                                       {/*   src={selectedPreviewUrlEdit}*/}
                                       {/*   alt={t('common.selectedImage')}*/}
                                       {/*   style={{*/}
                                       {/*      maxWidth: '100%',*/}
                                       {/*      height: 'auto',*/}
                                       {/*      borderRadius: '6px',*/}
                                       {/*      overflow: 'hidden',*/}
                                       {/*      margin: '0px 0px 10px 0px',*/}
                                       {/*   }}*/}
                                       {/*/>*/}
                                       <div style={{position: 'absolute', top: '-10px', right: '-10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </>

                                    }
                                    {fileTypeEdit === 'vid' &&
                                    <div style={{ borderRadius: '8px', overflow: 'hidden' }}>
                                       <VideoPost pre_upload={true} video_src={selectedPreviewUrlEdit}/>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </div>
                                    }
                                    {fileTypeEdit === 'vey' &&
                                    <div style={{ borderRadius: '8px', overflow: 'hidden' }}>
                                       <YoutubePost video_src={selectedPreviewUrlEdit}/>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </div>
                                    }
                                    {fileTypeEdit === 'vel' &&
                                    <div style={{ borderRadius: '8px', overflow: 'hidden' }}>
                                       <LoomPost video_src={selectedPreviewUrlEdit}/>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </div>
                                    }
                                    {fileTypeEdit === 'vev' &&
                                    <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden' }}>
                                       <iframe
                                          src={"https://player.vimeo.com/video/" + selectedPreviewUrlEdit}
                                          frameborder="0"
                                          allow="autoplay; fullscreen; picture-in-picture"
                                          allowfullscreen
                                          style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                       ></iframe>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </div>
                                    }
                                    {fileTypeEdit === 'vtw' && selectedPreviewUrlEdit &&
                                    <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden' }}>
                                       <iframe
                                          src={
                                             selectedPreviewUrlEdit.startsWith('ch')
                                                ? "https://player.twitch.tv/?channel=" + selectedPreviewUrlEdit.slice(2) + "&parent=" + window.location.hostname
                                                : selectedPreviewUrlEdit.startsWith('c')
                                                ? "https://clips.twitch.tv/embed?clip=" + selectedPreviewUrlEdit.slice(1) + "&parent=" + window.location.hostname
                                                : "https://player.twitch.tv/?video=" + selectedPreviewUrlEdit.slice(1) + "&parent=" + window.location.hostname
                                          }
                                          frameborder="0"
                                          allow="autoplay; fullscreen"
                                          allowfullscreen
                                          style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                       ></iframe>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </div>
                                    }
                                    {fileTypeEdit === 'vwi' &&
                                    <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden' }}>
                                       <iframe
                                          src={"https://fast.wistia.com/embed/iframe/" + selectedPreviewUrlEdit + "?autoPlay=false"}
                                          frameborder="0"
                                          allow="autoplay; fullscreen"
                                          allowfullscreen
                                          style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                       ></iframe>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </div>
                                    }

                                    {['gos', 'god'].includes(fileTypeEdit) &&
                                       <Box
                                          sx={{
                                             display: 'flex',
                                             alignItems: 'center',
                                             backgroundColor: '#fff',
                                             height: '60px',
                                             border: '1px solid #E4EBF6',
                                             borderRadius: '8px',
                                             padding: '0 16px',
                                             marginBottom: '16px',
                                             position: 'relative'
                                          }}
                                       >
                                          {fileTypeEdit === 'gos' && <img src={GoogleSheetsImage} alt={t('dashboard.paidDms.googleSheets')} style={{ width: '24px', marginRight: '16px' }} />}
                                          {fileTypeEdit === 'god' && <img src={GoogleDocsImage} alt={t('dashboard.paidDms.googleDocs')} style={{ width: '24px', marginRight: '16px' }} />}
                                          <Box sx={{ flexGrow: 1 }}>
                                             <p style={{ fontWeight: 500, fontFamily: 'Roboto', color: '#000', margin: 0 }}>
                                                {fileTypeEdit === 'gos' && 'Google Sheets'}
                                                {fileTypeEdit === 'god' && 'Google Docs'}
                                             </p>
                                          </Box>
                                          <Button
                                             variant="contained"
                                             disableElevation
                                             onClick={() => handleFullscreenOpen(normalizeExternalHref(selectedPreviewUrlEdit), fileTypeEdit)}
                                             rel="noopener noreferrer"
                                             sx={{
                                                padding: '5px 7px',
                                                display: 'inline-block',
                                                marginLeft: 'auto',
                                                borderRadius: '8px !important',
                                                textTransform: 'none',
                                                textAlign: 'center',
                                                backgroundColor: 'var(--brand-color)',
                                                '&:hover': {
                                                   backgroundColor: 'var(--brand-color-hover)'
                                                },
                                                cursor: 'pointer'
                                             }}>
                                             <span className="fa fa-search" style={{ fontWeight: '500', fontSize: '14px' }}>
                                                Open
                                             </span>
                                          </Button>
                                          <div style={{ position: 'absolute', top: '-10px', right: '-10px', cursor: 'pointer', zIndex: 10 }}>
                                             <IconButton onClick={handleRemoveEditContent} size="small"
                                                sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                             </IconButton>
                                          </div>
                                       </Box>
                                    }     


                                    
                                    {fileTypeEdit === 'aud' &&
                                    <div style={{ position: 'relative' }}>
                                       <div className="image_container" style={{position: 'relative'}}>
                                          <ReactAudioPlayer
                                             className='react-player'
                                             src={selectedPreviewUrlEdit}
                                             // autoPlay
                                             controls
                                             style={{ width: '100%', margin: '0px', borderRadius: '0px' }}
                                             // onLoadedMetadata={handleAudioLoadMetadata}
                                          />
                                          <div style={{ position: 'absolute', top: '11px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                             <IconButton onClick={handleRemoveEditContent} size="small"
                                                sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                             </IconButton>
                                          </div>
                                       </div>
                                    </div>
                                    }
                                    {(selectedPreviewUrlEdit && ['mot', 'mgm', 'mzm', 'mmt'].includes(fileTypeEdit)) &&
                                       <div style={{ position: 'relative', padding: '0px' }}>
                                          <Box
                                             sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                height: '60px',
                                                border: '1px solid #E4EBF6',
                                                backgroundColor: '#fff',
                                                borderRadius: '8px',
                                                padding: '0 16px',
                                                marginBottom: '16px'
                                             }}
                                          >
                                             {fileTypeEdit === 'mot' && <FaLink style={{ width: '24px', marginRight: '16px', color: '#6C89AF' }} />}
                                             {fileTypeEdit === 'mgm' && <img src={GoogleMeetImage} alt={t('community.composer.googleMeet')} style={{ width: '24px', marginRight: '16px' }} />}
                                             {fileTypeEdit === 'mmt' && <img src={MicrosoftTeams} alt={t('community.composer.microsoftTeams')} style={{ width: '24px', marginRight: '16px' }} />}
                                             {fileTypeEdit === 'mzm' && <img src={ZoomImage} alt={t('profile.zoom')} style={{ width: '24px', marginRight: '16px' }} />}
                                             <Box sx={{ flexGrow: 1 , display: 'flex', alignItems: 'center'}}>
                                                <p style={{ fontWeight: 500, fontFamily: 'Roboto', color: '#000', margin: 0 }}>
                                                   {fileTypeEdit === 'mot' && 'Meeting'}
                                                   {fileTypeEdit === 'mgm' && 'Google Meet'}
                                                   {fileTypeEdit === 'mmt' && 'Microsoft Teams'}
                                                   {fileTypeEdit === 'mzm' && 'Zoom'}
                                                </p>
                                                {/* <p style={{ color: '#6C89AF', fontSize: '0.75rem', fontWeight: '500', margin: '2px 0px 0px 0px' }}>
                                                   {fileTypeEdit === 'mzm' ? 'Tomorrow at 10:00 AM' : 'Today at 3:00 PM'}
                                                </p> */}
                                             </Box>

                                             <Button
                                                variant="contained"
                                                disableElevation
                                                href={normalizeExternalHref(selectedPreviewUrlEdit)}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                sx={{
                                                   padding: '5px 7px',
                                                   display: 'inline-block',
                                                   marginLeft: 'auto',
                                                   borderRadius: '8px !important',
                                                   textTransform: 'none',
                                                   textAlign: 'center',
                                                   backgroundColor: 'var(--brand-color)',
                                                   '&:hover': {
                                                      backgroundColor: 'var(--brand-color-hover)'
                                                   }
                                                }}>

                                                <span className="fa fa-search" style={{ fontWeight: '500', fontSize: '14px' }}>
                                                   {t('community.post.join')}
                                                </span>
                                             </Button>
                                          </Box>
                                          <div style={{ position: 'absolute', top: '-10px', right: '-10px', cursor: 'pointer', zIndex: 10 }}>
                                             <IconButton onClick={handleRemoveEditContent} size="small"
                                                sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                             </IconButton>
                                          </div>
                                       </div>
                                    }
                                    {fileTypeEdit === 'pdf' &&
                                    <>
                                       <PDFPost fullscreen={fullscreenViewOpen} pdf_src={selectedPreviewUrlEdit} pre_upload={true} content_width_type={'post'} handleFullscreenPDFOpen={handleFullscreenPDFOpen}/>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </>
                                    }

                                 </div>
                                 }

                                 <div>
                                    {

                                       isMediaAttachedEdit ?
                                          // NOT SHOWING CONTENT UPLOAD OPTIONS IF UPLOADED & IN PREVIEW (ONLY ONE CONTENT UPLOAD PER POST)
                                          null
                                          :
                                                <div
                                                   style={{
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      marginTop: '10px',
                                                      justifyContent: 'space-between', // Adds spacing between the buttons
                                                   }}
                                                >
                                                   <DarkTooltip title={t('community.composer.uploadImage')} placement="bottom">
                                                   <span
                                                      onClick={handleEditImage}
                                                      className="fa fa-search" style={{fontWeight: '600', textAlign: 'center', fontSize: '14px', cursor: 'pointer', width: '19%', backgroundColor: '#F5F9FF',  display: 'flex', borderRadius: '6px'}}>
                                                                      {
                                                                         window.innerWidth > 1280 ?
                                                                            <div style={{ margin: 'auto', display: 'flex', width: '55px', padding: '8px 0px', justifyContent: 'center' }}>
                                                                               <FaFileImage style={{color: '#6C89AF', margin: 'auto 0px auto auto', width: '40px', fontSize: '14px', display: 'inline-block'}}/>
                                                                               <p style={{color: '#6C89AF', margin: 'auto auto auto 0px', display: 'inline-block', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.image')}</p>
                                                                            </div>
                                                                            :
                                                                            <div style={{ margin: 'auto', display: 'block', width: '100%', padding: '8px 0px' }}>
                                                                               <FaFileImage style={{color: '#6C89AF', margin: 'auto', width: '100%', fontSize: '16px'}}/>

                                                                               { window.innerWidth < 1280 ?
                                                                                  <p style={{color: '#6C89AF', margin: ' 0px auto 0px auto', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.image')}</p>
                                                                                  : null }
                                                                            </div>
                                                                      }

                                                               </span>
                                                   </DarkTooltip>


                                                   <DarkTooltip title={t('community.composer.uploadOrEmbedVideo')} placement="bottom">
                                                   <span
                                                      onClick={handleClickEditVideo}
                                                      className="fa fa-search" style={{fontWeight: '600', textAlign: 'center', fontSize: '14px', cursor: 'pointer', width: '19%', backgroundColor: '#F5F9FF',  display: 'flex', borderRadius: '6px'}}>
                                                                     {
                                                                        window.innerWidth > 1280 ?
                                                                           <div style={{ margin: 'auto', display: 'flex', width: '55px', padding: '8px 0px', justifyContent: 'center' }}>
                                                                              <FaFileVideo style={{color: '#6C89AF', margin: 'auto 0px auto auto', width: '40px', fontSize: '14px', display: 'inline-block'}}/>
                                                                              <p style={{color: '#6C89AF', margin: 'auto auto auto 0px', display: 'inline-block', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.video')}</p>
                                                                           </div>
                                                                           :
                                                                           <div style={{ margin: 'auto', display: 'block', width: '100%', padding: '8px 0px' }}>
                                                                              <FaFileVideo style={{color: '#6C89AF', margin: 'auto', width: '100%', fontSize: '16px'}}/>

                                                                              { window.innerWidth < 1280 ?
                                                                                 <p style={{color: '#6C89AF', margin: ' 0px auto 0px auto', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.video')}</p>
                                                                                 : null }
                                                                           </div>
                                                                     }

                                                               </span>
                                                   </DarkTooltip>
                                                   <Menu
                                                   id="simple-menu"
                                                   anchorEl={anchorElEditVideo}
                                                   keepMounted
                                                   anchorOrigin={{
                                                      vertical: 'bottom',
                                                      horizontal: 'center',
                                                   }}
                                                   transformOrigin={{
                                                      vertical: 'top',
                                                      horizontal: 'center',
                                                   }}
                                                   open={Boolean(anchorElEditVideo)}
                                                   onClose={handleCloseEditVideo}
                                                   sx={{
                                                      "& .MuiPaper-root": {
                                                         backgroundColor: "#fff",
                                                         boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 12px 0px, rgba(229, 229, 229, 0.05) 0px 0px 0px 1px;',
                                                         border: '1px #f4f4f4 solid'
                                                      },
                                                      zIndex: 9999,
                                                   }}>

                                                   {/*   comment.username === username || current_user_display_name === username ?*/}
                                                   <div>

                                                      <MenuItem type="button" onClick={() => {
                                                         handleCloseEditVideo();
                                                         handleEditVideo();
                                                      }}
                                                      sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}>
                                                      <FaFileVideo
                                                      style={{ verticalAlign: 'middle', color: '#6C89AF', marginRight: '8px', width: '16px', height: '16px' }} />
                                                   {t('community.composer.upload')}
                                                      </MenuItem>

                                                      <MenuItem
                                                            onClick={() => {
                                                               handleCloseEditVideo();
                                                               setEmbedUrlIsOpen(true);
                                                               setSnackbarEmbed(false);
                                                               setEmbedUrlType('edit');
                                                            }}
                                                            sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}>
                                                            <ImEmbed2
                                                      style={{verticalAlign: 'middle', width: '16px', height: '16px', color: '#6C89AF', marginRight: '8px'}}/>
                                                         {t('community.composer.embed')}
                                                         </MenuItem>
                                                   </div>
                                                   </Menu>

                                                   <DarkTooltip title={t('community.composer.uploadAudio')} placement="bottom">
                                                   <span
                                                      // onClick={handleClickEdit}
                                                      onClick={() => {
                                                         handleCloseEdit();
                                                         handleEditAudio();
                                                      }}
                                                      className="fa fa-search" style={{fontWeight: '600', textAlign: 'center', fontSize: '14px', cursor: 'pointer', width: '19%', backgroundColor: '#F5F9FF',  display: 'flex', borderRadius: '6px'}}>
                                                                    {
                                                                       window.innerWidth > 1280 ?
                                                                          <div style={{ margin: 'auto', display: 'flex', width: '55px', padding: '8px 0px', justifyContent: 'center' }}>
                                                                             <FaFileAudio style={{color: '#6C89AF', margin: 'auto 0px auto auto', width: '40px', fontSize: '14px', display: 'inline-block'}}/>
                                                                             <p style={{color: '#6C89AF', margin: 'auto auto auto 0px', display: 'inline-block', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.audio')}</p>
                                                                          </div>
                                                                          :
                                                                          <div style={{ margin: 'auto', display: 'block', width: '100%', padding: '8px 0px' }}>
                                                                             <FaFileAudio style={{color: '#6C89AF', margin: 'auto', width: '100%', fontSize: '16px'}}/>

                                                                             { window.innerWidth < 1280 ?
                                                                                <p style={{color: '#6C89AF', margin: ' 0px auto 0px auto', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.audio')}</p>
                                                                                : null }
                                                                          </div>
                                                                    }

                                                               </span>
                                                   </DarkTooltip>
                                                   <Menu
                                                   id="simple-menu"
                                                   anchorEl={anchorElEdit}
                                                   keepMounted
                                                   anchorOrigin={{
                                                      vertical: 'bottom',
                                                      horizontal: 'center',
                                                   }}
                                                   transformOrigin={{
                                                      vertical: 'top',
                                                      horizontal: 'center',
                                                   }}
                                                   open={Boolean(anchorElEdit)}
                                                   onClose={handleCloseEdit}
                                                   sx={{
                                                      "& .MuiPaper-root": {
                                                         backgroundColor: "#fff",
                                                         boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 12px 0px, rgba(229, 229, 229, 0.05) 0px 0px 0px 1px;',
                                                         border: '1px #f4f4f4 solid'
                                                      },
                                                      zIndex: 9999,
                                                   }}>

                                                   <div>

                                                      <MenuItem type="button" onClick={() => {
                                                         handleCloseEdit();
                                                         handleEditAudio();
                                                      }}
                                                      sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}>
                                                      <FaFileAudio
                                                      style={{ verticalAlign: 'middle', color: '#6C89AF', marginRight: '8px', width: '16px', height: '16px' }} />
                                                   {t('community.composer.upload')}
                                                      </MenuItem>
                                                   </div>
                                                   </Menu>

                                                   <DarkTooltip title={t('community.composer.uploadDoc')} placement="bottom">
                                                   <span
                                                      onClick={handleClickEditDoc}
                                                      className="fa fa-search" style={{fontWeight: '600', textAlign: 'center', fontSize: '14px', cursor: 'pointer', width: '19%', backgroundColor: '#F5F9FF',  display: 'flex', borderRadius: '6px'}}>
                                                                      {
                                                                         window.innerWidth > 1280 ?
                                                                            <div style={{ margin: 'auto', display: 'flex', width: '55px', padding: '8px 0px', justifyContent: 'center' }}>
                                                                               <FaFile style={{color: '#6C89AF', margin: 'auto 0px auto auto', width: '40px', fontSize: '14px', display: 'inline-block'}}/>
                                                                               <p style={{color: '#6C89AF', margin: 'auto auto auto 0px', display: 'inline-block', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.doc')}</p>
                                                                            </div>
                                                                            :
                                                                            <div style={{ margin: 'auto', display: 'block', width: '100%', padding: '8px 0px' }}>
                                                                               <FaFile style={{color: '#6C89AF', margin: 'auto', width: '100%', fontSize: '16px'}}/>

                                                                               { window.innerWidth < 1280 ?
                                                                                  <p style={{color: '#6C89AF', margin: ' 0px auto 0px auto', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.doc')}</p>
                                                                                  : null }
                                                                            </div>
                                                                      }

                                                               </span>
                                                   </DarkTooltip>
                                                   <Menu
                                                      id="simple-menu"
                                                      anchorEl={anchorElEditDoc}
                                                      keepMounted
                                                      anchorOrigin={{
                                                         vertical: 'bottom',
                                                         horizontal: 'center',
                                                      }}
                                                      transformOrigin={{
                                                         vertical: 'top',
                                                         horizontal: 'center',
                                                      }}
                                                      open={Boolean(anchorElEditDoc)}
                                                      onClose={handleCloseEditDoc}
                                                      sx={{
                                                         "& .MuiPaper-root": {
                                                            backgroundColor: "#fff",
                                                            boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 12px 0px, rgba(229, 229, 229, 0.05) 0px 0px 0px 1px;',
                                                            border: '1px #f4f4f4 solid'
                                                         },
                                                         zIndex: 9999,
                                                      }}>

                                                      {/*   comment.username === props.username || props.current_user_display_name === props.username ?*/}
                                                      <div>

                                                         <MenuItem type="button" onClick={() => {
                                                            handleCloseEditDoc();
                                                            handleEditPDF();
                                                         }}
                                                         sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}>
                                                         <FaFilePdf
                                                         style={{ verticalAlign: 'middle', color: '#6C89AF', marginRight: '8px' }} />
                                                      {t('community.post.uploadPdf')}
                                                         </MenuItem>


                                                         <MenuItem
                                                            onClick={() => {
                                                               handleCloseEditDoc();
                                                               setDocModalOpen(true);
                                                               setFileTypeEdit('gos');
                                                               setDocType('edit');
                                                               setActiveDocFileType('gos');
                                                               setSnackbarOpenDoc(false);
                                                            }}
                                                            sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}>
                                                            <img src={GoogleSheetsImage}
                                                           style={{ verticalAlign: 'middle', color: '#6C89AF', width: '16px', height: '16px', marginRight: '8px' }} />
                                                        {t('community.composer.googleSheet')}
                                                         </MenuItem>
                                                         <MenuItem
                                                            onClick={() => {
                                                               handleCloseEditDoc();
                                                               setDocModalOpen(true);
                                                               setFileTypeEdit('god');
                                                               setDocType('edit');
                                                               setActiveDocFileType('god');
                                                               setSnackbarOpenDoc(false);
                                                            }}
                                                            sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}>
                                                            <img src={GoogleDocsImage}
                                                            style={{ verticalAlign: 'middle', color: '#6C89AF', width: '16px', height: '16px', marginRight: '8px' }} />
                                                         {t('community.composer.googleDoc')}
                                                         </MenuItem>
                                                      </div>
                                                   </Menu>
                                             <DarkTooltip title={t('community.composer.addMeeting')} placement="bottom">
                                                <span
                                                   onClick={handleClickEditMeeting}
                                                   className="fa fa-search" style={{ fontWeight: '600', textAlign: 'center', fontSize: '14px', cursor: 'pointer', width: '19%', backgroundColor: '#F5F9FF', display: 'flex', borderRadius: '6px' }}>
                                                 {
                                                                     window.innerWidth > 1280 ?
                                                                        <div style={{ margin: 'auto', display: 'flex', width: '55px', padding: '8px 0px', justifyContent: 'center' }}>
                                                                           <FaRegCalendarAlt style={{color: '#6C89AF', margin: 'auto 0px auto auto', width: '40px', fontSize: '14px', display: 'inline-block'}}/>
                                                                           <p style={{color: '#6C89AF', margin: 'auto auto auto 0px', display: 'inline-block', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.meet')}</p>
                                                                        </div>
                                                                        :
                                                                        <div style={{ margin: 'auto', display: 'block', width: '100%', padding: '8px 0px' }}>
                                                                           <FaRegCalendarAlt style={{color: '#6C89AF', margin: 'auto', width: '100%', fontSize: '16px'}}/>
                                                                           <p style={{color: '#6C89AF', margin: ' 0px auto 0px auto', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.meet')}</p>
                                                                        </div>
                                                                  }

                                                </span>
                                             </DarkTooltip>
                                             <Menu
                                                      id="simple-menu"
                                                      anchorEl={anchorElEditMeeting}
                                                      keepMounted
                                                      anchorOrigin={{
                                                         vertical: 'bottom',
                                                         horizontal: 'center',
                                                      }}
                                                      transformOrigin={{
                                                         vertical: 'top',
                                                         horizontal: 'center',
                                                      }}
                                                      open={Boolean(anchorElEditMeeting)}
                                                      onClose={handleCloseEditMeeting}
                                                      sx={{
                                                         "& .MuiPaper-root": {
                                                            backgroundColor: "#fff",
                                                            boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 12px 0px, rgba(229, 229, 229, 0.05) 0px 0px 0px 1px;',
                                                            border: '1px #f4f4f4 solid'
                                                         },
                                                         zIndex: 9999,
                                                      }}>

                                                      {/*   comment.username === props.username || props.current_user_display_name === props.username ?*/}
                                                      <div>

                                                         <MenuItem type="button" onClick={() => {
                                                            handleCloseEditMeeting();
                                                            setMeetingModalOpen(true);
                                                            setFileTypeEdit('mzm');
                                                            setMeetingType('edit');
                                                            setSnackbarOpenMeeting(false);
                                                         }}
                                                         sx={{color: 'black', fontWeight: '500', fontSize: '14px'}}>
                                                         <img src={ZoomImage}
                                                      style={{verticalAlign: 'middle', height: 'auto', width: '16px',  marginRight: '8px'}}/>
                                                      Zoom 
                                                         </MenuItem>


                                                         <MenuItem
                                                            onClick={() => {
                                                               handleCloseEditMeeting();
                                                               setMeetingModalOpen(true);
                                                               setFileTypeEdit('mgm');
                                                               setMeetingType('edit');
                                                               setSnackbarOpenMeeting(false);
                                                            }}
                                                            sx={{color: 'black', fontWeight: '500', fontSize: '14px'}}>
                                                            <img src={GoogleMeetImage}
                                                         style={{verticalAlign: 'middle', height: 'auto', width: '16px',  marginRight: '8px'}}/>
                                                         Google Meet 
                                                         </MenuItem>
                                                         <MenuItem
                                                            onClick={() => {
                                                               handleCloseEditMeeting();
                                                               setMeetingModalOpen(true);
                                                               setFileTypeEdit('mmt');
                                                               setMeetingType('edit');
                                                               setSnackbarOpenMeeting(false);
                                                            }}
                                                            sx={{color: 'black', fontWeight: '500', fontSize: '14px'}}>
                                                            <img src={MicrosoftTeams}
                                                         style={{verticalAlign: 'middle', height: 'auto', width: '16px',  marginRight: '8px'}}/>
                                                         Microsoft Teams 
                                                         </MenuItem>
                                                         <MenuItem
                                                            onClick={() => {
                                                               handleCloseEditMeeting();
                                                               setMeetingModalOpen(true);
                                                               setFileTypeEdit('mot');
                                                               setMeetingType('edit');
                                                               setSnackbarOpenMeeting(false);
                                                            }}
                                                            sx={{color: 'black', fontWeight: '500', fontSize: '14px'}}>
                                                            <FaLink
                                                         style={{verticalAlign: 'middle', color: '#6C89AF', width: '16px', height: '16px', marginRight: '8px'}}/>
                                                         Other 
                                                         </MenuItem>
                                                      </div>
                                                   </Menu>
                                                </div>
                                    }

                                 </div>
                              </Grid>
                           </Grid>

                           <Button
                              fullWidth
                              variant="contained"
                              disabled={selectedPreviewUrlEdit === 'temp'}
                              sx={{
                                 width: '100%', backgroundColor: selectedPreviewUrlEdit === 'temp' ? 'var(--secondary-color)' : 'var(--brand-color)', fontSize: '16px',
                                 textTransform: 'none', margin: '5px auto 0px auto', height: '40px',
                                 boxShadow: 'none', fontWeight: '600',
                                 ':hover': {
                                    bgcolor: 'var(--brand-color-hover)',
                                    color: 'white',
                                    boxShadow: 'none',
                                 },
                              }}
                              type="submit" value="submit"
                              // Update profile
                              onClick={() => {
                                 if (validateUpdatedContent(editCommentThreadData, fileTypeEdit) === true) {
                                    editThread(threadId, editCommentThreadData, postIndex, threadIndex, post_id, selectedPreviewUrlEdit);
                                    setMeetingTimeEditPost('')
                                 }
                              }}

                           >{t('community.post.updateThread')}</Button>
                        </Grid>
                     </Grid>
                  </Fade>
               </Modal>
               : null

         }


         {
            // EDIT COMMENT MODAL
            editCommentModal ?

               <Modal
                  sx={{backgroundColor: 'transparent', overflow: 'auto', display:'flex', outline: 'none', width: '100vw', minHeight: '100vh', zIndex: '9998'}}
                  open={handleEditComment}
                  // closeAfterTransition
               >
                  <Fade in={handleEditComment}>
                     <Grid
                        container
                        xs={12} md={9} lg={6}
                        alignItems="center"
                        justifyContent="center"
                        direction="column"
                        sx={{
                           width: '100vw',
                           minHeight:'100vh',
                           paddingTop: 'calc(30px + 1vw)',
                           paddingBottom: 'calc(30px + 1vw)',
                           overflow:'auto',
                           margin: '0px auto auto auto',
                        }}
                     >
                        <SnackbarAlert
                           msg={snackbarMsgOuter}
                           open={snackbarOpenOuter}
                           backgroundColor={snackbarColorOuter}
                           severity={snackbarSeverityOuter}
                           handleClose={() => {
                              setSnackbarOpenOuter(false)
                           }}
                           autoHide={4000}
                        />
                        <SnackbarAlertClick
                           msg_pre={snackbarPreMsgClick}
                           msg_post={snackbarPostMsgClick}
                           click_text={snackbarTextClick}
                           click_process={() => {
                              var currentdate = new Date(); 
                              var datetime = currentdate.getDate() + "/"
                                             + (currentdate.getMonth()+1)  + "/" 
                                             + currentdate.getFullYear() + "_"  
                                             + currentdate.getHours() + ":"  
                                             + currentdate.getMinutes() + ":" 
                                             + currentdate.getSeconds();

                              saveFile(selectedPreviewUrlEdit, datetime+'_'+'recording'+recordedFileFormat)
                           }}
                           open={snackbarOpenClick}
                           severity={snackbarSeverityClick}
                           backgroundColor={snackbarColorClick}
                           handleClose={() => {
                              setSnackbarOpenClick(false)
                           }}
                           autoHide={null}
                        />
                        <Grid sx={{
                           minHeight: '240px', backgroundColor: '#fff', borderRadius: '10px', margin: '30px auto',
                           maxWidth: 'calc(100% - 20px)', width: window.innerWidth >= 1280 ? '100%' : '800px', overflow:'auto',
                           boxShadow: '0 5px 25px 0 rgba(35, 40, 105, 0.04)' , padding: '25px 20px', position: 'relative',
                        }}>


                           <IoClose
                              onClick={() => {setEditCommentModal(false)}}
                              style={{
                                 fontSize: '20px',
                                 fontWeight: '300',
                                 textAlign: 'right',
                                 display: 'flex',
                                 top: '15px',
                                 right: '15px',
                                 position: 'absolute',
                                 padding: '0px',
                                 cursor: 'pointer'
                              }}
                              color= '#023648'
                           />

                           <Grid
                              xs={12}
                              alignItems='center'
                              justifyContent='center'
                           >
                              <Typography
                                 style={{
                                    color: 'black',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    textTransform: 'none',
                                    textAlign: 'center',
                                    cursor: 'default',
                                    margin: '0px 0px 3px 0px',
                                    padding: '0px',
                                    backgroundColor:'transparent',
                                    width: '100%',
                                 }}
                              >
                                 {t('community.post.editComment')}
                              </Typography>
                           </Grid>


                           <Grid xs={12}
                                 container
                                 justifyContent={'center'}
                                 alignItems={'center'}
                           >
                              <Grid xs={12}
                                    style={{paddingBottom:'10px',paddingTop:'10px', backgroundColor: 'white', borderRadius: '10px'}}
                              >

                                 <TextField
                                    size="small"
                                    hiddenLabel
                                    name="post_description"
                                    placeholder={t('community.post.enterNewDescription')}
                                    inputProps={{ maxLength: 5000 }}
                                    multiline
                                    maxRows={8}
                                    minRows={2}
                                    value={editCommentData}
                                    onChange={(event) =>
                                       setEditCommentData(event.target.value)
                                    }

                                    style = {{
                                       width: '100%',
                                       border: '1px solid #C7D1DE',
                                       justifyContent: 'center',
                                       fontWeight: '500',
                                       marginRight: 'auto',
                                       marginTop: '0px',
                                    }}

                                    id="filled-basic1" variant="filled"
                                    InputProps={{
                                       style: {
                                          fontSize: '16px',
                                          color: '#1D1D1D',
                                          fontWeight: '500',
                                          borderRadius: '8px',
                                          padding: '0px 10px',
                                          backgroundColor: '#FFF'
                                       },
                                       disableUnderline: true,
                                    }}
                                    sx={{
                                       marginBottom: '0px',
                                       borderRadius: '5px',
                                       border: '0px',
                                       backgroundColor: '#fff',
                                       input : {
                                          color: '#1D1D1D',
                                       },
                                    }}
                                 />

                              </Grid>


                              {/* Content displayed here*/}
                              <Grid xs={12} style={{paddingBottom:'10px',paddingTop:'10px',}}>
                                 {selectedPreviewUrlEdit &&
                                 <div style={{ position: 'relative', padding: '0px 0px 0px 0px'}}>
                                    {fileTypeEdit === 'img' &&
                                    <>
                                       <ImagePost pre_upload={true} fullscreen={false} image_src={selectedPreviewUrlEdit} handleFullscreenOpen={handleFullscreenOpen}/>
                                       <div style={{position: 'absolute', top: '-10px', right: '-10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </>

                                    }
                                    {fileTypeEdit === 'vid' &&
                                    <div style={{ borderRadius: '8px', overflow: 'hidden' }}>
                                       <VideoPost pre_upload={true} video_src={selectedPreviewUrlEdit}/>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </div>

                                    }
                                       {fileTypeEdit === 'vey' &&
                                    <div style={{ borderRadius: '8px', overflow: 'hidden' }}>
                                       <YoutubePost video_src={selectedPreviewUrlEdit}/>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </div>
                                    }
                                    {fileTypeEdit === 'vel' &&
                                    <div style={{ borderRadius: '8px', overflow: 'hidden' }}>
                                       <LoomPost video_src={selectedPreviewUrlEdit}/>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </div>
                                    }
                                    {fileTypeEdit === 'vev' &&
                                    <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden' }}>
                                       <iframe
                                          src={"https://player.vimeo.com/video/" + selectedPreviewUrlEdit}
                                          frameborder="0"
                                          allow="autoplay; fullscreen; picture-in-picture"
                                          allowfullscreen
                                          style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                       ></iframe>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </div>
                                    }
                                    {fileTypeEdit === 'vtw' && selectedPreviewUrlEdit &&
                                    <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden' }}>
                                       <iframe
                                          src={
                                             selectedPreviewUrlEdit.startsWith('ch')
                                                ? "https://player.twitch.tv/?channel=" + selectedPreviewUrlEdit.slice(2) + "&parent=" + window.location.hostname
                                                : selectedPreviewUrlEdit.startsWith('c')
                                                ? "https://clips.twitch.tv/embed?clip=" + selectedPreviewUrlEdit.slice(1) + "&parent=" + window.location.hostname
                                                : "https://player.twitch.tv/?video=" + selectedPreviewUrlEdit.slice(1) + "&parent=" + window.location.hostname
                                          }
                                          frameborder="0"
                                          allow="autoplay; fullscreen"
                                          allowfullscreen
                                          style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                       ></iframe>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </div>
                                    }
                                    {fileTypeEdit === 'vwi' &&
                                    <div style={{ position: 'relative', paddingBottom: '56.25%', height: '0', borderRadius: '8px', overflow: 'hidden' }}>
                                       <iframe
                                          src={"https://fast.wistia.com/embed/iframe/" + selectedPreviewUrlEdit + "?autoPlay=false"}
                                          frameborder="0"
                                          allow="autoplay; fullscreen"
                                          allowfullscreen
                                          style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                       ></iframe>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </div>
                                    }
                                       {['gos', 'god'].includes(fileTypeEdit) &&
                                       <Box
                                          sx={{
                                             display: 'flex',
                                             alignItems: 'center',
                                             backgroundColor: '#fff',
                                             height: '60px',
                                             border: '1px solid #E4EBF6',
                                             borderRadius: '8px',
                                             padding: '0 16px',
                                             marginBottom: '16px',
                                             position: 'relative'
                                          }}
                                       >
                                          {fileTypeEdit === 'gos' && <img src={GoogleSheetsImage} alt={t('dashboard.paidDms.googleSheets')} style={{ width: '24px', marginRight: '16px' }} />}
                                          {fileTypeEdit === 'god' && <img src={GoogleDocsImage} alt={t('dashboard.paidDms.googleDocs')} style={{ width: '24px', marginRight: '16px' }} />}
                                          <Box sx={{ flexGrow: 1 }}>
                                             <p style={{ fontWeight: 500, fontFamily: 'Roboto', color: '#000', margin: 0 }}>
                                                {fileTypeEdit === 'gos' && 'Google Sheets'}
                                                {fileTypeEdit === 'god' && 'Google Docs'}
                                             </p>
                                          </Box>
                                          <Button
                                             variant="contained"
                                             disableElevation
                                             onClick={() => handleFullscreenOpen(normalizeExternalHref(selectedPreviewUrlEdit), fileTypeEdit)}
                                             rel="noopener noreferrer"
                                             sx={{
                                                padding: '5px 7px',
                                                display: 'inline-block',
                                                marginLeft: 'auto',
                                                borderRadius: '8px !important',
                                                textTransform: 'none',
                                                textAlign: 'center',
                                                backgroundColor: 'var(--brand-color)',
                                                '&:hover': {
                                                   backgroundColor: 'var(--brand-color-hover)'
                                                },
                                                cursor: 'pointer'
                                             }}>
                                             <span className="fa fa-search" style={{ fontWeight: '500', fontSize: '14px' }}>
                                                Open
                                             </span>
                                          </Button>
                                          <div style={{ position: 'absolute', top: '-10px', right: '-10px', cursor: 'pointer', zIndex: 10 }}>
                                             <IconButton onClick={handleRemoveEditContent} size="small"
                                                sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                             </IconButton>
                                          </div>
                                       </Box>
                                    }  

                                    {fileTypeEdit === 'aud' &&
                                    <div style={{ position: 'relative' }}>
                                       <div className="image_container" style={{position: 'relative'}}>
                                          <ReactAudioPlayer
                                             className='react-player'
                                             src={selectedPreviewUrlEdit}
                                             // autoPlay
                                             controls
                                             style={{ width: '100%', margin: '0px', borderRadius: '0px' }}
                                             // onLoadedMetadata={handleAudioLoadMetadata}
                                          />
                                          <div style={{ position: 'absolute', top: '11px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                             <IconButton onClick={handleRemoveEditContent} size="small"
                                                sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                             </IconButton>
                                          </div>
                                       </div>
                                    </div>
                                    }
                                    {['mgm', 'mzm', 'mmt', 'mot'].includes(fileTypeEdit) &&
                                       <Box
                                          sx={{
                                             display: 'flex',
                                             alignItems: 'center',
                                             height: '60px',
                                             border: '1px solid #E4EBF6',
                                             backgroundColor: '#fff',
                                             borderRadius: '8px',
                                             padding: '0 16px',
                                             marginBottom: '16px',
                                             position: 'relative'
                                          }}
                                       >
                                          {fileTypeEdit === 'mot' && <FaLink style={{ width: '24px', marginRight: '16px', color: '#6C89AF' }} />}
                                          {fileTypeEdit === 'mgm' && <img src={GoogleMeetImage} alt={t('community.composer.googleMeet')} style={{ width: '24px', marginRight: '16px' }} />}
                                          {fileTypeEdit === 'mmt' && <img src={MicrosoftTeams} alt={t('community.composer.microsoftTeams')} style={{ width: '24px', marginRight: '16px' }} />}
                                          {fileTypeEdit === 'mzm' && <img src={ZoomImage} alt={t('profile.zoom')} style={{ width: '24px', marginRight: '16px' }} />}
                                          <Box sx={{ flexGrow: 1 , display: 'flex', alignItems: 'center'}}>
                                             <p style={{ fontWeight: 500, fontFamily: 'Roboto', color: '#000', margin: 0 }}>
                                                {fileTypeEdit === 'mot' && 'Meeting'}
                                                {fileTypeEdit === 'mgm' && 'Google Meet'}
                                                {fileTypeEdit === 'mmt' && 'Microsoft Teams'}
                                                {fileTypeEdit === 'mzm' && 'Zoom'}
                                             </p>
                                             {/* <p style={{ color: '#6C89AF', fontSize: '0.75rem', fontWeight: '500', margin: '2px 0px 0px 0px' }}>
                                                {fileTypeEdit === 'mzm' ? 'Tomorrow at 10:00 AM' : 'Today at 3:00 PM'}
                                             </p> */}
                                          </Box>

                                          <Button
                                                   variant="contained"
                                                   disableElevation
                                                   href={normalizeExternalHref(selectedPreviewUrlEdit)}
                                                   target="_blank"
                                                   rel="noopener noreferrer"
                                                   sx={{
                                                      padding: '5px 7px',
                                                      display: 'inline-block',
                                                      marginLeft: 'auto',
                                                      borderRadius: '8px !important',
                                                      textTransform: 'none',
                                                      textAlign: 'center',
                                                      backgroundColor: 'var(--brand-color)',
                                                      '&:hover': {
                                                         backgroundColor: 'var(--brand-color-hover)'
                                                      }
                                                   }}>
                                                   <span className="fa fa-search" style={{ fontWeight: '500', fontSize: '14px' }}>
                                                      {t('community.post.join')}
                                                   </span>
                                                </Button>

                                          <div style={{ position: 'absolute', top: '-10px', right: '-10px', cursor: 'pointer', zIndex: 10 }}>
                                             <IconButton onClick={handleRemoveEditContent} size="small"
                                                sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                                <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                             </IconButton>
                                          </div>
                                       </Box>
                                    }
                                    {fileTypeEdit === 'pdf' &&
                                    <>
                                       <PDFPost fullscreen={fullscreenViewOpen} pdf_src={selectedPreviewUrlEdit} pre_upload={true} content_width_type={'post'} handleFullscreenPDFOpen={handleFullscreenPDFOpen}/>
                                       <div style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', zIndex: 10 }}>
                                          <IconButton onClick={handleRemoveEditContent} size="small"
                                             sx={{ border: '1px solid #D3DCE7', backgroundColor: '#fff', p: '5px', height: '28px', width: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                                             <IoClose style={{ fontSize: '16px', color: '#222' }} />
                                          </IconButton>
                                       </div>
                                    </>
                                    }

                                 </div>
                                 }

                                 <div>
                                    {

                                       isMediaAttachedEdit ?
                                          // NOT SHOWING CONTENT UPLOAD OPTIONS IF UPLOADED & IN PREVIEW (ONLY ONE CONTENT UPLOAD PER POST)
                                          null
                                          :
                                                <div
                                                   style={{
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      marginTop: '10px',
                                                      // marginLeft: '52px',
                                                      // padding: '0px 30px 5px 30px',
                                                      justifyContent: 'space-between', // Add spacing between the buttons
                                                   }}
                                                >

                                                   <DarkTooltip title={t('community.composer.uploadImage')} placement="bottom">
                                                   <span
                                                      onClick={handleEditImage}
                                                      className="fa fa-search" style={{fontWeight: '600', textAlign: 'center', fontSize: '14px', cursor: 'pointer', width: '19%', backgroundColor: '#F5F9FF',  display: 'flex', borderRadius: '6px'}}>
                                                                       {
                                                                          window.innerWidth > 1280 ?
                                                                             <div style={{ margin: 'auto', display: 'flex', width: '55px', padding: '8px 0px', justifyContent: 'center' }}>
                                                                                <FaFileImage style={{color: '#6C89AF', margin: 'auto 0px auto auto', width: '40px', fontSize: '14px', display: 'inline-block'}}/>
                                                                                <p style={{color: '#6C89AF', margin: 'auto auto auto 0px', display: 'inline-block', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.image')}</p>
                                                                             </div>
                                                                             :
                                                                             <div style={{ margin: 'auto', display: 'block', width: '100%', padding: '8px 0px' }}>
                                                                                <FaFileImage style={{color: '#6C89AF', margin: 'auto', width: '100%', fontSize: '16px'}}/>

                                                                                { window.innerWidth < 1280 ?
                                                                                   <p style={{color: '#6C89AF', margin: ' 0px auto 0px auto', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.image')}</p>
                                                                                   : null }
                                                                             </div>
                                                                       }

                                                               </span>
                                                   </DarkTooltip>


                                                   <DarkTooltip title={t('community.composer.uploadOrEmbedVideo')} placement="bottom">
                                                   <span
                                                      onClick={handleClickEditVideo}
                                                      className="fa fa-search" style={{fontWeight: '600', textAlign: 'center', fontSize: '14px', cursor: 'pointer', width: '19%', backgroundColor: '#F5F9FF',  display: 'flex', borderRadius: '6px'}}>
                                                                     {
                                                                        window.innerWidth > 1280 ?
                                                                           <div style={{ margin: 'auto', display: 'flex', width: '55px', padding: '8px 0px', justifyContent: 'center' }}>
                                                                              <FaFileVideo style={{color: '#6C89AF', margin: 'auto 0px auto auto', width: '40px', fontSize: '14px', display: 'inline-block'}}/>
                                                                              <p style={{color: '#6C89AF', margin: 'auto auto auto 0px', display: 'inline-block', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.video')}</p>
                                                                           </div>
                                                                           :
                                                                           <div style={{ margin: 'auto', display: 'block', width: '100%', padding: '8px 0px' }}>
                                                                              <FaFileVideo style={{color: '#6C89AF', margin: 'auto', width: '100%', fontSize: '16px'}}/>

                                                                              { window.innerWidth < 1280 ?
                                                                                 <p style={{color: '#6C89AF', margin: ' 0px auto 0px auto', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.video')}</p>
                                                                                 : null }
                                                                           </div>
                                                                     }

                                                               </span>
                                                   </DarkTooltip>
                                                   <Menu
                                                   id="simple-menu"
                                                   anchorEl={anchorElEditVideo}
                                                   keepMounted
                                                   anchorOrigin={{
                                                      vertical: 'bottom',
                                                      horizontal: 'center',
                                                   }}
                                                   transformOrigin={{
                                                      vertical: 'top',
                                                      horizontal: 'center',
                                                   }}
                                                   open={Boolean(anchorElEditVideo)}
                                                   onClose={handleCloseEditVideo}
                                                   sx={{
                                                      "& .MuiPaper-root": {
                                                         backgroundColor: "#fff",
                                                         boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 12px 0px, rgba(229, 229, 229, 0.05) 0px 0px 0px 1px;',
                                                         border: '1px #f4f4f4 solid'
                                                      },
                                                      zIndex: 9999,
                                                   }}>

                                                   {/*   comment.username === username || current_user_display_name === username ?*/}
                                                   <div>

                                                      <MenuItem type="button" onClick={() => {
                                                         handleCloseEditVideo();
                                                         handleEditVideo();
                                                      }}
                                                      sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}>
                                                      <FaFileVideo
                                                      style={{ verticalAlign: 'middle', color: '#6C89AF', marginRight: '8px', width: '16px', height: '16px' }} />
                                                   {t('community.composer.upload')}
                                                      </MenuItem>
                                                      <MenuItem
                                                         onClick={() => {
                                                            handleCloseEditVideo();
                                                            setEmbedUrlIsOpen(true);
                                                            setSnackbarEmbed(false);
                                                            setEmbedUrlType('edit');
                                                         }}
                                                         sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}>
                                                         <ImEmbed2
                                                   style={{verticalAlign: 'middle', width: '16px', height: '16px', color: '#6C89AF', marginRight: '8px'}}/>
                                                      {t('community.composer.embed')}
                                                      </MenuItem>
                                                   </div>
                                                   </Menu>

                                                   <DarkTooltip title={t('community.composer.uploadAudio')} placement="bottom">
                                                   <span
                                                      // onClick={handleClickEdit}
                                                      onClick={() => {
                                                         handleCloseEdit();
                                                         handleEditAudio();
                                                      }}
                                                      className="fa fa-search" style={{fontWeight: '600', textAlign: 'center', fontSize: '14px', cursor: 'pointer', width: '19%', backgroundColor: '#F5F9FF',  display: 'flex', borderRadius: '6px'}}>
                                                                  {
                                                                     window.innerWidth > 1280 ?
                                                                        <div style={{ margin: 'auto', display: 'flex', width: '55px', padding: '8px 0px', justifyContent: 'center' }}>
                                                                           <FaFileAudio style={{color: '#6C89AF', margin: 'auto 0px auto auto', width: '40px', fontSize: '14px', display: 'inline-block'}}/>
                                                                           <p style={{color: '#6C89AF', margin: 'auto auto auto 0px', display: 'inline-block', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.audio')}</p>
                                                                        </div>
                                                                        :
                                                                        <div style={{ margin: 'auto', display: 'block', width: '100%', padding: '8px 0px' }}>
                                                                           <FaFileAudio style={{color: '#6C89AF', margin: 'auto', width: '100%', fontSize: '16px'}}/>

                                                                           { window.innerWidth < 1280 ?
                                                                              <p style={{color: '#6C89AF', margin: ' 0px auto 0px auto', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.audio')}</p>
                                                                              : null }
                                                                        </div>
                                                                  }

                                                               </span>
                                                   </DarkTooltip>
                                                   <Menu
                                                   id="simple-menu"
                                                   anchorEl={anchorElEdit}
                                                   keepMounted
                                                   anchorOrigin={{
                                                      vertical: 'bottom',
                                                      horizontal: 'center',
                                                   }}
                                                   transformOrigin={{
                                                      vertical: 'top',
                                                      horizontal: 'center',
                                                   }}
                                                   open={Boolean(anchorElEdit)}
                                                   onClose={handleCloseEdit}
                                                   sx={{
                                                      "& .MuiPaper-root": {
                                                         backgroundColor: "#fff",
                                                         boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 12px 0px, rgba(229, 229, 229, 0.05) 0px 0px 0px 1px;',
                                                         border: '1px #f4f4f4 solid'
                                                      },
                                                      zIndex: 9999,
                                                   }}>

                                                   {/*   comment.username === username || current_user_display_name === username ?*/}
                                                   <div>

                                                      <MenuItem type="button" onClick={() => {
                                                         handleCloseEdit();
                                                         handleEditAudio();
                                                      }}
                                                      sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}>
                                                      <FaFileAudio
                                                      style={{ verticalAlign: 'middle', color: '#6C89AF', marginRight: '8px', width: '16px', height: '16px' }} />
                                                   {t('community.composer.upload')}
                                                      </MenuItem>
                                                   </div>
                                                   </Menu>

                                                   <DarkTooltip title={t('community.composer.uploadDoc')} placement="bottom">
                                                   <span
                                                      onClick={handleClickEditDoc}
                                                      className="fa fa-search" style={{fontWeight: '600', textAlign: 'center', fontSize: '14px', cursor: 'pointer', width: '19%', backgroundColor: '#F5F9FF',  display: 'flex', borderRadius: '6px'}}>
                                                                     {
                                                                        window.innerWidth > 1280 ?
                                                                           <div style={{ margin: 'auto', display: 'flex', width: '55px', padding: '8px 0px', justifyContent: 'center' }}>
                                                                              <FaFile style={{color: '#6C89AF', margin: 'auto 0px auto auto', width: '40px', fontSize: '14px', display: 'inline-block'}}/>
                                                                              <p style={{color: '#6C89AF', margin: 'auto auto auto 0px', display: 'inline-block', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.doc')}</p>
                                                                           </div>
                                                                           :
                                                                           <div style={{ margin: 'auto', display: 'block', width: '100%', padding: '8px 0px' }}>
                                                                              <FaFile style={{color: '#6C89AF', margin: 'auto', width: '100%', fontSize: '16px'}}/>

                                                                              { window.innerWidth < 1280 ?
                                                                                 <p style={{color: '#6C89AF', margin: ' 0px auto 0px auto', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.doc')}</p>
                                                                                 : null }
                                                                           </div>
                                                                     }

                                                               </span>
                                                   </DarkTooltip>
                                                   <Menu
                                                      id="simple-menu"
                                                      anchorEl={anchorElEditDoc}
                                                      keepMounted
                                                      anchorOrigin={{
                                                         vertical: 'bottom',
                                                         horizontal: 'center',
                                                      }}
                                                      transformOrigin={{
                                                         vertical: 'top',
                                                         horizontal: 'center',
                                                      }}
                                                      open={Boolean(anchorElEditDoc)}
                                                      onClose={handleCloseEditDoc}
                                                      sx={{
                                                         "& .MuiPaper-root": {
                                                            backgroundColor: "#fff",
                                                            boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 12px 0px, rgba(229, 229, 229, 0.05) 0px 0px 0px 1px;',
                                                            border: '1px #f4f4f4 solid'
                                                         },
                                                         zIndex: 9999,
                                                      }}>

                                                      {/*   comment.username === props.username || props.current_user_display_name === props.username ?*/}
                                                      <div>

                                                         <MenuItem type="button" onClick={() => {
                                                            handleCloseEditDoc();
                                                            handleEditPDF();
                                                         }}
                                                         sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}>
                                                         <FaFilePdf
                                                         style={{ verticalAlign: 'middle', color: '#6C89AF', marginRight: '8px' }} />
                                                      {t('community.post.uploadPdf')}
                                                         </MenuItem>


                                                         <MenuItem
                                                            onClick={() => {
                                                               handleCloseEditDoc();
                                                               setDocModalOpen(true);
                                                               setFileTypeEdit('gos');
                                                               setDocType('edit');
                                                               setActiveDocFileType('gos');
                                                               setSnackbarOpenDoc(false);
                                                            }}
                                                            sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}>
                                                            <img src={GoogleSheetsImage}
                                                           style={{ verticalAlign: 'middle', color: '#6C89AF', width: '16px', height: '16px', marginRight: '8px' }} />
                                                        {t('community.composer.googleSheet')}
                                                         </MenuItem>
                                                         <MenuItem
                                                            onClick={() => {
                                                               handleCloseEditDoc();
                                                               setDocModalOpen(true);
                                                               setFileTypeEdit('god');
                                                               setDocType('edit');
                                                               setActiveDocFileType('god');
                                                               setSnackbarOpenDoc(false);
                                                            }}
                                                            sx={{ color: 'black', fontWeight: '500', fontSize: '14px' }}>
                                                            <img src={GoogleDocsImage}
                                                            style={{ verticalAlign: 'middle', color: '#6C89AF', width: '16px', height: '16px', marginRight: '8px' }} />
                                                         {t('community.composer.googleDoc')}
                                                         </MenuItem>
                                                      </div>
                                                   </Menu>
                                                   <DarkTooltip title={t('community.composer.addMeeting')} placement="bottom">
                                                      <span
                                                         onClick={handleClickEditMeeting}
                                                         className="fa fa-search" style={{ fontWeight: '600', textAlign: 'center', fontSize: '14px', cursor: 'pointer', width: '19%', backgroundColor: '#F5F9FF', display: 'flex', borderRadius: '6px' }}>
                                               {
                                                                     window.innerWidth > 1280 ?
                                                                        <div style={{ margin: 'auto', display: 'flex', width: '55px', padding: '8px 0px', justifyContent: 'center' }}>
                                                                           <FaRegCalendarAlt style={{color: '#6C89AF', margin: 'auto 0px auto auto', width: '40px', fontSize: '14px', display: 'inline-block'}}/>
                                                                           <p style={{color: '#6C89AF', margin: 'auto auto auto 0px', display: 'inline-block', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.meet')}</p>
                                                                        </div>
                                                                        :
                                                                        <div style={{ margin: 'auto', display: 'block', width: '100%', padding: '8px 0px' }}>
                                                                           <FaRegCalendarAlt style={{color: '#6C89AF', margin: 'auto', width: '100%', fontSize: '16px'}}/>
                                                                           <p style={{color: '#6C89AF', margin: ' 0px auto 0px auto', fontSize: window.innerWidth < 500 ? '12px' : '10px', textAlign: 'center'}}>{t('community.post.meet')}</p>
                                                                        </div>
                                                                  }

                                                      </span>
                                                   </DarkTooltip>
                                                   <Menu
                                                      id="simple-menu"
                                                      anchorEl={anchorElEditMeeting}
                                                      keepMounted
                                                      anchorOrigin={{
                                                         vertical: 'bottom',
                                                         horizontal: 'center',
                                                      }}
                                                      transformOrigin={{
                                                         vertical: 'top',
                                                         horizontal: 'center',
                                                      }}
                                                      open={Boolean(anchorElEditMeeting)}
                                                      onClose={handleCloseEditMeeting}
                                                      sx={{
                                                         "& .MuiPaper-root": {
                                                            backgroundColor: "#fff",
                                                            boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 12px 0px, rgba(229, 229, 229, 0.05) 0px 0px 0px 1px;',
                                                            border: '1px #f4f4f4 solid'
                                                         },
                                                         zIndex: 9999,
                                                      }}>

                                                      {/*   comment.username === props.username || props.current_user_display_name === props.username ?*/}
                                                      <div>

                                                         <MenuItem type="button" onClick={() => {
                                                            handleCloseEditMeeting();
                                                            setMeetingModalOpen(true);
                                                            setMeetingType('edit')
                                                            setFileTypeEdit('mzm');
                                                            setSnackbarOpenMeeting(false);
                                                         }}
                                                         sx={{color: 'black', fontWeight: '500', fontSize: '14px'}}>
                                                         <img src={ZoomImage}
                                                      style={{verticalAlign: 'middle', height: 'auto', width: '16px',  marginRight: '8px'}}/>
                                                      Zoom 
                                                         </MenuItem>


                                                         <MenuItem
                                                            onClick={() => {
                                                               handleCloseEditMeeting();
                                                               setMeetingModalOpen(true);
                                                               setMeetingType('edit')
                                                               setFileTypeEdit('mgm');
                                                               setSnackbarOpenMeeting(false);
                                                            }}
                                                            sx={{color: 'black', fontWeight: '500', fontSize: '14px'}}>
                                                            <img src={GoogleMeetImage}
                                                         style={{verticalAlign: 'middle', height: 'auto', width: '16px',  marginRight: '8px'}}/>
                                                         Google Meet 
                                                         </MenuItem>
                                                         <MenuItem
                                                            onClick={() => {
                                                               handleCloseEditMeeting();
                                                               setMeetingModalOpen(true);
                                                               setMeetingType('edit')
                                                               setFileTypeEdit('mmt');
                                                               setSnackbarOpenMeeting(false);
                                                            }}
                                                            sx={{color: 'black', fontWeight: '500', fontSize: '14px'}}>
                                                            <img src={MicrosoftTeams}
                                                         style={{verticalAlign: 'middle', height: 'auto', width: '16px',  marginRight: '8px'}}/>
                                                         Microsoft Teams 
                                                         </MenuItem>
                                                         <MenuItem
                                                            onClick={() => {
                                                               handleCloseEditMeeting();
                                                               setMeetingModalOpen(true);
                                                               setMeetingType('edit')
                                                               setFileTypeEdit('mot');
                                                               setSnackbarOpenMeeting(false);
                                                            }}
                                                            sx={{color: 'black', fontWeight: '500', fontSize: '14px'}}>
                                                            <FaLink
                                                         style={{verticalAlign: 'middle', color: '#6C89AF', width: '16px', height: '16px', marginRight: '8px'}}/>
                                                         Other 
                                                         </MenuItem>
                                                      </div>
                                                   </Menu>
                                                </div>
                                    }
                                 </div>
                              </Grid>
                           </Grid>

                           <Button
                              fullWidth
                              variant="contained"
                              disabled={selectedPreviewUrlEdit === 'temp'}
                              sx={{
                                 width: '100%', backgroundColor: selectedPreviewUrlEdit === 'temp' ? 'var(--secondary-color)' : 'var(--brand-color)', fontSize: '16px',
                                 textTransform: 'none', margin: '5px auto 0px auto', height: '40px',
                                 boxShadow: 'none', fontWeight: '600',
                                 ':hover': {
                                    bgcolor: 'var(--brand-color-hover)',
                                    color: 'white',
                                    boxShadow: 'none',
                                 },
                              }}
                              type="submit" value="submit"
                              // Update profile
                              onClick={() => {
                                 if (validateUpdatedContent(editCommentData, fileTypeEdit) === true) {
                                    editComment(editCommentData, commentId, postIndex, threadIndex, commentIndex, post_id, selectedPreviewUrlEdit);
                                    
                                 }
                              }}
                           >{t('community.post.updateComment')}</Button>
                        </Grid>
                     </Grid>
                  </Fade>
               </Modal>
               : null
         }



         <Menu
            anchorEl={menuAnchorEl}
            open={menuOpen}
            onClose={handleMenuClose}
            anchorOrigin={{
               vertical: 'top',
               horizontal: 'right'
            }}
            transformOrigin={{
               vertical: 'top',
               horizontal: 'right'
            }}
            sx={{
               zIndex: 9999,
               "& .MuiPaper-root": {
                  marginTop: '20px',
                  overflow: 'hidden',
                  // backgroundColor: "#e7e9ef",
                  backgroundColor: "#fff",
                  boxShadow: 'rgba(0, 0, 0, 0.1) 0px 6px 12px 0px, rgba(229, 229, 229, 0.01) 0px 0px 0px 1px;',
                  border: '1px #e7e9ef solid'
               }
            }}
         >


            {menuIdentifier === 'postMenu' && [
               <>
               {
                  (pinnedPost === false && currentUser === influencer_name && !isPinnedPost) ?
                     <MenuItem
                        onClick={() => {
                           // handleEditPost(text, menuPostID, menuPostIndex, content_file);
                           handleUpdatePinnedPost(menuPostID, post_index)
                           handleMenuClose();
                        }}
                        sx={{color: 'var(--rebranding-primary-text-color)', fontWeight: '500', fontSize: '14px'}}>{t('community.post.menu.pin')}
                     </MenuItem>
                     :
                     null

               }
               </>,

            <>
               {
                  (pinnedPost === true && currentUser === influencer_name && post_index === 0) ?
                     <MenuItem
                        onClick={() => {
                           // handleEditPost(text, menuPostID, menuPostIndex, content_file);
                           handleRemovePinnedPost(menuPostID, post_index)
                           handleMenuClose();
                        }}
                        sx={{color: 'var(--rebranding-primary-text-color)', fontWeight: '500', fontSize: '14px'}}>{t('community.post.menu.removePin')}
                     </MenuItem>
                     :
                     null

               }
               </>,
                   <MenuItem
                      onClick={() => {
                         handleEditPost(text, menuPostID, menuPostIndex, content_file, tags_list);
                         handleMenuClose();
                      }}
                      sx={{color: 'var(--rebranding-primary-text-color)', fontWeight: '500', fontSize: '14px'}}>{t('community.post.menu.edit')}
                   </MenuItem>,

                  <MenuItem
                     onClick={() => {
                        deletePost(menuPostID, menuPostIndex);
                        handleMenuClose();
                     }}
                     sx={{color: 'var(--rebranding-primary-text-color)', fontWeight: '500', fontSize: '14px'}}>{t('community.post.menu.delete')}
                  </MenuItem>
            ]}

            {menuIdentifier === 'threadMenu' && [

                  <MenuItem
                     onClick={() => {
                        // TODO add Edit Modal
                        handleEditCommentThread(threads[menuThreadIndex].text, threads[menuThreadIndex].id, menuThreadPostIndex, menuThreadIndex, threads[menuThreadIndex].file, threads[menuThreadIndex].content_type, threads[menuThreadIndex].link);
                        handleMenuClose();
                     }}
                     sx={{color: 'var(--rebranding-primary-text-color)', fontWeight: '500', fontSize: '14px'}}>{t('community.post.menu.edit')}
                  </MenuItem>,
                  <MenuItem
                     onClick={() => {
                        deleteThread(menuThreadID, menuThreadPostIndex, menuThreadIndex);
                        handleMenuClose();
                     }}
                     sx={{color: 'var(--rebranding-primary-text-color)', fontWeight: '500', fontSize: '14px'}}>{t('community.post.menu.delete')}
                  </MenuItem>
            ]}

            {menuIdentifier === 'commentMenu' && [

            <MenuItem
               onClick={() => {
                  // TODO add Edit Modal
                  handleEditComment(threads[menuThreadIndex]['comments'][menuCommentIndex].text, menuCommentID, menuThreadPostIndex, menuThreadIndex, menuCommentIndex, threads[menuThreadIndex]['comments'][menuCommentIndex].file, threads[menuThreadIndex]['comments'][menuCommentIndex].content_type, threads[menuThreadIndex]['comments'][menuCommentIndex].link);

                  handleMenuClose();
               }}
               sx={{color: 'var(--rebranding-primary-text-color)', fontWeight: '500', fontSize: '14px'}}>{t('community.post.menu.edit')}
            </MenuItem>,
            <MenuItem
               onClick={() => {
                  deleteComment(menuCommentID, menuThreadPostIndex, menuThreadIndex, menuCommentIndex);
                  handleMenuClose();
               }}
               sx={{color: 'var(--rebranding-primary-text-color)', fontWeight: '500', fontSize: '14px'}}>{t('community.post.menu.delete')}
            </MenuItem>
            ]}


         {/*  Influencer Menus  */}
            {menuIdentifier === 'postMenuInfluencer' && [

               <MenuItem
                  onClick={() => {
                     deletePost(menuPostID, menuPostIndex);
                     handleMenuClose();
                  }}
                  sx={{color: 'var(--rebranding-primary-text-color)', fontWeight: '500', fontSize: '14px'}}>{t('community.post.menu.delete')}
               </MenuItem>
            ]}

            {menuIdentifier === 'threadMenuInfluencer' && [
               <MenuItem
                  onClick={() => {
                     deleteThread(menuThreadID, menuThreadPostIndex, menuThreadIndex);
                     handleMenuClose();
                  }}
                  sx={{color: 'var(--rebranding-primary-text-color)', fontWeight: '500', fontSize: '14px'}}>{t('community.post.menu.delete')}
               </MenuItem>
            ]}

            {menuIdentifier === 'commentMenuInfluencer' && [
               <MenuItem
                  onClick={() => {
                     deleteComment(menuCommentID, menuThreadPostIndex, menuThreadIndex, menuCommentIndex);
                     handleMenuClose();
                  }}
                  sx={{color: 'var(--rebranding-primary-text-color)', fontWeight: '500', fontSize: '14px'}}>{t('community.post.menu.delete')}
               </MenuItem>
            ]}
         </Menu>

         <SnackbarAlert
            msg={snackbarMsg}
            open={snackbarOpen}
            severity={snackbarType}
            backgroundColor={snackbarColor}
            handleClose={() => {
               setSnackbarOpen(false)
            }}
            autoHide={4000}
         />

      </div>
   );
};


export default CommunityPost;